if (window.top === window.self && typeof vxTagBootstrapped === "undefined") {
    vxTagBootstrapped = true;
    window.voxus_tag_loaded = true;
    var VOXUS_DEBUG = false;
    const _vxScriptSrc = document.currentScript?.src ?? "";
    window.onerror = function(message, source, lineno, colno, error) {
        if (message === "Script error.") return true;
        if (_vxScriptSrc && source && source === _vxScriptSrc) {
            if (window.vxLogger) window.vxLogger.report(String(message), {
                stack: error?.stack || "",
                line: lineno,
                col: colno
            });
            if (!VOXUS_DEBUG) return true;
        }
    };
    window.addEventListener("unhandledrejection", function(event) {
        var stack = event.reason && event.reason.stack || "";
        if (_vxScriptSrc && stack.includes(_vxScriptSrc)) {
            if (window.vxLogger) window.vxLogger.report(event.reason?.message || "Unhandled rejection", {
                stack: stack
            });
            if (!VOXUS_DEBUG) event.preventDefault();
        }
    });
    var tagConfig = {
        advInfo: {
            id: "3144",
            campaignId: 2084
        },
        clientDomain: "sallve.com.br",
        clientDomainWl: [ "www.sallve.com.br" ],
        usubidaPages: [],
        igpgs: [],
        sgotasd: [],
        urlsToBloq: [],
        dc: "false",
        tfAdvId: 0,
        tfCpgId: 0,
        tfDsName: "",
        dsName: "",
        tID: "",
        advCtmzs: {
            ds_hit: true,
            ga_hit: true,
            ga4_reset_session: true,
            new_user_reset: true,
            "force-cd-attr": true
        },
        adsWithCustomData: [],
        advWithCustomUtm: {
            utm_source: "voxus_teste",
            utm_medium: "voxus_teste",
            utm_campaign: "voxus_teste",
            utm_content: null,
            utm_term: null,
            custom_params: null
        },
        customData: "{}",
        tagVersion: "20261023_094039",
        tagSemanticVersion: "2.0.19",
        clientName: "Sallve",
        secundaryDimension: 0,
        lookalikeDays: 0,
        rmktDays: 0,
        advCustomTracking: {},
        dspSegmentsMap: [],
        errorReportingEndpoint: "https://logs.voxus.com.br"
    };
    var tagGlobals = {
        usubida_domain: "//api-dsp.voxus.tv",
        subusubidaPages: [ "checkout", "cart", "pedido" ],
        voxus_key: "voxusmediamanager",
        logglyloadvoxus: false,
        lastDataLoggly: null,
        thisip: null,
        getip: null,
        sgarqRun: true,
        dataExcludeValidated: false,
        interPixel: false,
        interConversion: false,
        igvxtst: false,
        igvxgtst: false,
        kopid: false,
        kopiduh: false,
        adinter: false,
        sent_usubida: false,
        sentloggly: false,
        alihuadsa: false,
        alihuadsanw: false,
        fromOther: false,
        converted: false,
        converted_gl: 0,
        retroative: 0,
        cookie_id: null,
        ismobile: false,
        creativekaoq: false,
        sgotasdkaoq: false,
        kopidCooked: false,
        totalSes: 0,
        isicgt: false,
        alcc: null,
        alsd: "cpl",
        alcs: "voxusmediamanager",
        alcm: "cpl",
        alcn: "voxus",
        isChrome: false,
        kiphouYiasO: [],
        alvx2: null,
        alvx1: null,
        alvx3: null,
        lswf: false,
        wppTriggered: false,
        appointmentTriggered: false,
        trackedElements: {},
        observerController: {
            observers: {},
            observedDomains: {},
            observedRequests: {}
        },
        indexNckVersion: "1.0.10",
        fromOtherv2: false,
        vxAttrStatus: {
            gaNotSent: null,
            recentConv: false
        },
        analyticsAttributionHitsSentOnPage: {
            ga: false,
            ds: false,
            tfDs: false
        },
        tfAdvSeen: false,
        noNewUserResetReason: null,
        resetHitCollectHost: null
    };
    Object.assign(window, tagConfig, tagGlobals);
    var __defProp = Object.defineProperty;
    var __typeError = msg => {
        throw TypeError(msg);
    };
    var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
    var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
    var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), 
    getter ? getter.call(obj) : member.get(obj));
    var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
    var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), 
    setter ? setter.call(obj, value) : member.set(obj, value), value);
    var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), 
    method);
    (function() {
        "use strict";
        var _VxDomainAllowlist_static, matchesClientDomain_fn, matchesAllowList_fn, _storage, _a, _b, _messageListenerAttached, _VxCrossDomainBridge_static, buildIframeUrl_fn, onMessage_fn, handleDataExclude_fn, handleUser_fn, _VxPixelReloader_static, fireAdvertiserPixels_fn, getPixelsDataForDsp_fn, isOnBottomFunnelPage_fn, splitBySegmentType_fn, executeAddPixelsForDsp_fn, trackConversionPages_fn, _VxSecondaryDimensionChecker_static, filterValidCampaigns_fn, getCustomDimensionRtgAttributionDays_fn, getTopFunnelLiftCampaigns_fn, _VxCookieStateLoader_static, loadCookieId_fn, loadTestingFlag_fn, loadConvertedFlag_fn, loadAdSeenState_fn, loadAdClickState_fn, loadIgnoreFullGa_fn, handleTestingQueryParam_fn, loadIgnoreCookie_fn, _c, _cachedNativePromise, _VxNativePromise_static, extractNativePromiseFromIframe_fn;
        class VxDomainAllowlist {
            static isAllowedDomain() {
                const allowList = window.clientDomainWl;
                if (allowList.length === 0) {
                    return __privateMethod(this, _VxDomainAllowlist_static, matchesClientDomain_fn).call(this);
                }
                return __privateMethod(this, _VxDomainAllowlist_static, matchesAllowList_fn).call(this, allowList);
            }
        }
        _VxDomainAllowlist_static = new WeakSet;
        matchesClientDomain_fn = function() {
            const clientDomain = window.clientDomain.replace("www.", "");
            return window.location.href.toLowerCase().indexOf(clientDomain.toLowerCase()) !== -1;
        };
        matchesAllowList_fn = function(allowList) {
            const pageHostname = window.location.hostname.toLowerCase().replace("www.", "");
            return allowList.some(domain => pageHostname === domain.toLowerCase().replace("www.", ""));
        };
        __privateAdd(VxDomainAllowlist, _VxDomainAllowlist_static);
        const _VxLogTransport = class _VxLogTransport {
            static getEndpoint() {
                var _a2;
                return ((_a2 = window.tagConfig) == null ? void 0 : _a2.errorReportingEndpoint) || "";
            }
            static send(level, message, context) {
                var _a2;
                const endpoint = this.getEndpoint();
                if (!endpoint) return;
                if (!VxDomainAllowlist.isAllowedDomain()) return;
                const key = `${window.advInfo.id}:${level}:${message}`;
                if (this.reported.has(key)) return;
                this.reported.add(key);
                const payload = JSON.stringify({
                    advertiser_id: window.advInfo.id || "unknown",
                    cookie_id: window.cookie_id || "unknown",
                    is_mobile: window.ismobile ?? "unknown",
                    user_agent: navigator.userAgent || "unknown",
                    tag_version: ((_a2 = window.tagConfig) == null ? void 0 : _a2.tagVersion) || "unknown",
                    level: level,
                    error: message,
                    url: window.location.href,
                    ...context
                });
                fetch(endpoint, {
                    method: "POST",
                    credentials: "omit",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: payload
                }).catch(() => {});
            }
        };
        _VxLogTransport.reported = new Set;
        let VxLogTransport = _VxLogTransport;
        class VxLogger {
            constructor(debugEnabled = false) {
                this.debugEnabled = debugEnabled;
            }
            debug(...args) {
                if (this.debugEnabled) {
                    console.debug(...args);
                }
            }
            trace(...args) {
                if (this.debugEnabled) {
                    console.trace(...args);
                }
            }
            report(message, context) {
                if (this.debugEnabled) {
                    console.debug(message, context);
                    return;
                }
                VxLogTransport.send("error", message, context);
            }
            info(message, context) {
                if (this.debugEnabled) {
                    console.info(message, context);
                    return;
                }
                VxLogTransport.send("info", message, context);
            }
        }
        let VxAsyncWrapper$1 = class VxAsyncWrapper2 {
            static setTimeout(callback, delay, ...args) {
                return window.setTimeout(() => {
                    try {
                        callback == null ? void 0 : callback(...args);
                    } catch (error) {
                        VxAsyncWrapper2.logError("setTimeout", error);
                    }
                }, delay);
            }
            static setInterval(callback, delay, ...args) {
                return window.setInterval(() => {
                    try {
                        callback == null ? void 0 : callback(...args);
                    } catch (error) {
                        VxAsyncWrapper2.logError("setInterval", error);
                    }
                }, delay);
            }
            static sleep(delay) {
                return new Promise(resolve => {
                    VxAsyncWrapper2.setTimeout(resolve, delay);
                });
            }
            static logError(context, error) {
                var _a2, _b2, _c2, _d;
                (_b2 = (_a2 = window.vxLogger) == null ? void 0 : _a2.debug) == null ? void 0 : _b2.call(_a2, `Error in \`${context}\` for advertiser:`, window.advInfo.id, error);
                (_d = (_c2 = window.vxLogger) == null ? void 0 : _c2.trace) == null ? void 0 : _d.call(_c2, error.stack);
            }
        };
        class VxDate {
            static addMinutes(date, minutes) {
                return new Date(date.getTime() + minutes * 60 * 1e3);
            }
            static addDays(date, days) {
                return new Date(date.getTime() + days * 24 * 60 * 60 * 1e3);
            }
            static addHours(date, hours) {
                return new Date(date.getTime() + hours * 60 * 60 * 1e3);
            }
            static minutesSinceTimestamp(earlierTimestamp) {
                return Math.floor((Math.floor(Date.now() / 1e3) - earlierTimestamp) / 60);
            }
            static normalizeTimestampInSeconds(timestamp) {
                const num = Number(timestamp);
                if (!Number.isFinite(num)) return null;
                const MS_THRESHOLD = 1e12;
                if (num > MS_THRESHOLD) {
                    return Math.floor(num / 1e3);
                }
                return num;
            }
        }
        class VxPageCache {
            constructor() {
                __privateAdd(this, _storage, {});
            }
            hasChangedPageByKey(key) {
                const slot = this.getOrCreateStorageByKey(key);
                const current = window.location.href;
                if (slot.lastUrl !== current) {
                    slot.lastUrl = current;
                    slot.data = null;
                    return true;
                }
                return false;
            }
            getCacheData(key) {
                return this.getOrCreateStorageByKey(key).data;
            }
            setCacheData(key, value) {
                this.getOrCreateStorageByKey(key).data = value;
            }
            clear() {
                __privateSet(this, _storage, {});
            }
            getOrCreateStorageByKey(key) {
                if (!__privateGet(this, _storage)[key]) {
                    __privateGet(this, _storage)[key] = {
                        lastUrl: null,
                        data: void 0
                    };
                }
                return __privateGet(this, _storage)[key];
            }
        }
        _storage = new WeakMap;
        let CookiesVx$1 = (_a = class {
            static safeReadCookie() {
                try {
                    return document.cookie;
                } catch {
                    return null;
                }
            }
            static safeWriteCookie(cookieString) {
                try {
                    document.cookie = cookieString;
                } catch {}
            }
            static getRegistrableDomain() {
                if (_a.cachedRegistrableDomain === null) {
                    _a.cachedRegistrableDomain = _a.detectRegistrableDomain();
                }
                return _a.cachedRegistrableDomain;
            }
            static detectRegistrableDomain() {
                let i = 0;
                let domain = document.domain;
                const parts = domain.split(".");
                const probeKey = "_gd" + Date.now();
                const probeMatch = probeKey + "=" + probeKey;
                while (i < parts.length - 1 && (_a.safeReadCookie() ?? "").indexOf(probeMatch) === -1) {
                    i++;
                    domain = parts.slice(-1 - i).join(".");
                    _a.safeWriteCookie(probeKey + "=" + probeKey + ";domain=" + domain + ";");
                }
                _a.safeWriteCookie(probeKey + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + domain + ";");
                return domain;
            }
            static get(key) {
                const currentCookie = _a.safeReadCookie();
                if (currentCookie === null) return void 0;
                if (_a.cachedDocumentCookie !== currentCookie) {
                    _a.renewCache(currentCookie);
                }
                const value = _a.cache[_a.CACHE_KEY_PREFIX + key];
                return value === void 0 ? void 0 : decodeURIComponent(value);
            }
            static set(key, value, options) {
                const opts = _a.getExtendedOptions(options);
                opts.expires = _a.getExpiresDate(value === void 0 ? -1 : opts.expires);
                _a.safeWriteCookie(_a.generateCookieString(key, value, opts));
            }
            static expire(key, options) {
                _a.set(key, void 0, options);
            }
            static isEnabled() {
                const testKey = "cookies.js.test";
                _a.set(testKey, "1");
                const enabled = _a.get(testKey) === "1";
                _a.expire(testKey);
                return enabled;
            }
            static getExtendedOptions(options) {
                const defaults = _a.defaults;
                const newOptions = {
                    path: (options == null ? void 0 : options.path) || defaults.path,
                    domain: (options == null ? void 0 : options.domain) || "." + _a.getRegistrableDomain(),
                    expires: (options == null ? void 0 : options.expires) || defaults.expires,
                    secure: (options == null ? void 0 : options.secure) !== void 0 ? options.secure : defaults.secure,
                    samesite: (options == null ? void 0 : options.samesite) !== void 0 ? options.samesite : defaults.samesite
                };
                if ((options == null ? void 0 : options.domain) === "") {
                    newOptions.domain = options.domain;
                }
                return newOptions;
            }
            static isValidDate(date) {
                return Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime());
            }
            static getExpiresDate(expires, now) {
                now = now || new Date;
                if (typeof expires === "number") {
                    expires = expires === Infinity ? _a.MAX_EXPIRE_DATE : new Date(now.getTime() + expires * 1e3);
                } else if (typeof expires === "string") {
                    expires = new Date(expires);
                }
                if (expires && !_a.isValidDate(expires)) {
                    throw new Error("`expires` parameter cannot be converted to a valid Date instance");
                }
                return expires;
            }
            static generateCookieString(key, value, options) {
                key = key.replace(/[^#$&+^`|]/g, encodeURIComponent);
                key = key.replace(/\(/g, "%28").replace(/\)/g, "%29");
                value = (value + "").replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
                let cookieString = key + "=" + value;
                cookieString += options.path ? ";path=" + options.path : "";
                cookieString += options.domain ? ";domain=" + options.domain : "";
                cookieString += options.expires ? ";expires=" + options.expires.toUTCString() : "";
                cookieString += options.secure ? ";secure" : "";
                if (_a.shouldSendSameSiteNone(navigator.userAgent)) {
                    cookieString += ";SameSite=" + options.samesite;
                }
                return cookieString;
            }
            static shouldSendSameSiteNone(useragent) {
                return !_a.isSameSiteNoneIncompatible(useragent);
            }
            static isSameSiteNoneIncompatible(useragent) {
                return _a.hasWebKitSameSiteBug(useragent) || _a.dropsUnrecognizedSameSiteCookies(useragent);
            }
            static hasWebKitSameSiteBug(useragent) {
                return _a.isIosVersion(12, useragent) || _a.isMacosxVersion(10, 14, useragent) && (_a.isSafari(useragent) || _a.isMacEmbeddedBrowser(useragent));
            }
            static dropsUnrecognizedSameSiteCookies(useragent) {
                if (_a.isUcBrowser(useragent)) {
                    return !_a.isUcBrowserVersionAtLeast(12, 13, 2, useragent);
                }
                return _a.isChromiumBased(useragent) && _a.isChromiumVersionAtLeast(51, useragent) && !_a.isChromiumVersionAtLeast(67, useragent);
            }
            static isIosVersion(major, useragent) {
                const regex = /\(iP.+; CPU .*OS (\d+)[_\d]*.*\) AppleWebKit\//;
                const match = regex.exec(useragent);
                return match !== null && parseInt(match[1], 10) === major;
            }
            static isMacosxVersion(major, minor, useragent) {
                const regex = /\(Macintosh;.*Mac OS X (\d+)_(\d+)[_\d]*.*\) AppleWebKit\//;
                const match = regex.exec(useragent);
                return match !== null && parseInt(match[1], 10) === major && parseInt(match[2], 10) === minor;
            }
            static isSafari(useragent) {
                const safari_regex = /Version\/.* Safari\//g;
                return safari_regex.test(useragent) && !_a.isChromiumBased(useragent);
            }
            static isMacEmbeddedBrowser(useragent) {
                const regex = /^Mozilla\/[.\d]+ \(Macintosh;.*Mac OS X [_\d]+\) AppleWebKit\/[.\d]+ \(KHTML, like Gecko\)$/g;
                return regex.test(useragent);
            }
            static isChromiumBased(useragent) {
                const regex = /Chrom(e|ium)/g;
                return regex.test(useragent);
            }
            static isChromiumVersionAtLeast(major, useragent) {
                const regex = /Chrom[^ \/]+\/(\d+)[.\d]* /;
                const match = regex.exec(useragent);
                return match !== null && parseInt(match[1], 10) >= major;
            }
            static isUcBrowser(useragent) {
                const regex = /UCBrowser\//g;
                return regex.test(useragent);
            }
            static isUcBrowserVersionAtLeast(major, minor, build, useragent) {
                const regex = /UCBrowser\/(\d+)\.(\d+)\.(\d+)[.\d]* /;
                const match = regex.exec(useragent);
                if (!match) return false;
                const major_version = parseInt(match[1], 10);
                const minor_version = parseInt(match[2], 10);
                const build_version = parseInt(match[3], 10);
                if (major_version !== major) return major_version > major;
                if (minor_version !== minor) return minor_version > minor;
                return build_version >= build;
            }
            static renewCache(currentCookie) {
                const cookie = currentCookie ?? _a.safeReadCookie();
                if (cookie === null) return;
                _a.cache = _a.getCacheFromString(cookie);
                _a.cachedDocumentCookie = cookie;
            }
            static getCacheFromString(documentCookie) {
                const cookieCache = {};
                const cookiesArray = documentCookie ? documentCookie.split("; ") : [];
                for (let i = 0; i < cookiesArray.length; i++) {
                    const kvp = _a.getKeyValuePairFromCookieString(cookiesArray[i]);
                    if (cookieCache[_a.CACHE_KEY_PREFIX + kvp.key] === void 0) {
                        cookieCache[_a.CACHE_KEY_PREFIX + kvp.key] = kvp.value;
                    }
                }
                return cookieCache;
            }
            static getKeyValuePairFromCookieString(cookieString) {
                let separatorIndex = cookieString.indexOf("=");
                separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;
                const key = cookieString.substring(0, separatorIndex);
                let decodedKey = key;
                try {
                    decodedKey = decodeURIComponent(key);
                } catch {}
                return {
                    key: decodedKey,
                    value: cookieString.substring(separatorIndex + 1)
                };
            }
        }, _a.CACHE_KEY_PREFIX = "cookey.", _a.MAX_EXPIRE_DATE = new Date("Fri, 31 Dec 9999 23:59:59 UTC"), 
        _a.cache = {}, _a.cachedDocumentCookie = "", _a.cachedRegistrableDomain = null, 
        _a.defaults = {
            path: "/",
            secure: true,
            samesite: "None"
        }, _a);
        const _VxFingerprint = class _VxFingerprint {
            static generateUuid() {
                const existing = CookiesVx$1.get(_VxFingerprint.COOKIE_KEY);
                const ip = CookiesVx$1.get(`${window.voxus_key}_ip`);
                const shouldAppendIp = Boolean(ip) && !(existing == null ? void 0 : existing.includes("_"));
                if (existing && !shouldAppendIp) return existing;
                const uuid = existing ?? _VxFingerprint.generateUuidV7();
                const id = ip ? `${uuid}_${ip}` : uuid;
                CookiesVx$1.set(_VxFingerprint.COOKIE_KEY, id, {
                    expires: Infinity
                });
                return id;
            }
            static generateUuidV7() {
                const bytes = new Uint8Array(16);
                crypto.getRandomValues(bytes);
                const timestamp = Date.now();
                bytes[0] = timestamp / 2 ** 40 & 255;
                bytes[1] = timestamp / 2 ** 32 & 255;
                bytes[2] = timestamp / 2 ** 24 & 255;
                bytes[3] = timestamp / 2 ** 16 & 255;
                bytes[4] = timestamp / 2 ** 8 & 255;
                bytes[5] = timestamp & 255;
                bytes[6] = bytes[6] & 15 | 112;
                bytes[8] = bytes[8] & 63 | 128;
                const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
                return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
            }
        };
        _VxFingerprint.COOKIE_KEY = "vx_fid";
        let VxFingerprint = _VxFingerprint;
        function hasCustomization$1(customizationType) {
            const advCtmzs = window.advCtmzs;
            return (advCtmzs == null ? void 0 : advCtmzs[customizationType]) === true;
        }
        class VxPlatformAttr {
            static async sendHit(params) {
                if (!this.canRun()) return;
                await this.doSendHit(params);
            }
            static canRun() {
                throw new Error("canRun must be implemented");
            }
            static doSendHit(_params) {
                throw new Error("doSendHit must be implemented");
            }
        }
        const _VxAdobeAttr = class _VxAdobeAttr extends VxPlatformAttr {
            static canRun() {
                return hasCustomization$1("adobe_hit") && this.hasAlloy();
            }
            static doSendHit(params) {
                const utmString = `:${params.medium}:${params.source}:${params.name}:`;
                const url = new URL(window.location.href);
                url.searchParams.set("utm_campaign", params.name);
                url.searchParams.set("utm_source", params.source);
                url.searchParams.set("utm_medium", params.medium);
                if (params.jumpid) {
                    url.searchParams.set("jumpid", params.jumpid);
                }
                alloy("sendEvent", {
                    xdm: {
                        web: {
                            webPageDetails: {
                                URL: url.toString(),
                                pageViews: {
                                    value: 1
                                }
                            }
                        },
                        _experience: {
                            analytics: {
                                customDimensions: {
                                    eVars: {
                                        [this.ADOBE_PAGE_PARAM2]: url.toString(),
                                        [this.ADOBE_UTM_PARAM]: utmString,
                                        [this.ADOBE_JUMP_PARAM]: params.jumpid,
                                        props: {
                                            prop40: "pageView"
                                        }
                                    }
                                }
                            }
                        },
                        documentUnloading: true,
                        eventType: "web.webpagedetails.pageViews"
                    }
                });
            }
            static hasAlloy() {
                return typeof alloy === "function";
            }
        };
        _VxAdobeAttr.ADOBE_PAGE_PARAM2 = "eVar90";
        _VxAdobeAttr.ADOBE_UTM_PARAM = "eVar14";
        _VxAdobeAttr.ADOBE_JUMP_PARAM = "eVar15";
        let VxAdobeAttr = _VxAdobeAttr;
        class VxLocalStorageManager {
            static getItem(key) {
                var _a2;
                try {
                    return ((_a2 = window.localStorage) == null ? void 0 : _a2.getItem(key)) ?? null;
                } catch {
                    return null;
                }
            }
            static setItem(key, value) {
                var _a2;
                try {
                    (_a2 = window.localStorage) == null ? void 0 : _a2.setItem(key, value);
                } catch {}
            }
            static removeItem(key) {
                var _a2;
                try {
                    (_a2 = window.localStorage) == null ? void 0 : _a2.removeItem(key);
                } catch {}
            }
        }
        class VxNemuAttr extends VxPlatformAttr {
            static canRun() {
                return hasCustomization$1("nemu_hit") && this.hasNemu();
            }
            static doSendHit(params) {
                const searchParams = new URLSearchParams;
                searchParams.append("utm_campaign", params.name);
                searchParams.append("utm_source", params.source);
                searchParams.append("utm_medium", params.medium);
                window.trackingNemu.nemuUtms = searchParams;
                CookiesVx$1.set("nemuUtmsTrack", searchParams.toString(), {
                    domain: "",
                    secure: true,
                    samesite: "Lax",
                    expires: VxDate.addMinutes(new Date, 30)
                });
                VxLocalStorageManager.setItem("nemu:utmsTrack", searchParams.toString());
            }
            static hasNemu() {
                return !!window.trackingNemu;
            }
        }
        class VxPlausibleAttr extends VxPlatformAttr {
            static canRun() {
                return this.hasPlausible();
            }
            static doSendHit(params) {
                const url = new URL(window.location.href);
                url.searchParams.set("utm_campaign", params.name);
                url.searchParams.set("utm_medium", params.medium);
                url.searchParams.set("utm_source", params.source);
                plausible("pageview", {
                    url: url.toString()
                });
            }
            static hasPlausible() {
                return typeof plausible === "function";
            }
        }
        class VxVtexAttr extends VxPlatformAttr {
            static getSessionCookie() {
                if (typeof CookiesVx$1 === "undefined") return null;
                return CookiesVx$1.get("VtexRCSessionIdv7") || null;
            }
            static getConversionId() {
                var _a2;
                const url = new URL(window.location.href);
                const isOrderPlaced = url.pathname.includes("orderPlaced");
                const isCheckoutOrder = url.pathname.includes("checkout/order/");
                if (isOrderPlaced) {
                    return url.searchParams.get("og");
                }
                if (isCheckoutOrder) {
                    const og = (_a2 = url.pathname.split("/")) == null ? void 0 : _a2.at(-1);
                    return og ? og : null;
                }
                return;
            }
            static isCheckoutV6() {
                const {pathname: pathname, hash: hash} = window.location;
                return pathname.includes("cart") || hash.startsWith("#/cart");
            }
            static isOnCheckout() {
                return this.isCheckoutV6() || this.isVtexOldCheckout() && window.location.pathname.includes("checkout");
            }
            static async cleanCheckout(message = "vtex_clean") {
                var _a2, _b2, _c2, _d, _e;
                if (this.isCheckoutV6()) {
                    await this.cleanCheckoutV6(message);
                    return;
                }
                if (!this.isVtexOldCheckout()) return;
                const form = await ((_a2 = vtexjs == null ? void 0 : vtexjs.checkout) == null ? void 0 : _a2.getOrderForm());
                const marketingData = form == null ? void 0 : form.marketingData;
                if (!((_b2 = marketingData == null ? void 0 : marketingData.utmSource) == null ? void 0 : _b2.includes("voxus"))) return;
                marketingData.utmSource = "";
                marketingData.utmMedium = "";
                marketingData.utmCampaign = "";
                await ((_c2 = vtexjs == null ? void 0 : vtexjs.checkout) == null ? void 0 : _c2.sendAttachment("marketingData", marketingData));
                sendToLoggly({
                    type: message,
                    pageview: window.location.href,
                    marketingDataBefore: marketingData,
                    marketingDataAfter: (_e = await ((_d = vtexjs == null ? void 0 : vtexjs.checkout) == null ? void 0 : _d.getOrderForm())) == null ? void 0 : _e.marketingData
                });
            }
            static async cleanCheckoutV6(message) {
                var _a2, _b2, _c2, _d, _e;
                try {
                    const response = await fetch("/api/checkout/pub/orderForm");
                    if (!response.ok) return;
                    const form = await response.json();
                    const orderFormId = form.orderFormId;
                    if (!orderFormId) return;
                    const marketingData = form.marketingData ?? {};
                    if (!((_a2 = marketingData == null ? void 0 : marketingData.utmSource) == null ? void 0 : _a2.includes("voxus"))) return;
                    const marketingDataBefore = {
                        ...marketingData
                    };
                    await fetch(`/api/checkout/pub/orderForm/${orderFormId}/attachments/marketingData`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            utmSource: "",
                            utmMedium: "",
                            utmCampaign: ""
                        })
                    });
                    sendToLoggly({
                        type: message,
                        pageview: window.location.href,
                        marketingDataBefore: marketingDataBefore,
                        marketingDataAfter: {
                            ...marketingData,
                            utmSource: "",
                            utmMedium: "",
                            utmCampaign: ""
                        }
                    });
                } catch (e) {
                    (_c2 = (_b2 = window.vxLogger) == null ? void 0 : _b2.debug) == null ? void 0 : _c2.call(_b2, "Error in `VxVtexAttr.cleanCheckoutV6` for advertiser: ", window.advInfo.id, e);
                    (_e = (_d = window.vxLogger) == null ? void 0 : _d.trace) == null ? void 0 : _e.call(_d, e.stack);
                }
            }
            static onVtexCheckout(callback) {
                if (this.isCheckoutV6()) {
                    callback();
                    return;
                }
                if (!this.isOnCheckout()) return;
                if (this.isVtexOldCheckout()) {
                    callback();
                    return;
                }
                const observer = new MutationObserver(() => {
                    if (this.isVtexOldCheckout()) {
                        observer.disconnect();
                        callback();
                    }
                });
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
                const interval = setInterval(() => {
                    if (this.isVtexOldCheckout()) {
                        clearInterval(interval);
                        callback();
                    }
                }, 300);
            }
            static canRun() {
                return this.isVtexStore();
            }
            static async doSendHit(params) {
                if (this.isOnCheckout()) {
                    await this.sendUtmsToCheckout(params);
                }
                await this.sendUtmsToSession(params);
            }
            static isVtexStore() {
                return !!CookiesVx$1.get("VtexRCSessionIdv7");
            }
            static isVtexOldCheckout() {
                return typeof vtexjs !== "undefined";
            }
            static async getOrderForm() {
                var _a2, _b2, _c2, _d;
                try {
                    const response = await fetch("/api/checkout/pub/orderForm");
                    if (!response.ok) return null;
                    return await response.json();
                } catch (e) {
                    (_b2 = (_a2 = window.vxLogger) == null ? void 0 : _a2.debug) == null ? void 0 : _b2.call(_a2, "Error in `VxVtexAttr.getOrderForm` for advertiser: ", window.advInfo.id, e);
                    (_d = (_c2 = window.vxLogger) == null ? void 0 : _c2.trace) == null ? void 0 : _d.call(_c2, e.stack);
                    return null;
                }
            }
            static async sendUtmsToCheckout(utms) {
                try {
                    if (this.isCheckoutV6()) {
                        await this.sendUtmsToCheckoutV6(utms);
                    } else {
                        await this.sendUtmsToCheckoutWithVtexjs(utms);
                    }
                    return true;
                } catch {
                    return false;
                }
            }
            static async sendUtmsToCheckoutWithVtexjs(utms) {
                var _a2, _b2;
                const form = await ((_a2 = vtexjs == null ? void 0 : vtexjs.checkout) == null ? void 0 : _a2.getOrderForm());
                if (!form) return;
                const currentMarketingData = form.marketingData || {};
                const marketingData = {
                    ...currentMarketingData,
                    utmSource: utms.source,
                    utmMedium: utms.medium,
                    utmCampaign: utms.name
                };
                await ((_b2 = vtexjs == null ? void 0 : vtexjs.checkout) == null ? void 0 : _b2.sendAttachment("marketingData", marketingData));
                return true;
            }
            static async sendUtmsToCheckoutV6(utms) {
                var _a2, _b2, _c2, _d, _e;
                try {
                    const form = await this.getOrderForm();
                    const orderFormId = form == null ? void 0 : form.orderFormId;
                    if (!orderFormId) return;
                    const marketingData = {
                        ...form == null ? void 0 : form.marketingData,
                        utmSource: utms.source,
                        utmMedium: utms.medium,
                        utmCampaign: utms.name
                    };
                    const response = await fetch(`/api/checkout/pub/orderForm/${orderFormId}/attachments/marketingData`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(marketingData)
                    });
                    sendToLoggly({
                        type: "vtex_hit",
                        pageview: window.location.href,
                        status: response.status,
                        data: response.ok ? (_a2 = await response.json()) == null ? void 0 : _a2.marketingData : null
                    });
                    return true;
                } catch (e) {
                    (_c2 = (_b2 = window.vxLogger) == null ? void 0 : _b2.debug) == null ? void 0 : _c2.call(_b2, "Error in `VxVtexAttr.sendUtmsToCheckoutV6` for advertiser: ", window.advInfo.id, e);
                    (_e = (_d = window.vxLogger) == null ? void 0 : _d.trace) == null ? void 0 : _e.call(_d, e.stack);
                    throw e;
                }
            }
            static async sendUtmsToSession(params) {
                var _a2, _b2, _c2, _d;
                try {
                    await fetch("/api/sessions", {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            public: {
                                utm_campaign: {
                                    value: params.name
                                },
                                utm_medium: {
                                    value: params.medium
                                },
                                utm_source: {
                                    value: params.source
                                }
                            }
                        })
                    });
                } catch (e) {
                    (_b2 = (_a2 = window.vxLogger) == null ? void 0 : _a2.debug) == null ? void 0 : _b2.call(_a2, "Error in `VxVtexAttr.sendUtmsToSession` for advertiser: ", window.advInfo.id, e);
                    (_d = (_c2 = window.vxLogger) == null ? void 0 : _c2.trace) == null ? void 0 : _d.call(_c2, e.stack);
                }
            }
        }
        class VxVtexIOAttr extends VxPlatformAttr {
            static canRun() {
                return this.isAvailable();
            }
            static doSendHit(params) {
                var _a2;
                const url = new URL("/", window.location.origin);
                url.searchParams.set("utm_source", params.source);
                url.searchParams.set("utm_medium", params.medium);
                url.searchParams.set("utm_campaign", params.name);
                const locationWithUtms = url.toString();
                this.overwriteAnalyticsSession(locationWithUtms, params.source);
                (_a2 = window.dataLayer) == null ? void 0 : _a2.push({
                    originalLocation: locationWithUtms
                });
            }
            static isAvailable() {
                return VxLocalStorageManager.getItem("analytics:session") !== null;
            }
            static overwriteAnalyticsSession(locationWithVoxusUtm, utmSource) {
                if (!this.isAvailable()) return;
                let currentCache = VxLocalStorageManager.getItem("analytics:session");
                const alreadyHasVoxus = currentCache.indexOf("utm_source=" + utmSource) !== -1;
                if (alreadyHasVoxus) return;
                const parsedCache = JSON.parse(currentCache);
                parsedCache.location = locationWithVoxusUtm;
                VxLocalStorageManager.setItem("analytics:session", JSON.stringify(parsedCache));
            }
        }
        const _VxRdstationCookieBased = class _VxRdstationCookieBased extends VxPlatformAttr {
            static canRun() {
                if (!hasCustomization$1("rdstation_cookie_hit")) return false;
                return this.isOnMatchingPage() || this.isOnHomepage();
            }
            static doSendHit(params) {
                if (this.isOnMatchingPage()) {
                    this.writeCookie(params, window.location.pathname);
                }
                if (this.isOnHomepage()) {
                    this.watchForSubmitButton(params);
                }
            }
            static writeCookie(params, convertedPage) {
                var _a2, _b2;
                const measurementId = (_a2 = window.getMeasurementIds()) == null ? void 0 : _a2[0];
                if (!measurementId) {
                    return;
                }
                const ga4SessionId = measurementId ? ((_b2 = getGaSessionCookieData(measurementId)) == null ? void 0 : _b2.sessionId) ?? null : null;
                const payload = {
                    name: params.name,
                    source: params.source,
                    medium: params.medium,
                    ga4_session_id: ga4SessionId,
                    converted_page: convertedPage
                };
                sendToLoggly({
                    type: "rdstation-hit",
                    pageview: window.location.href,
                    data: payload
                });
                CookiesVx$1.set(this.COOKIE_NAME, JSON.stringify(payload), {
                    samesite: "Lax"
                });
            }
            static watchForSubmitButton(params) {
                const existing = document.querySelector(this.SUBMIT_BUTTON_SELECTOR);
                if (existing) {
                    this.attachSubmitListener(existing, params);
                    return;
                }
                const observer = new MutationObserver((_mutations, obs) => {
                    const btn = document.querySelector(this.SUBMIT_BUTTON_SELECTOR);
                    if (btn) {
                        obs.disconnect();
                        this.attachSubmitListener(btn, params);
                    }
                });
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            }
            static attachSubmitListener(btn, params) {
                btn.addEventListener("inter", () => {
                    this.writeCookie(params, window.location.pathname);
                }, {
                    once: true
                });
            }
            static isOnMatchingPage() {
                return this.PAGES.includes(window.location.pathname);
            }
            static isOnHomepage() {
                return window.location.pathname === "/";
            }
        };
        _VxRdstationCookieBased.COOKIE_NAME = "voxus_rdstation_attr";
        _VxRdstationCookieBased.SUBMIT_BUTTON_SELECTOR = "#submitBtn";
        _VxRdstationCookieBased.PAGES = [ "/signup" ];
        let VxRdstationCookieBased = _VxRdstationCookieBased;
        let UtmParamsHandler$1 = class UtmParamsHandler2 {
            static getDefaultVxSourceParameters() {
                return [ window.alcs, "voxus" ];
            }
            static getDefaultVxCampaign() {
                var _a2, _b2, _c2, _d;
                if ((_a2 = window.advWithCustomUtm) == null ? void 0 : _a2["utm_campaign"]) {
                    return window.advWithCustomUtm["utm_campaign"];
                }
                const campaignId = ((_b2 = window.advInfo) == null ? void 0 : _b2.campaignId) ?? ((_d = (_c2 = window.sgotasd) == null ? void 0 : _c2[0]) == null ? void 0 : _d[1]);
                if (campaignId) {
                    return `campaign_${window.advInfo.id}_${campaignId}`;
                }
                return "campaign_vx";
            }
            static getUtmParametersToSend(alcs2, alcm2, alcn2) {
                let customUtm = UtmParamsHandler2._getAdvertiserCustomGlobalUtm(alcs2, alcn2, alcm2);
                alcs2 = customUtm.source;
                alcn2 = customUtm.campaign;
                alcm2 = customUtm.medium;
                if (typeof window.associatedAdvData !== "undefined" && window.associatedAdvData !== null) {
                    customUtm = UtmParamsHandler2._getCustomUtmFromAssociatedAdvertisers(window.associatedAdvData, alcs2, alcn2, alcm2);
                    alcs2 = customUtm.source;
                    alcn2 = customUtm.campaign;
                    alcm2 = customUtm.medium;
                }
                if (window.hasCustomization("unify-tf-core-attribution") && window.tfAdvSeen) {
                    alcs2 = "voxusTopo";
                    alcm2 = "cpm";
                }
                const additionalCustomParameters = {};
                const customParams = window.advWithCustomUtm["custom_params"];
                if (customParams && Object.keys(customParams).length > 0) {
                    for (const [key, value] of Object.entries(customParams)) {
                        additionalCustomParameters[key] = value;
                    }
                }
                const lastAdSeen = window.VxImpHandler.getCookieLastAdSeenInformation().creative;
                const adCustomData = window.adsWithCustomData[lastAdSeen];
                const hasAdCustomData = lastAdSeen !== "" && typeof adCustomData !== "undefined";
                return {
                    source: hasAdCustomData && adCustomData.source != "" ? adCustomData.source : alcs2,
                    medium: hasAdCustomData && adCustomData.medium != "" ? adCustomData.medium : alcm2,
                    name: hasAdCustomData && adCustomData.name != "" ? adCustomData.name : alcn2,
                    content: hasAdCustomData ? adCustomData.content : customUtm.content,
                    term: hasAdCustomData ? adCustomData.term : customUtm.term,
                    id: lastAdSeen !== "" ? lastAdSeen : "",
                    ...additionalCustomParameters
                };
            }
            static _getAdvertiserCustomGlobalUtm(alcs2, alcn2, alcm2) {
                const response = {
                    source: alcs2,
                    campaign: alcn2,
                    medium: alcm2,
                    content: "",
                    term: ""
                };
                const advWithCustomUtm = window.advWithCustomUtm;
                if (Object.keys(advWithCustomUtm).length > 0) {
                    response.source = advWithCustomUtm["utm_source"];
                    response.campaign = advWithCustomUtm["utm_campaign"];
                    response.medium = advWithCustomUtm["utm_medium"];
                    response.content = advWithCustomUtm["utm_content"];
                    response.term = advWithCustomUtm["utm_term"];
                }
                return response;
            }
            static _getCustomUtmFromAssociatedAdvertisers(associatedAdvData, originalSource, originalCampaign, originalMedium) {
                const response = {
                    source: originalSource,
                    campaign: originalCampaign,
                    medium: originalMedium
                };
                if (typeof associatedAdvData === "undefined") {
                    return response;
                }
                Object.values(associatedAdvData).forEach(({kaoq: kaoq, source: source, campaign: campaign, medium: medium}) => {
                    if (kaoq === true) {
                        if (typeof source !== "undefined") {
                            response.source = source;
                        }
                        if (typeof campaign !== "undefined") {
                            response.campaign = campaign;
                        }
                        if (typeof medium !== "undefined") {
                            response.medium = medium;
                        }
                    }
                });
                return response;
            }
        };
        const EXTERNAL_MEDIA_PARAM_FRAGMENTS = [ "fbclid", "gclid", "wbraid", "gbraid", "source", "partner", "parceiro", "origem", "affiliate", "afiliado" ];
        const IGNORED_EXACT_PARAMS = new Set([ "source" ]);
        class VxAttrOnClickUtmHandler {
            static identifyPaidMediaOnQueryString() {
                const cacheKey = "paid_media_qs";
                if (window.vxPageCache.hasChangedPageByKey(cacheKey)) {
                    const paidMediaOnQs = this.extractPaidMediaFromQueryString(window.location.href);
                    window.vxPageCache.setCacheData(cacheKey, paidMediaOnQs);
                }
                return window.vxPageCache.getCacheData(cacheKey);
            }
            static extractPaidMediaFromQueryString(currentUrl) {
                const params = new URL(currentUrl).searchParams;
                const fromUtmSource = this.detectFromUtmSource(params);
                if (fromUtmSource) return fromUtmSource;
                const fromExternalMediaParams = this.detectFromExternalMediaParams(params);
                if (fromExternalMediaParams) return fromExternalMediaParams;
                return {
                    source: "none",
                    value: null
                };
            }
            static detectFromUtmSource(params) {
                const utmSource = params.get("utm_source");
                if (!utmSource) return null;
                if (UtmParamsHandler$1.getDefaultVxSourceParameters().includes(utmSource)) {
                    return {
                        source: "voxus",
                        value: utmSource
                    };
                }
                this.blockLiveloHopeUsers(utmSource);
                return {
                    source: "other_utm",
                    value: utmSource
                };
            }
            static detectFromExternalMediaParams(params) {
                for (const fragment of this.getBlockedUtmParameters()) {
                    const matchedParam = this.findQueryStringParamLike(fragment, params);
                    if (matchedParam) return {
                        source: fragment,
                        value: params.get(matchedParam)
                    };
                }
                return null;
            }
            static blockLiveloHopeUsers(utmSource) {
                if (utmSource !== "LIVELOHOPE") return;
                CookiesVx$1.set(window.voxus_key + "_block_full", "true", {
                    expires: VxDate.addDays(new Date, 1)
                });
            }
            static getBlockedUtmParameters() {
                return EXTERNAL_MEDIA_PARAM_FRAGMENTS;
            }
            static isVxPaidMediaOnQueryString() {
                const paidMedia = this.identifyPaidMediaOnQueryString();
                return paidMedia.source === "voxus" && paidMedia.value !== "";
            }
            static isOtherPaidMediaOnQueryString() {
                const paidMedia = this.identifyPaidMediaOnQueryString();
                return paidMedia.source !== "none" && paidMedia.value !== "" && !this.isVxPaidMediaOnQueryString();
            }
            static findQueryStringParamLike(name, params) {
                for (const key of params.keys()) {
                    if (IGNORED_EXACT_PARAMS.has(key)) continue;
                    if (key.includes(name) && params.get(key)) return key;
                }
                return null;
            }
            static setIgnoreCookies() {
                const oneDayExpiry = VxDate.addDays(new Date, 1);
                CookiesVx$1.set(`${window.voxus_key}_ignore`, "true", {
                    expires: oneDayExpiry
                });
                CookiesVx$1.set(`${window.voxus_key}_ignoreot_full`, "true", {
                    expires: oneDayExpiry
                });
                CookiesVx$1.expire(`${window.voxus_key}_at_pg_ok`);
                window.igvxtst = true;
                window.fromOther = true;
                window.kopid = false;
            }
        }
        let VxOtherV2Attr$1 = (_b = class {
            static _getOtherMediaCooldownCookieKey() {
                return `${window.voxus_key}_ot_block_window`;
            }
            static setOtherMediaCooldownCookie(date) {
                const cookieName = this._getOtherMediaCooldownCookieKey();
                const halfHourExpiryDate = window.VxDate.addMinutes(date, this.ATTR_OTHER_MEDIA_COOLDOWN_WINDOW_MINUTES);
                window.CookiesVx.set(cookieName, "true", {
                    expires: halfHourExpiryDate
                });
            }
            static isOtherMediaCooldownActive() {
                const cookieName = this._getOtherMediaCooldownCookieKey();
                return Boolean(window.CookiesVx.get(cookieName));
            }
            static async isVxLastPaidMedia(advertiserId = null) {
                const active = await this.getActivePaidMedia(advertiserId);
                if (!active) return false;
                return active.source === this._getVxAttributionEntryName();
            }
            static async isGoogleAdsLastPaidMedia() {
                const active = await this.getActivePaidMedia();
                if (!active || !("source" in active.raw)) return false;
                return active.raw.source === "gclid";
            }
            static async isOtherMediaLastPaidMedia() {
                const active = await this.getActivePaidMedia();
                if (!active) return false;
                return active.source === this._getOtherAttributionEntryName();
            }
            static async isVxLastPaidMediaOnAnyAdvertiser() {
                const advertiserIds = this.getAttrScopeAdvertiserIds();
                const results = await window.VxNativePromise.allSettled(advertiserIds.map(id => this.isVxLastPaidMedia(id)));
                return results.some(r => r.status === "fulfilled" && r.value === true);
            }
            static async getActivePaidMedia(advertiserId = null) {
                this.storePaidMediaIfExists();
                if (!advertiserId) advertiserId = window.advInfo.id;
                const otherActivePaidMedia = this._getOtherPaidMedia();
                const vxImpression = await window.VxImpHandler.getVxLastImpression(advertiserId);
                const activeMedias = [];
                const otherAttributionEntryName = this._getOtherAttributionEntryName();
                const otherAttributionSource = this._buildAttributionEntry(otherAttributionEntryName, otherActivePaidMedia);
                if (otherAttributionSource) activeMedias.push(otherAttributionSource);
                const vxAttributionEntryName = this._getVxAttributionEntryName();
                const vxAttributionSource = this._buildAttributionEntry(vxAttributionEntryName, vxImpression);
                if (vxAttributionSource) activeMedias.push(vxAttributionSource);
                if (activeMedias.length === 0) return null;
                activeMedias.sort((a, b) => b.time - a.time);
                return activeMedias[0];
            }
            static storePaidMediaIfExists() {
                const cookieKey = this._getOtherCookieKey();
                const cacheKey = `s_:${cookieKey}`;
                if (!window.vxPageCache.hasChangedPageByKey(cacheKey)) return;
                window.vxPageCache.setCacheData(cacheKey, true);
                if (window.VxAttrOnClickUtmHandler.isVxPaidMediaOnQueryString()) {
                    this._expireOtherCookie();
                    return;
                }
                if (window.VxAttrOnClickUtmHandler.isOtherPaidMediaOnQueryString()) {
                    const now = Math.floor(Date.now() / 1e3);
                    const paidMedia = window.VxAttrOnClickUtmHandler.identifyPaidMediaOnQueryString();
                    const data = {
                        ...paidMedia,
                        time: now
                    };
                    window.CookiesVx.set(cookieKey, JSON.stringify(data), {
                        expires: window.VxDate.addDays(new Date, 1)
                    });
                }
            }
            static async expireIgnoreOtherCookieWhenVoxusLastPaidMedia() {
                const cacheKey = "expired_ignoreot";
                window.vxPageCache.hasChangedPageByKey(cacheKey);
                const hasExpired = !!window.vxPageCache.getCacheData(cacheKey);
                if (hasExpired) return false;
                const isVoxus = await this.isVxLastPaidMedia(window.advInfo.id);
                if (!isVoxus) return false;
                if (this.isOtherMediaCooldownActive()) return false;
                this._expireOtherCookie();
                window.vxPageCache.setCacheData(cacheKey, true);
                return true;
            }
            static getAttrScopeAdvertiserIds() {
                const advertiserIds = window.hasCustomization("multi_adv_same_adv") && typeof window.associatedAdvData !== "undefined" ? Object.keys(window.associatedAdvData) : [];
                advertiserIds.push(window.advInfo.id);
                if (window.hasCustomization("unify-tf-core-attribution") && window.tfAdvId) {
                    advertiserIds.push(window.tfAdvId);
                }
                return advertiserIds;
            }
            static reloadFromOtherV2VariableState() {
                this.isOtherMediaLastPaidMedia().then(v => {
                    window.fromOtherv2 = !!v;
                }).catch(() => {
                    window.fromOtherv2 = null;
                });
            }
            static _expireOtherCookie() {
                window.CookiesVx.expire(window.voxus_key + "_ignore");
                window.CookiesVx.expire(window.voxus_key + "_ignoreot_full");
                const otherV2CookieKey = this._getOtherCookieKey();
                window.CookiesVx.expire(otherV2CookieKey);
            }
            static _getOtherPaidMedia() {
                const cookieKey = this._getOtherCookieKey();
                const cacheKey = `g_:${cookieKey}`;
                if (!window.vxPageCache.hasChangedPageByKey(cacheKey)) return window.vxPageCache.getCacheData(cacheKey);
                const storedDataJSON = window.CookiesVx.get(cookieKey);
                if (!storedDataJSON) {
                    window.vxPageCache.setCacheData(cacheKey, null);
                    return null;
                }
                try {
                    const parsed = JSON.parse(storedDataJSON);
                    window.vxPageCache.setCacheData(cacheKey, parsed);
                    return parsed;
                } catch (e) {
                    window.vxLogger.debug("Error in `_getOtherPaidMedia` for advertiser: ", window.advInfo.id, e);
                    window.vxLogger.trace(e.stack);
                    window.CookiesVx.expire(cookieKey);
                    return null;
                }
            }
            static _buildAttributionEntry(sourceName, obj) {
                const now = Math.floor(Date.now() / 1e3);
                const windowSeconds = this.ATTRIBUTION_WINDOW_HOURS * 60 * 60;
                if (!obj || typeof obj.time !== "number" || !Number.isFinite(obj.time)) return null;
                const age = now - obj.time;
                if (age < 0) return null;
                if (age > windowSeconds) return null;
                const expiresAt = obj.time + windowSeconds;
                return {
                    source: sourceName,
                    time: obj.time,
                    expiresAt: expiresAt,
                    remainingSeconds: Math.max(0, expiresAt - now),
                    raw: obj
                };
            }
            static _getOtherCookieKey() {
                return "other_v2";
            }
            static _getVxAttributionEntryName() {
                return window.voxus_key;
            }
            static _getOtherAttributionEntryName() {
                return "other";
            }
        }, __publicField(_b, "ATTRIBUTION_WINDOW_HOURS", 24), __publicField(_b, "ATTR_OTHER_MEDIA_COOLDOWN_WINDOW_MINUTES", 30), 
        _b);
        let VxImpHandler$1 = class VxImpHandler {
            static setLastImpressionTimestampCookie(timestamp) {
                const normalizedTimestamp = window.VxDate.normalizeTimestampInSeconds(timestamp);
                if (!normalizedTimestamp) return;
                const cookieKey = "voxus_last_impression_timestamp_" + window.advInfo.id;
                const thirtyDays = 60 * 60 * 24 * 30;
                window.CookiesVx.set(cookieKey, normalizedTimestamp, {
                    expires: thirtyDays
                });
            }
            static getCookieLastAdSeenInformation(advertiserId = null) {
                if (!advertiserId) advertiserId = window.advInfo.id;
                const raw = window.CookiesVx.get(`${window.voxus_key}_kopid_pip`);
                const timeRaw = window.CookiesVx.get(`voxus_last_impression_timestamp_${advertiserId}`);
                const parsed = Number.parseInt(timeRaw, 10);
                const time = Number.isFinite(parsed) ? parsed : null;
                let creative = "", campaign = "";
                if (raw && typeof raw === "string") {
                    const [p0 = "", p1 = ""] = raw.trim().split("-", 2).map(s => s.trim());
                    creative = p0;
                    campaign = p1;
                }
                const rawSegSeen = window.CookiesVx.get(`${window.voxus_key}_seg_kaoq`);
                const adPlacementDomain = window.CookiesVx.get(`${window.voxus_key}_ad_placement_domain`);
                const kopidPlataform = window.CookiesVx.get(`${window.voxus_key}_kopid_plataform`);
                let allCampaigns = [];
                if (rawSegSeen && typeof rawSegSeen === "string") allCampaigns = rawSegSeen.split(",");
                return {
                    time: time,
                    creative: creative,
                    campaign: campaign,
                    campaigns: allCampaigns,
                    ad_placement_domain: adPlacementDomain,
                    kopid_plataform: kopidPlataform
                };
            }
            static getVerifyTrackData(advertiserId, cookieId, use30DayWindow) {
                const nsKey = `verify:${advertiserId}`;
                let store = window.vxPageCache.getCacheData(nsKey);
                if (window.vxPageCache.hasChangedPageByKey(nsKey) || store === void 0) {
                    store = {
                        queue: {},
                        resolved: {}
                    };
                    window.vxPageCache.setCacheData(nsKey, store);
                }
                const {queue: queue, resolved: resolved} = store;
                const cacheKey = use30DayWindow ? "ipa_true" : "ipa_false";
                if (resolved[cacheKey]) return Promise.resolve(resolved[cacheKey]);
                if (queue[cacheKey]) return queue[cacheKey];
                const pending = this._fetchVerifyTrackingData(advertiserId, cookieId, use30DayWindow).then(resp => {
                    const val = Object.freeze(resp || {});
                    resolved[cacheKey] = val;
                    delete queue[cacheKey];
                    window.vxPageCache.setCacheData(nsKey, store);
                    return val;
                }).catch(err => {
                    delete queue[cacheKey];
                    window.vxLogger.debug("Error in `getVerifyTrackData` (cached path): ", window.advInfo.id, err);
                    window.vxLogger.trace(err.stack);
                    const empty = Object.freeze({});
                    resolved[cacheKey] = empty;
                    window.vxPageCache.setCacheData(nsKey, store);
                    return empty;
                });
                queue[cacheKey] = pending;
                window.vxPageCache.setCacheData(nsKey, store);
                return pending;
            }
            static async getVxLastImpression(advertiserId) {
                if (window.ismobile) {
                    return this._getIPAddressLastImpression(advertiserId);
                }
                const ipResult = await this._getIPAddressLastImpression(advertiserId);
                if (ipResult) return ipResult;
                return this._getCookiesLastImpression(advertiserId);
            }
            static async hasSeenAdInLastHours(hours, advertiserId = null) {
                const impression = await this.getVxLastImpression(advertiserId);
                if (!(impression == null ? void 0 : impression.time)) return false;
                const nowSeconds = Math.floor(Date.now() / 1e3);
                const hoursInSeconds = hours * 60 * 60;
                return nowSeconds - impression.time < hoursInSeconds;
            }
            static setAdSeenCookies(impressionData) {
                const {impressionTime: impressionTime, lastSeenCreative: lastSeenCreative, lastSeenCampaign: lastSeenCampaign, lastSeenCampaigns: lastSeenCampaigns, adPlacementDomain: adPlacementDomain = "", adSeenPlatform: adSeenPlatform = ""} = impressionData;
                const impressionDate = new Date(impressionTime * 1e3);
                const expiresDate = window.VxDate.addHours(impressionDate, 24);
                const adSeenValue = `${lastSeenCreative}-${lastSeenCampaign}-apnx`;
                const campaignsValue = Array.isArray(lastSeenCampaigns) ? lastSeenCampaigns.join(",") : lastSeenCampaigns;
                window.CookiesVx.set(window.voxus_key + "_kopid_pip", adSeenValue, {
                    expires: expiresDate
                });
                window.CookiesVx.set(window.voxus_key + "_seg_kaoq", campaignsValue, {
                    expires: expiresDate
                });
                if (adPlacementDomain) {
                    window.CookiesVx.set(window.voxus_key + "_ad_placement_domain", adPlacementDomain, {
                        expires: expiresDate
                    });
                }
                if (adSeenPlatform) {
                    window.CookiesVx.set(window.voxus_key + "_kopid_plataform", adSeenPlatform, {
                        expires: expiresDate
                    });
                }
                this.setLastImpressionTimestampCookie(impressionTime);
            }
            static buildVerifyUrl(advertiserId, cookieId, use30DayWindow) {
                const currentPath = encodeURIComponent(window.location.href);
                const params = new URLSearchParams({
                    adv_id: String(advertiserId),
                    ck_id: cookieId,
                    page_url: currentPath
                });
                if (use30DayWindow) {
                    params.append("ipa", "true");
                }
                return `${window.VOXUS_API_BASE_URL}/verify/?${params.toString()}`;
            }
            static async _fetchVerifyTrackingData(advertiserId, cookieId, use30DayWindow) {
                return new Promise((resolve, reject) => {
                    const url = this.buildVerifyUrl(advertiserId, cookieId, use30DayWindow);
                    const xhr = new XMLHttpRequest;
                    xhr.open("GET", url, true);
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4) {
                            if (xhr.status >= 200 && xhr.status < 300) {
                                try {
                                    const jsonResponse = JSON.parse(xhr.responseText);
                                    resolve(jsonResponse);
                                } catch (e) {
                                    window.vxLogger.debug("Error in `fetchVerifyTrackingData` for advertiser: ", window.advInfo.id, e);
                                    window.vxLogger.trace(e.stack);
                                    reject(new Error("Erro ao parsear JSON"));
                                }
                            } else {
                                window.vxLogger.debug("Error in `fetchVerifyTrackingData` with bad HTTP status code for advertiser: ", window.advInfo.id, xhr.status);
                                reject(new Error(`Erro HTTP: ${xhr.status}`));
                            }
                        }
                    };
                    xhr.onerror = function() {
                        window.vxLogger.debug("Network error in `fetchVerifyTrackingData` for advertiser: ", window.advInfo.id);
                        reject(new Error("Erro de rede"));
                    };
                    xhr.send();
                });
            }
            static _getCookiesLastImpression(advertiserId) {
                const adSeenCookieInfo = this.getCookieLastAdSeenInformation(advertiserId);
                if (!adSeenCookieInfo.time) return null;
                return adSeenCookieInfo;
            }
            static async _getIPAddressLastImpression(advertiserId) {
                const response = await this.getVerifyTrackData(advertiserId, window.cookie_id, false);
                if (!response || !response.data || response.data.length === 0) {
                    return null;
                }
                const latestItem = response.data.reduce((latest, current) => {
                    const latestDate = new Date(latest == null ? void 0 : latest.date);
                    const currentDate = new Date(current == null ? void 0 : current.date);
                    if (isNaN(currentDate.getTime())) return latest;
                    if (isNaN(latestDate.getTime())) return current;
                    return currentDate > latestDate ? current : latest;
                });
                if (!latestItem) return null;
                const allCampaigns = response.data.map(item => item.campaign).filter(Boolean);
                const adSeenPlataform = [ "adse", "en_plataform" ].join("");
                return {
                    time: Math.floor(new Date(latestItem.dateTz || latestItem.date).getTime() / 1e3),
                    campaign: latestItem.campaign,
                    creative: latestItem.crtv,
                    campaigns: allCampaigns,
                    ad_placement_domain: latestItem.ad_placement_domain || null,
                    kopid_plataform: latestItem[adSeenPlataform] || null
                };
            }
        };
        const _VxGa = class _VxGa {
            static getMeasurementIds() {
                if (typeof window.hasCustomization === "function" && !window.hasCustomization("ga_hit")) {
                    return [];
                }
                const mIdsSet = new Set([ ..._VxGa.getHardCodedMeasurementIds(), ..._VxGa.getMeasurementIdsFromGtm(), ..._VxGa.getMeasurementIdsFromGtmDestination() ]);
                return [ ...mIdsSet ];
            }
            static getGaSessionCookieData(measurementId) {
                const selectedMeasurementId = measurementId || _VxGa.getMeasurementIds()[0];
                if (!selectedMeasurementId) return null;
                const key = [ "_", "ga_" ].join("") + selectedMeasurementId.slice(2);
                const fullCookie = CookiesVx$1.get(key);
                if (!fullCookie) return null;
                const mainCookie = _VxGa.parseGaMainCookie();
                if (!mainCookie) return null;
                const isSessionCookieNewVersion = _VxGa.isGS2Implementation(fullCookie);
                const sessionId = _VxGa.getGaCookieSessionId(isSessionCookieNewVersion, fullCookie);
                const sessionLastInteraction = _VxGa.getSessionLastInteraction(isSessionCookieNewVersion, fullCookie);
                const sessionCount = _VxGa.getSessionCount(isSessionCookieNewVersion, fullCookie);
                const newUser = _VxGa.getSessionNewUser(isSessionCookieNewVersion, fullCookie);
                const sessionStartSeconds = VxDate.normalizeTimestampInSeconds(sessionId);
                const sessionLastInteractionSeconds = VxDate.normalizeTimestampInSeconds(sessionLastInteraction);
                const userSessionTimespent = sessionStartSeconds && sessionLastInteractionSeconds ? Math.max(0, sessionLastInteractionSeconds - sessionStartSeconds) : 0;
                return {
                    key: key,
                    value: fullCookie,
                    userId: mainCookie.userId,
                    userTimestamp: mainCookie.timestamp,
                    sessionId: sessionId,
                    sessionLastInteraction: sessionLastInteraction,
                    sessionCount: sessionCount,
                    newUser: newUser,
                    userSessionTimespent: userSessionTimespent
                };
            }
            static getFixedMeasurementId() {
                let fixedMeasurementId = CookiesVx$1.get("measurement_id");
                if (!_VxGa.isMeasurementIdValid(fixedMeasurementId)) {
                    fixedMeasurementId = _VxGa.getMeasurementIds()[0];
                    if (!fixedMeasurementId) return null;
                }
                CookiesVx$1.set("measurement_id", fixedMeasurementId);
                return fixedMeasurementId;
            }
            static isMeasurementIdValid(measurementId) {
                if (!measurementId) return false;
                return _VxGa.getMeasurementIds().includes(measurementId);
            }
            static isNewUser() {
                const mainCookie = _VxGa.parseGaMainCookie();
                if (!mainCookie) return false;
                const measurementIds = _VxGa.getMeasurementIds();
                if (!measurementIds.length) return false;
                const isNewUserByTime = VxDate.minutesSinceTimestamp(Number(mainCookie.timestamp)) <= 1;
                return isNewUserByTime || measurementIds.some(measurementId => _VxGa.isNewGaSessionCookie(measurementId));
            }
            static isNewGaSessionCookie(measurementId) {
                const gaCookieData = _VxGa.getGaSessionCookieData(measurementId);
                if (!gaCookieData) return false;
                return gaCookieData.sessionCount === "1" && gaCookieData.newUser;
            }
            static getGaCookieKey() {
                return [ "_", "g", "a" ].join("");
            }
            static getGaCookie() {
                return CookiesVx$1.get(_VxGa.getGaCookieKey());
            }
            static generateNewCid() {
                const timestamp = Math.floor(Date.now() / 1e3);
                const randomPart = Math.floor(1e8 + Math.random() * 9e8);
                return `${randomPart}.${timestamp}`;
            }
            static generateSid() {
                return Math.floor(Date.now() / 1e3);
            }
            static updateClientGaCookie(newClientId) {
                const originalClientId = _VxGa.getGaCookie();
                if (typeof originalClientId === "undefined") return;
                const newGaCookie = originalClientId.split(".").slice(0, 2).concat(newClientId).join(".");
                CookiesVx$1.set(_VxGa.getGaCookieKey(), newGaCookie);
            }
            static updateCookieSessionId(sessionId, measurementId) {
                var _a2;
                if (!measurementId) return;
                const originalSessionCookieId = (_a2 = _VxGa.getGaSessionCookieData(measurementId)) == null ? void 0 : _a2.value;
                if (!originalSessionCookieId) return;
                const gaCookieName = measurementId.replace("G-", [ "_", "ga_" ].join(""));
                let newSessionCookieId;
                if (_VxGa.isGS2Implementation(originalSessionCookieId)) {
                    const parts = originalSessionCookieId.split("$");
                    const sessionNumber = 1;
                    const sessionEngaged = 0;
                    const joinTimer = 0;
                    const [prefix] = parts[0].split(".s");
                    parts[0] = `${prefix}.s${sessionId}`;
                    newSessionCookieId = parts.map((part, index) => {
                        if (index === 0) return part;
                        if (part.startsWith("o")) return `o${sessionNumber}`;
                        if (part.startsWith("g")) return `g${sessionEngaged}`;
                        if (part.startsWith("t")) return `t${sessionId}`;
                        if (part.startsWith("j")) return `j${joinTimer}`;
                        return part;
                    }).join("$");
                } else {
                    const cookieParts = originalSessionCookieId.split(".");
                    cookieParts[2] = String(sessionId);
                    cookieParts[3] = "1";
                    cookieParts[4] = "0";
                    cookieParts[5] = String(sessionId);
                    cookieParts[6] = "0";
                    newSessionCookieId = cookieParts.join(".");
                }
                CookiesVx$1.set(gaCookieName, newSessionCookieId);
            }
            static getGAUserAgent() {
                const uaData = navigator.userAgentData;
                if (!uaData) return "";
                const chromeVersionMatch = navigator.userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
                const chromeFullVersion = chromeVersionMatch ? chromeVersionMatch[1] : "unknown";
                return uaData.brands.map(({brand: brand, version: version}) => {
                    if (brand === "Google Chrome") return `${brand};${chromeFullVersion}`;
                    if (brand === "Not A;Brand") return `Not%3BA%3DBrand;${version}.0.0.0`;
                    return `${brand};${version}.0.6613.138`;
                }).join("|");
            }
            static generateRandomTfd() {
                return Math.floor(1e3 + Math.random() * 9e3);
            }
            static getClientId() {
                var _a2;
                return ((_a2 = _VxGa.parseGaMainCookie()) == null ? void 0 : _a2.userId) ?? null;
            }
            static getSiteCollectEndpoint(measurementId) {
                try {
                    const urls = performance.getEntriesByType("resource").map(entry => _VxGa.parseUrl(entry.name)).reverse();
                    for (const url of urls) {
                        const endpoint = url && _VxGa.readCollectEndpoint(url, measurementId);
                        if (endpoint && !_VxGa.isGoogleEndpoint(endpoint)) return endpoint;
                    }
                } catch {}
                return null;
            }
            static async waitForSiteCollectEndpoint(measurementId, timeoutMs = 5e3, intervalMs = 250) {
                for (let waited = 0; ;waited += intervalMs) {
                    const endpoint = _VxGa.getSiteCollectEndpoint(measurementId);
                    if (endpoint || waited >= timeoutMs) return endpoint;
                    await new Promise(resolve => window.setTimeout(resolve, intervalMs));
                }
            }
            static isGoogleEndpoint(endpoint) {
                var _a2;
                const host = ((_a2 = _VxGa.parseUrl(endpoint.url)) == null ? void 0 : _a2.hostname) ?? "";
                return _VxGa.GOOGLE_COLLECT_DOMAINS.some(domain => host === domain || host.endsWith(`.${domain}`));
            }
            static buildHitUrl(endpoint, query) {
                if (!endpoint.encodedParam) return `${endpoint.url}?${query}`;
                return `${endpoint.url}?${endpoint.encodedParam}=${encodeURIComponent(btoa(`${endpoint.encodedPath}?${query}`))}`;
            }
            static readCollectEndpoint(url, measurementId) {
                if (_VxGa.isCollectHitFor(url, measurementId)) {
                    return {
                        url: url.origin + url.pathname,
                        encodedParam: null,
                        encodedPath: null
                    };
                }
                for (const [param, value] of url.searchParams) {
                    const decoded = _VxGa.decodeBase64(value);
                    if (!(decoded == null ? void 0 : decoded.startsWith("/"))) continue;
                    const inner = _VxGa.parseUrl(url.origin + decoded);
                    if (inner && _VxGa.isCollectHitFor(inner, measurementId)) {
                        return {
                            url: url.origin + url.pathname,
                            encodedParam: param,
                            encodedPath: inner.pathname
                        };
                    }
                }
                return null;
            }
            static isCollectHitFor(url, measurementId) {
                return url.pathname.endsWith("/g/collect") && url.searchParams.get("tid") === measurementId;
            }
            static decodeBase64(value) {
                try {
                    return atob(value);
                } catch {
                    return null;
                }
            }
            static parseUrl(url) {
                try {
                    return new URL(url);
                } catch {
                    return null;
                }
            }
            static getHardCodedMeasurementIds() {
                const manualClientTrackingMap = new Map([ [ "2726", [ "G-JPJPRSDB9K" ] ], [ "1852", [ "G-ZM0BG28WWR" ] ], [ "2859", [ "G-ZQG965CFCJ" ] ], [ "2783", [ "G-NM6XDMNB2W" ] ], [ "1985", [ "G-SZ828V6WSK" ] ], [ "2701", [ "DC-11379620", "G-WCFX1FQ26K", "AW-804145559" ] ], [ "1948", [ "G-78EPY23H13", "G-7HNMFXJ8J5", "G-B0521B3853", "G-HMCQCM5KQ1", "G-NY5NGVZ1KQ", "G-S02H216ES2" ] ], [ "1879", [ "G-PYGGC1W2VQ" ] ], [ "2900", [ "G-4CZX459Q1Q", "G-G5LR3WEXK4" ] ], [ "1598", [ "corebiz_google_app", "G-TCKVZX1BJB", "G-HN1RYJHPJ7" ] ] ]);
                return manualClientTrackingMap.get(window.advInfo.id) || [];
            }
            static getMeasurementIdsFromGtm() {
                if (typeof window.google_tag_manager === "undefined") return [];
                const allOptions = Object.keys(window.google_tag_manager || {});
                return allOptions.filter(option => option.startsWith("G-"));
            }
            static getMeasurementIdsFromGtmDestination() {
                var _a2, _b2;
                if (typeof window.google_tag_data === "undefined" || !((_b2 = (_a2 = window.google_tag_data) == null ? void 0 : _a2.tidr) == null ? void 0 : _b2.destination)) {
                    return [];
                }
                const mainDestinations = Object.keys(window.google_tag_data.tidr.destination || {}).filter(item => item.startsWith("G-"));
                const secondDestinations = Object.keys(window.google_tag_data.tidr.destinationArray || {}).filter(item => item.startsWith("G-"));
                return mainDestinations.concat(secondDestinations);
            }
            static parseGaMainCookie() {
                const key = [ "_", "ga" ].join("");
                const fullCookie = CookiesVx$1.get(key);
                if (!fullCookie) return null;
                const splited = fullCookie.split(".");
                if (splited.length < 4) return null;
                return {
                    key: key,
                    value: fullCookie,
                    timestamp: splited[3],
                    userId: `${splited[2]}.${splited[3]}`
                };
            }
            static isGS2Implementation(fullCookie) {
                return fullCookie.startsWith("GS2");
            }
            static getGaCookieSessionId(isNewVersion, fullCookie) {
                if (isNewVersion) {
                    const splited = fullCookie.split("$");
                    const sessionIdPart = splited.find(p => p.includes(".s"));
                    return sessionIdPart ? sessionIdPart.split(".s")[1] : null;
                }
                return fullCookie.split(".")[2] || null;
            }
            static getSessionLastInteraction(isNewVersion, fullCookie) {
                var _a2;
                if (isNewVersion) {
                    const splited = fullCookie.split("$");
                    return ((_a2 = splited.find(p => p.startsWith("t"))) == null ? void 0 : _a2.substring(1)) || null;
                }
                return fullCookie.split(".")[5] || null;
            }
            static getSessionCount(isNewVersion, fullCookie) {
                if (isNewVersion) {
                    const splited = fullCookie.split("$");
                    const sessionCountPart = splited.find(p => p.startsWith("o"));
                    return sessionCountPart ? sessionCountPart.substring(1) : null;
                }
                return fullCookie.split(".")[3] || null;
            }
            static getSessionNewUser(isNewVersion, fullCookie) {
                if (isNewVersion) {
                    const splited = fullCookie.split("$");
                    const newUserPart = splited.find(p => p.startsWith("o"));
                    return newUserPart ? newUserPart.substring(1) === "1" : false;
                }
                return fullCookie.split(".")[3] === "1";
            }
        };
        _VxGa.GOOGLE_COLLECT_URL = "https://www.google-analytics.com/g/collect";
        _VxGa.GOOGLE_COLLECT_ENDPOINT = {
            url: _VxGa.GOOGLE_COLLECT_URL,
            encodedParam: null,
            encodedPath: null
        };
        _VxGa.GOOGLE_COLLECT_DOMAINS = [ "google-analytics.com", "google.com", "doubleclick.net" ];
        let VxGa = _VxGa;
        class VxResetLookupWindow {
            static setOtherPaidMediaCookie() {
                this._setLastPaidMediaCookie(this._getOtherLastPaidMediaCookieValue());
            }
            static setVxPaidMediaCookie() {
                this._setLastPaidMediaCookie("vx");
            }
            static async resetLookupWindow() {
                if (!this.hasLookupCustomization()) return;
                if (this._hasOtherLastPaidMediaCookie()) return;
                if (!this._canResetLookupWindow()) return;
                if (await window.VxImpHandler.hasSeenAdInLastHours(window.VxOtherV2Attr.ATTRIBUTION_WINDOW_HOURS)) return;
                const cookieBeforeReset = VxGa.getGaCookie();
                window.VxGA4Attr.resetUser(VxGa.getMeasurementIds(), {});
                sendToLoggly({
                    type: "reset_lookup_window",
                    pageview: window.location.href,
                    cookie_id: window.cookie_id,
                    old_ugi_cookie: cookieBeforeReset,
                    new_ugi_cookie: VxGa.getGaCookie(),
                    measurementIds: VxGa.getMeasurementIds(),
                    is_mobile: window.ismobile
                });
                this._incrementResetCount();
            }
            static _canResetLookupWindow() {
                if (!this.hasLookupCustomization()) return false;
                const currentCount = this.getResetCount();
                return currentCount < this.MAX_RESETS_PER_WINDOW;
            }
            static _incrementResetCount() {
                if (!this.hasLookupCustomization()) return;
                const cookieName = this._getResetCountCookieName();
                const currentCount = this.getResetCount();
                const nextCount = Math.min(currentCount + 1, this.MAX_RESETS_PER_WINDOW);
                window.CookiesVx.set(cookieName, nextCount.toString(), {
                    expires: window.VxDate.addDays(new Date, this.RESET_WINDOW_DAYS)
                });
            }
            static getResetCount() {
                const raw = window.CookiesVx.get(this._getResetCountCookieName());
                return raw ? parseInt(raw, 10) || 0 : 0;
            }
            static _getResetCountCookieName() {
                return `${window.voxus_key}_lookup_reset_count`;
            }
            static _hasOtherLastPaidMediaCookie() {
                if (!this.hasLookupCustomization()) return false;
                return window.CookiesVx.get(`${window.voxus_key}_last_media`) === this._getOtherLastPaidMediaCookieValue();
            }
            static _setLastPaidMediaCookie(value) {
                if (!this.hasLookupCustomization()) return;
                window.CookiesVx.set(`${window.voxus_key}_last_media`, value, {
                    expires: window.VxDate.addDays(new Date, 7)
                });
            }
            static _getOtherLastPaidMediaCookieValue() {
                return "other";
            }
            static hasLookupCustomization() {
                return window.hasCustomization("reset_lookup_window");
            }
        }
        __publicField(VxResetLookupWindow, "MAX_RESETS_PER_WINDOW", 1);
        __publicField(VxResetLookupWindow, "RESET_WINDOW_DAYS", 7);
        class VxGA4Attr {
            static sendDefaultPageViewAnalyticsHit(measurementIds = null, params = null, skipSetAttributionGa = false, customPayload = {}) {
                const sent = this._sendAnalyticsEventHit(params, measurementIds, "page_view", customPayload);
                if (advInfo.id == "2192") {
                    sendToLoggly({
                        type: "stanley_ugihit",
                        pageview: window.location.href,
                        params: params
                    });
                }
                if (!skipSetAttributionGa && sent) window.analyticsAttributionHitsSentOnPage.ga = true;
                return sent;
            }
            static sendPurchaseAnalyticsHit(measurementIds = null, params = null, customPayload = {}) {
                return this._sendAnalyticsEventHit(params, measurementIds, "purchase", customPayload);
            }
            static _sendAnalyticsEventHit(params = null, measurementIds = null, eventName = null, customPayload = {}) {
                if (!eventName) return false;
                if (!params) params = UtmParamsHandler.getUtmParametersToSend(alcs, alcm, alcn);
                const defaultPayload = {
                    campaign: params,
                    send_to: measurementIds || VxGa.getMeasurementIds()
                };
                const finalPayload = {
                    ...defaultPayload,
                    ...customPayload
                };
                VxGtag.event(eventName, finalPayload);
                return true;
            }
            static sendEventScopedCustomDimensionProperty(dimensionName, value = "voxus_user") {
                VxGtag.event("page_view", {
                    send_to: VxGa.getMeasurementIds(),
                    [dimensionName]: value
                });
            }
            static resetSession(measurementIds) {
                if (!measurementIds || !measurementIds.length) {
                    return;
                }
                const newTimestamp = Math.floor(window.VxDate.addHours(new Date, -6).getTime() / 1e3);
                const voxusGaSessionResetedCookieKey = window.voxus_key + "_session_reseted";
                const voxusGaSessionResetQtCookieKey = window.voxus_key + "_session_reset_qt";
                const resetCap = window.hasCustomization("measurement_protocol_fix") ? 3 : 1;
                const isSessionReseted = Boolean(window.CookiesVx.get(voxusGaSessionResetedCookieKey));
                const rawValue = window.CookiesVx.get(voxusGaSessionResetQtCookieKey);
                const amountOfResets = isNaN(Number(rawValue)) ? 0 : Number(rawValue);
                if (isSessionReseted && amountOfResets >= resetCap) {
                    return;
                }
                for (const measurementId of measurementIds) {
                    modifyGa4SessionCookie({
                        measurementId: measurementId,
                        newTimestamp: newTimestamp
                    });
                }
                window.CookiesVx.set(voxusGaSessionResetedCookieKey, "true", {
                    expires: window.VxDate.addMinutes(new Date, 30)
                });
                window.CookiesVx.set(voxusGaSessionResetQtCookieKey, (amountOfResets + 1).toString(), {
                    expires: window.VxDate.addMinutes(new Date, 30)
                });
            }
            static usesServerManagedClientId() {
                return Boolean(window.CookiesVx.get("FPLC"));
            }
            static async resetNewUserIfEligible(utmParams) {
                const restartsThroughSgtm = window.hasCustomization("reset_hit_sgtm_route") && this.usesServerManagedClientId();
                const alreadyResetNewUser = window.CookiesVx.get(voxus_key + "_already_reset_user");
                if (alreadyResetNewUser === "true") {
                    window.noNewUserResetReason = "already_reset";
                    return;
                }
                const ids = VxGa.getMeasurementIds();
                if (!(ids == null ? void 0 : ids.length)) {
                    window.noNewUserResetReason = "no_measurement_ids";
                    return;
                }
                if (!VxGa.isNewUser()) {
                    window.noNewUserResetReason = "not_new_user";
                    return;
                }
                const resetFeatActivationTime = "ADV_NEW_USER_FEAT_ACTIVATION_DATETIME";
                if (!shouldResetUserByFeatureActivationDate(resetFeatActivationTime)) {
                    window.noNewUserResetReason = "time_restricted";
                    return;
                }
                let sentHits;
                if (restartsThroughSgtm) {
                    sentHits = await this.restartSessionThroughSgtm(ids, utmParams);
                    if (sentHits === null) {
                        window.noNewUserResetReason = "sgtm_endpoint_not_found";
                        return;
                    }
                } else {
                    sentHits = await this.resetUser(ids, utmParams);
                }
                if (!sentHits) {
                    window.noNewUserResetReason = "send_failed";
                    return;
                }
                const ONE_DAY = 24 * 60 * 60;
                window.CookiesVx.set(window.voxus_key + "_already_reset_user", "true", {
                    expires: ONE_DAY
                });
                window.noNewUserResetReason = "sent";
            }
            static async resetUser(measurementIds, utmParams) {
                if (!(measurementIds == null ? void 0 : measurementIds.length)) return 0;
                const clientId = VxGa.generateNewCid();
                VxGa.updateClientGaCookie(clientId);
                return this.sendNewSessionHitToEach(measurementIds.map(measurementId => ({
                    measurementId: measurementId,
                    options: {
                        clientId: clientId
                    }
                })), utmParams);
            }
            static async restartSessionThroughSgtm(measurementIds, utmParams) {
                const clientId = window.VxGa.getClientId();
                if (!clientId) return null;
                const results = await window.VxNativePromise.allSettled(measurementIds.map(measurementId => window.VxGa.waitForSiteCollectEndpoint(measurementId)));
                const sends = [];
                measurementIds.forEach((measurementId, index) => {
                    const endpoint = results[index].status === "fulfilled" ? results[index].value : null;
                    if (!endpoint || window.VxGa.isGoogleEndpoint(endpoint)) return;
                    sends.push({
                        measurementId: measurementId,
                        options: {
                            endpoint: endpoint,
                            clientId: clientId,
                            firstVisit: false
                        }
                    });
                });
                if (!sends.length) return null;
                return this.sendNewSessionHitToEach(sends, utmParams);
            }
            static async sendNewSessionHitToEach(sends, utmParams) {
                const results = await window.VxNativePromise.allSettled(sends.map(async ({measurementId: measurementId, options: options}) => this.sendNewSessionHit(measurementId, utmParams, options)));
                let sentHits = 0;
                results.forEach((result, index) => {
                    var _a2;
                    if (result.status === "fulfilled") {
                        sentHits++;
                        return;
                    }
                    window.vxLogger.debug("Error in `sendNewSessionHit` for measurement ID:", sends[index].measurementId, window.advInfo.id, result.reason);
                    window.vxLogger.trace((_a2 = result.reason) == null ? void 0 : _a2.stack);
                });
                return sentHits;
            }
            static sendNewSessionHit(measurementId, utmParams, {clientId: clientId, endpoint: endpoint = null, firstVisit: firstVisit = true}) {
                var _a2;
                if (!clientId) {
                    throw new Error("sendNewSessionHit needs the client ID already written to `_ugi`");
                }
                if (!measurementId) {
                    measurementId = VxGa.getFixedMeasurementId();
                }
                if (!endpoint) {
                    endpoint = window.hasCustomization("reset_hit_sgtm_route") && window.VxGa.getSiteCollectEndpoint(measurementId) || window.VxGa.GOOGLE_COLLECT_ENDPOINT;
                }
                const usesSiteEndpoint = !window.VxGa.isGoogleEndpoint(endpoint);
                window.resetHitCollectHost = new URL(endpoint.url).host;
                const sessionId = VxGa.generateSid();
                VxGa.updateCookieSessionId(sessionId, measurementId);
                let currentPageUrl = window.location.href;
                const utmParamsName = [ "utm_source", "utm_campaign", "utm_medium", "utm_term" ];
                const hasUtmParam = utmParamsName.some(utmParam => currentPageUrl.includes(utmParam));
                const hasUtmValues = utmParams && (utmParams.source || utmParams.name || utmParams.medium || utmParams.term);
                if (!hasUtmParam && hasUtmValues) {
                    const completeUtmParams = utmsToString(utmParams);
                    if (currentPageUrl.includes("?")) {
                        currentPageUrl += `&${completeUtmParams}`;
                    } else {
                        currentPageUrl += `?${completeUtmParams}`;
                    }
                }
                const encodedCurrentPageUrl = encodeURIComponent(currentPageUrl);
                const payload = {
                    v: 2,
                    tid: measurementId,
                    npa: 0,
                    dma: 0,
                    tag_exp: 0,
                    cid: clientId,
                    ul: navigator.language.toLowerCase(),
                    sr: window.screen.availWidth + "x" + window.screen.availHeight,
                    uaa: "x86",
                    uab: "64",
                    uafvl: VxGa.getGAUserAgent(),
                    uamb: 0,
                    uam: "",
                    uap: ((_a2 = navigator.userAgentData) == null ? void 0 : _a2.platform) ?? "unknown",
                    uapv: "15.0.0",
                    uaw: 0,
                    are: 1,
                    frm: 0,
                    pscdl: "noapi",
                    _eu: "AAAI",
                    _s: 1,
                    sid: sessionId,
                    sct: 1,
                    seg: 0,
                    dl: encodedCurrentPageUrl,
                    dt: encodeURIComponent(document.title),
                    en: "page_view",
                    ...firstVisit ? {
                        _fv: 1
                    } : {},
                    _nsi: 1,
                    _ss: 1,
                    tfd: VxGa.generateRandomTfd()
                };
                const queryString = Object.keys(payload).map(key => key + "=" + payload[key]).join("&");
                const finalUrl = window.VxGa.buildHitUrl(endpoint, queryString);
                fetch(finalUrl, usesSiteEndpoint ? {
                    method: "GET",
                    mode: "no-cors",
                    credentials: "include"
                } : {
                    method: "GET"
                }).then(response => {}).catch(error => {
                    window.vxLogger.debug("Error in `sendNewSessionHit` for advertiser: ", window.advInfo.id, error);
                    window.vxLogger.trace(error.stack);
                });
            }
        }
        function utmsToString(utmParams = {}) {
            return new URLSearchParams({
                utm_source: utmParams.source || window.alcs,
                utm_campaign: utmParams.name || window.alcn,
                utm_medium: utmParams.medium || "cpl",
                utm_term: utmParams.term || "",
                utm_id: utmParams.id || ""
            }).toString();
        }
        function shouldResetUserByFeatureActivationDate(initialDate, options = {}) {
            const {duration: duration = 30, baseProb: baseProb = .17, maxProb: maxProb = 1, forceResetAfter: forceResetAfter = 30} = options;
            const MS_PER_DAY = 1e3 * 60 * 60 * 24;
            const start = new Date(initialDate).getTime();
            if (!start) return true;
            const daysPassed = Math.floor((Date.now() - start) / MS_PER_DAY);
            if (daysPassed >= forceResetAfter) return true;
            const growthPerDay = (maxProb - baseProb) / (duration - 1);
            const prob = baseProb + growthPerDay * Math.min(daysPassed, duration - 1);
            return Math.random() < prob;
        }
        class VxAdPlacementDomainTracking {
            static async _buildUrlWithParams(isConversionHit, isNewUser2) {
                const baseUrl = `${VOXUS_API_BASE_URL}/track_channel`;
                const vxLastImpression = await VxImpHandler.getVxLastImpression(advInfo.id);
                const kopidPlataform = [ "adse", "en_plataform" ].join("");
                const isConversion = [ "is_conv", "ersion" ].join("");
                const params = {
                    action: "save",
                    adv_id: advInfo.id,
                    ad_placement_domain: vxLastImpression["ad_placement_domain"] ?? "not_tracked",
                    [kopidPlataform]: vxLastImpression["kopid_plataform"] ?? "not_tracked",
                    is_new_user: isNewUser2,
                    [isConversion]: isConversionHit ? 1 : 0
                };
                const urlParams = new URLSearchParams(params);
                return baseUrl + "?" + urlParams.toString();
            }
            static _hasAttributionHit(newUser) {
                const key = "last_ad_placement_domain";
                const adPlacement = VxImpHandler.getCookieLastAdSeenInformation().ad_placement_domain;
                if (newUser) {
                    VxLocalStorageManager.setItem(key, adPlacement);
                    return false;
                }
                if (VxLocalStorageManager.getItem(key) !== null && VxLocalStorageManager.getItem(key) === adPlacement) {
                    return true;
                }
                VxLocalStorageManager.setItem(key, adPlacement);
                return false;
            }
            static _hasConversionHit() {
                const hasConvertedBefore = CookiesVx.get(voxus_key + "_usubida_tracking");
                return hasConvertedBefore === "true";
            }
            static async sendHit(isConversionHit = false) {
                const newUser = isNewUser();
                if (!hasCustomization("send_channel_tracking")) {
                    return;
                }
                const hasHit = isConversionHit ? this._hasConversionHit() : this._hasAttributionHit(newUser);
                if (hasHit || !await VxOtherV2Attr.isVxLastPaidMedia()) {
                    return;
                }
                const url = await this._buildUrlWithParams(isConversionHit, newUser);
                fetch(url, {
                    method: "GET"
                }).then(response => {}).catch(error => {
                    vxLogger.debug("Error in `sendChannelTrackingHit` for advertiser: ", advInfo.id, error);
                    vxLogger.trace(error.stack);
                });
            }
        }
        const PURCHASE_ID_ADVERTISER_IDS = [ "1567", "1700", "1701", "1702", "1703", "1704", "2653", "2781" ];
        class VxDataLayerObserver {
            static observe({matcher: matcher, onMatch: onMatch = null, delay: delay = null, dataLayerName: dataLayerName = null}) {
                const dlName = dataLayerName || this._resolveDataLayerName();
                const pollDelay = delay || this.DEFAULT_DELAY;
                if (!dlName) {
                    vxLogger.debug("VxDataLayerObserver: Could not find dataLayer");
                    return Promise.resolve(null);
                }
                return this._listenUntil(matcher, pollDelay, dlName).then(item => {
                    if (item && onMatch) onMatch(item);
                    return item;
                });
            }
            static observeGA4Event(eventName, {onMatch: onMatch, delay: delay = null, dataLayerName: dataLayerName = null}) {
                return this.observe({
                    matcher: this.matchers.ga4Event(eventName),
                    onMatch: onMatch,
                    delay: delay,
                    dataLayerName: dataLayerName
                });
            }
            static trackPurchaseUrl() {
                const storageKey = "vx_purchase_url_logged";
                if (VxLocalStorageManager.getItem(storageKey)) return;
                this.observeGA4Event("purchase", {
                    onMatch: () => {
                        sendToLoggly({
                            type: "purchase_url",
                            cookie_id: cookie_id,
                            pageview: window.location.href
                        });
                        VxLocalStorageManager.setItem(storageKey, "true");
                    }
                });
            }
            static trackPurchaseId() {
                var _a2;
                try {
                    if (!PURCHASE_ID_ADVERTISER_IDS.includes(String(advInfo.id))) return;
                    const loggedIds = new Set;
                    const scannedUpTo = new Map;
                    const checkDataLayers = () => {
                        try {
                            for (const name of this._resolveAllDataLayerNames()) {
                                const items = window[name];
                                if (!Array.isArray(items)) continue;
                                const from = items.length < (scannedUpTo.get(name) ?? 0) ? 0 : scannedUpTo.get(name) ?? 0;
                                for (let i = from; i < items.length; i++) {
                                    const transactionId = this._readTransactionIdSafely(items[i]);
                                    if (!transactionId || loggedIds.has(transactionId)) continue;
                                    loggedIds.add(transactionId);
                                    this._logPurchaseId(transactionId);
                                }
                                scannedUpTo.set(name, items.length);
                            }
                        } catch (error) {
                            vxLogger.debug("Error in `VxDataLayerObserver.trackPurchaseId` for advertiser: ", advInfo.id, error);
                            vxLogger.trace(error.stack);
                        }
                        VxAsyncWrapper.setTimeout(checkDataLayers, this.DEFAULT_DELAY);
                    };
                    checkDataLayers();
                } catch (error) {
                    vxLogger.debug("Error in `VxDataLayerObserver.trackPurchaseId` for advertiser: ", (_a2 = window.advInfo) == null ? void 0 : _a2.id, error);
                    vxLogger.trace(error.stack);
                }
            }
            static _readTransactionIdSafely(item) {
                try {
                    return this.getTransactionIdFrom(item);
                } catch (error) {
                    vxLogger.debug("Error in `VxDataLayerObserver._readTransactionIdSafely` for advertiser: ", advInfo.id, error);
                    vxLogger.trace(error.stack);
                    return void 0;
                }
            }
            static async _logPurchaseId(transactionId) {
                try {
                    sendToLoggly({
                        action: "vx_purchase_id",
                        advertiser_id: advInfo.id,
                        conv_id: transactionId,
                        cookie_id: cookie_id,
                        user_id: getUserId(getFixedMeasurementId()),
                        actv_paid_media: await VxOtherV2Attr.getActivePaidMedia(),
                        pageview: window.location.href
                    });
                } catch (error) {
                    vxLogger.debug("Error in `VxDataLayerObserver._logPurchaseId` for advertiser: ", advInfo.id, error);
                    vxLogger.trace(error.stack);
                }
            }
            static _resolveAllDataLayerNames() {
                try {
                    const names = (getMeasurementIds() || []).map(measurementId => findDataLayer(measurementId)).filter(Boolean);
                    return new Set([ ...names, "dataLayer" ]);
                } catch (error) {
                    vxLogger.debug("Error in `VxDataLayerObserver._resolveAllDataLayerNames` for advertiser: ", advInfo.id, error);
                    vxLogger.trace(error.stack);
                    return new Set([ "dataLayer" ]);
                }
            }
            static getTransactionIdFrom(item) {
                var _a2, _b2, _c2, _d;
                if (!item || typeof item !== "object") return void 0;
                const gtagPurchase = item[0] === "event" && item[1] === "purchase" ? item[2] : null;
                const candidates = [ item.event !== "refund" ? (_a2 = item.ecommerce) == null ? void 0 : _a2.transaction_id : void 0, gtagPurchase == null ? void 0 : gtagPurchase.transaction_id, (_d = (_c2 = (_b2 = item.ecommerce) == null ? void 0 : _b2.purchase) == null ? void 0 : _c2.actionField) == null ? void 0 : _d.id, item.transactionId ];
                for (const candidate of candidates) {
                    if (typeof candidate === "number" || typeof candidate === "string" && candidate.trim()) {
                        return String(candidate).trim();
                    }
                }
                return void 0;
            }
            static _resolveDataLayerName() {
                const msIds = getMeasurementIds();
                if ((msIds == null ? void 0 : msIds.length) > 0) {
                    return findDataLayer(msIds.at(0)) || "dataLayer";
                }
                return "dataLayer";
            }
            static _listenUntil(eventCheckCallback, delay = 1e3, dataLayerName = "dataLayer") {
                window[dataLayerName] = window[dataLayerName] || [];
                let originalSize = window[dataLayerName].length;
                const previousDataLayerItem = getDataLayerItemWith(eventCheckCallback, dataLayerName);
                if (previousDataLayerItem) return Promise.resolve(previousDataLayerItem);
                return new Promise((resolve, reject) => {
                    function checkDataLayer() {
                        try {
                            if (window[dataLayerName].length === originalSize) {
                                VxAsyncWrapper.setTimeout(checkDataLayer, delay);
                                return;
                            }
                            const itemFound = window[dataLayerName].find(eventCheckCallback);
                            if (itemFound) {
                                resolve(itemFound);
                                return;
                            }
                            originalSize = window[dataLayerName].length;
                            VxAsyncWrapper.setTimeout(checkDataLayer, delay);
                        } catch (error) {
                            vxLogger.debug("Error in `VxDataLayerObserver._listenUntil` for advertiser: ", advInfo.id, error);
                            vxLogger.trace(error.stack);
                            reject(error);
                        }
                    }
                    checkDataLayer();
                });
            }
        }
        __publicField(VxDataLayerObserver, "DEFAULT_DELAY", 1e3);
        __publicField(VxDataLayerObserver, "matchers", {
            ga4Event: eventName => item => (item == null ? void 0 : item.event) === eventName || (item == null ? void 0 : item[1]) === eventName
        });
        class VxAdSeenHandler {
            static async handleAdSeenMessage(data) {
                const response = {
                    kopid: false,
                    kopidck: false,
                    creativekaoq: null
                };
                const cv_lift_ids = data.cv_lift_ids;
                if (Array.isArray(cv_lift_ids) && cv_lift_ids.length > 0) {
                    CookiesVx$1.set(`${window.voxus_key}_cv_lift_cpg`, cv_lift_ids.join(","), {
                        expires: VxDate.addDays(new Date, 30)
                    });
                }
                if (data.voxus_kopid != null && data.voxus_kopid != "") {
                    window.kopid = true;
                    response.kopid = true;
                    const isVxLastPaidMedia = await VxOtherV2Attr$1.isVxLastPaidMedia();
                    if (isVxLastPaidMedia) {
                        let expiredNow = false;
                        try {
                            expiredNow = await VxOtherV2Attr$1.expireIgnoreOtherCookieWhenVoxusLastPaidMedia();
                        } catch (_) {
                            expiredNow = false;
                        }
                        const adSeenParts = data.voxus_kopid.split("-");
                        const lastSeenCreative = adSeenParts[0] || "";
                        const lastSeenCampaign = adSeenParts[1] || "";
                        const impressionTime = data.lastImpressionTimestamp ? parseInt(data.lastImpressionTimestamp, 10) : null;
                        VxImpHandler$1.setAdSeenCookies({
                            impressionTime: impressionTime,
                            lastSeenCreative: lastSeenCreative,
                            lastSeenCampaign: lastSeenCampaign,
                            lastSeenCampaigns: data.segkaoq || "",
                            adPlacementDomain: data.ad_placement_domain || "",
                            adSeenPlatform: data.kopid_plataform || ""
                        });
                        window.creativekaoq = data.voxus_kopid;
                        response.creativekaoq = data.voxus_kopid;
                        if (expiredNow && window.alihuadsa == false) window.sgarq();
                    }
                }
                if (data.voxus_kopidck == "1") {
                    CookiesVx$1.set(window.voxus_key + "_kopidck_pip", "true", {
                        expires: VxDate.addHours(new Date, 1)
                    });
                    response.kopidck = true;
                }
                return response;
            }
            static async handleAssociatedAdvertiserEvent(data, associatedAdvertiserId) {
                if (typeof window.associatedAdvData == "undefined") {
                    return;
                }
                if (!window.associatedAdvData[associatedAdvertiserId]) return;
                try {
                    const resp = await this.handleAdSeenMessage(data);
                    if (resp == null ? void 0 : resp.kopid) {
                        window.associatedAdvData[associatedAdvertiserId].kaoq = true;
                    }
                } catch (_) {}
            }
        }
        class VxCrossDomainBridge {
            static init() {
                if (document.getElementById(this.IFRAME_ID) != null) {
                    return;
                }
                const iframe = document.createElement("iframe");
                iframe.src = __privateMethod(this, _VxCrossDomainBridge_static, buildIframeUrl_fn).call(this);
                iframe.id = this.IFRAME_ID;
                iframe.frameBorder = "0";
                iframe.async = true;
                iframe.width = iframe.height = 1;
                iframe.style = "display:none;visibility:hidden";
                iframe.onload = function() {
                    this.contentWindow.postMessage({
                        type: "voxus_dmp",
                        url: window.location.href,
                        html: document.head.outerHTML + document.body.outerHTML,
                        dataType: "publisher"
                    }, "*");
                };
                if (!__privateGet(this, _messageListenerAttached)) {
                    const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                    const eventer = window[eventMethod];
                    const messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
                    eventer(messageEvent, e => __privateMethod(this, _VxCrossDomainBridge_static, onMessage_fn).call(this, e), false);
                    __privateSet(this, _messageListenerAttached, true);
                }
                const lastChild = document.getElementsByTagName("body")[0].lastChild;
                lastChild.parentNode.insertBefore(iframe, lastChild);
            }
        }
        _messageListenerAttached = new WeakMap;
        _VxCrossDomainBridge_static = new WeakSet;
        buildIframeUrl_fn = function() {
            const indexNckFile = hasCustomization$1("multi_adv_same_adv") ? "index_nckv5" : "index_nckv4";
            return this.TARGETING_BASE_URL + indexNckFile + ".html?12943a233&" + window.VOXUS_RTDT_DATA + `&v=5&nckV=${window.indexNckVersion}`;
        };
        onMessage_fn = function(e) {
            if (typeof e.data != "object") {
                return;
            }
            if (e.data.type == "dataexclude") {
                __privateMethod(this, _VxCrossDomainBridge_static, handleDataExclude_fn).call(this, e.data);
            }
            if (e.data.type == "user") {
                __privateMethod(this, _VxCrossDomainBridge_static, handleUser_fn).call(this, e.data);
            }
            if (e.data.type == "voxus_kopid") {
                VxAdSeenHandler.handleAdSeenMessage(e.data).catch(() => {});
            } else if (hasCustomization$1("multi_adv_same_adv") && typeof e.data.type != "undefined" && e.data.type.startsWith("voxus_kopid_")) {
                const tokensLimit = 3;
                const eventTypeTokens = e.data.type.split("_", tokensLimit);
                if (eventTypeTokens.length === tokensLimit) {
                    const associatedAdvertiserId = eventTypeTokens[tokensLimit - 1];
                    VxAdSeenHandler.handleAssociatedAdvertiserEvent(e.data, associatedAdvertiserId);
                }
            }
        };
        handleDataExclude_fn = function(data) {
            if (data.exclude == "true") {
                CookiesVx$1.set(window.voxus_key + "_dataexclude", "true", {
                    expires: Infinity
                });
            } else {
                CookiesVx$1.expire(window.voxus_key + "_dataexclude");
            }
            window.dataExcludeValidated = true;
        };
        handleUser_fn = function(data) {
            window.cookie_id = data.user_id;
            CookiesVx$1.set(window.voxus_key + "_id", window.cookie_id, {
                expires: VxDate.addHours(new Date, 1)
            });
        };
        __privateAdd(VxCrossDomainBridge, _VxCrossDomainBridge_static);
        __publicField(VxCrossDomainBridge, "IFRAME_ID", "_VOXUS___TARGETING___DATA");
        __publicField(VxCrossDomainBridge, "TARGETING_BASE_URL", "https://targeting.voxus.tv/a/");
        __privateAdd(VxCrossDomainBridge, _messageListenerAttached, false);
        class VxMobileImpressionChecker {
            static async check() {
                var _a2;
                const advertiserIds = VxOtherV2Attr$1.getAttrScopeAdvertiserIds();
                for (const id of advertiserIds) {
                    const isVxLastPaidMedia = await VxOtherV2Attr$1.isVxLastPaidMedia(id);
                    if (!isVxLastPaidMedia) {
                        continue;
                    }
                    await VxOtherV2Attr$1.expireIgnoreOtherCookieWhenVoxusLastPaidMedia();
                    const activePaidMedia = await VxOtherV2Attr$1.getActivePaidMedia(id);
                    window.kopid = true;
                    VxImpHandler$1.setAdSeenCookies({
                        impressionTime: activePaidMedia.time,
                        lastSeenCreative: activePaidMedia.raw.creative,
                        lastSeenCampaign: activePaidMedia.raw.campaign,
                        lastSeenCampaigns: activePaidMedia.raw.campaigns,
                        adPlacementDomain: activePaidMedia.raw.ad_placement_domain || "",
                        adSeenPlatform: activePaidMedia.raw.kopid_plataform || ""
                    });
                    if (hasCustomization$1("multi_adv_same_adv") && ((_a2 = window.associatedAdvData) == null ? void 0 : _a2[id])) {
                        window.associatedAdvData[id].kaoq = true;
                    }
                    if (hasCustomization$1("unify-tf-core-attribution") && window.tfAdvId && id == window.tfAdvId) {
                        window.tfAdvSeen = true;
                    }
                    return true;
                }
                return false;
            }
        }
        class VxSegmentBehaviourDetector {
            static matches() {
                throw new Error("matches must be implemented");
            }
        }
        class VxGoogleAdsBehaviour extends VxSegmentBehaviourDetector {
            static async matches() {
                return await VxOtherV2Attr$1.isGoogleAdsLastPaidMedia();
            }
        }
        class VxOrganicBehaviour extends VxSegmentBehaviourDetector {
            static async matches() {
                const paidMedia = await VxOtherV2Attr$1.getActivePaidMedia();
                if (paidMedia) {
                    return false;
                }
                return true;
            }
        }
        class VxVoxusUserBehaviour extends VxSegmentBehaviourDetector {
            static async matches() {
                if (CookiesVx$1.get(`${window.voxus_key}_usubida_tracking`)) {
                    return true;
                }
                return await VxOtherV2Attr$1.isVxLastPaidMedia();
            }
        }
        class VxNewUserBehaviour extends VxSegmentBehaviourDetector {
            static async matches() {
                const sessionData = VxGa.getGaSessionCookieData();
                if (!sessionData) return false;
                return sessionData.newUser === true;
            }
        }
        class VxReturningUserBehaviour extends VxSegmentBehaviourDetector {
            static async matches() {
                const sessionData = VxGa.getGaSessionCookieData();
                if (!sessionData) return false;
                return sessionData.newUser === false;
            }
        }
        const REGISTERED_BEHAVIOURS = {
            google_ads: VxGoogleAdsBehaviour,
            organic: VxOrganicBehaviour,
            new_user: VxNewUserBehaviour,
            returning_user: VxReturningUserBehaviour
        };
        class VxSegmentBehaviourPixels {
            static async fireMatching(segmentList) {
                const isVoxusUser = await VxVoxusUserBehaviour.matches();
                if (isVoxusUser) return;
                await Promise.all(segmentList.map(async ({segmentName: segmentName, pixelId: pixelId}) => {
                    const detector = REGISTERED_BEHAVIOURS[segmentName];
                    if (await (detector == null ? void 0 : detector.matches())) {
                        addStackAdaptPixelId(pixelId);
                    }
                }));
            }
        }
        const AB_TESTS_CONFIGURATION = {
            ab_test_home: {
                controlSegmentName: "/",
                variantRatio: .5,
                cookieDays: 30,
                version: 1
            }
        };
        const AB_TEST_PREFIX = "ab_test_";
        const BUCKETS = [ "control", "variant" ];
        class VxAbTestSplitter {
            static resolve(entries) {
                var _a2, _b2, _c2, _d;
                let resolved = entries;
                for (const [testKey, config] of Object.entries(AB_TESTS_CONFIGURATION)) {
                    const variants = resolved.filter(entry => entry.segmentName === testKey);
                    if (!variants.length) continue;
                    if (!variants.every(entry => this.hasPixelId(entry))) {
                        (_b2 = (_a2 = window.vxLogger) == null ? void 0 : _a2.debug) == null ? void 0 : _b2.call(_a2, `VxAbTestSplitter: '${testKey}' has no pixelId, falling back to the '${config.controlSegmentName}' control for advertiser:`, window.advInfo.id);
                        resolved = resolved.filter(entry => entry.segmentName !== testKey);
                        continue;
                    }
                    if (!resolved.some(entry => entry.segmentName === config.controlSegmentName)) {
                        (_d = (_c2 = window.vxLogger) == null ? void 0 : _c2.debug) == null ? void 0 : _d.call(_c2, `VxAbTestSplitter: '${testKey}' has no '${config.controlSegmentName}' control entry, skipping test for advertiser:`, window.advInfo.id);
                        resolved = resolved.filter(entry => entry.segmentName !== testKey);
                        continue;
                    }
                    if (this.getOrAssignBucket(testKey, config) === "variant") {
                        resolved = resolved.filter(entry => entry.segmentName !== config.controlSegmentName).map(entry => entry.segmentName === testKey ? {
                            ...entry,
                            segmentName: config.controlSegmentName
                        } : entry);
                    } else {
                        resolved = resolved.filter(entry => entry.segmentName !== testKey);
                    }
                }
                return resolved.filter(entry => {
                    var _a3, _b3;
                    if (!entry.segmentName.startsWith(AB_TEST_PREFIX)) return true;
                    (_b3 = (_a3 = window.vxLogger) == null ? void 0 : _a3.debug) == null ? void 0 : _b3.call(_a3, `VxAbTestSplitter: '${entry.segmentName}' is not configured in AB_TESTS_CONFIGURATION, dropping it for advertiser:`, window.advInfo.id);
                    return false;
                });
            }
            static getOrAssignBucket(testKey, config) {
                const cookieName = this.getCookieName(testKey);
                const stored = this.parseCookie(CookiesVx$1.get(cookieName), config.version);
                if (stored) return stored;
                const bucket = Math.random() < config.variantRatio ? "variant" : "control";
                CookiesVx$1.set(cookieName, `${config.version}:${bucket}`, {
                    expires: VxDate.addDays(new Date, config.cookieDays)
                });
                return bucket;
            }
            static hasPixelId(entry) {
                return typeof entry.pixelId === "string" && entry.pixelId.trim() !== "";
            }
            static getCookieName(testKey) {
                return `vx_ab_${testKey}_${window.advInfo.id}`;
            }
            static parseCookie(value, version) {
                const parts = (value ?? "").split(":");
                if (parts.length !== 2) return null;
                const [storedVersion, bucket] = parts;
                if (storedVersion !== String(version)) return null;
                return BUCKETS.includes(bucket) ? bucket : null;
            }
        }
        const MEDIA_MATH_ADVERTISER_IDS = [ "2321", "1421", "2653" ];
        const BOTTOM_FUNNEL_SEGMENTS = [ "/cart", "/carrinho", "/checkout" ];
        class VxPixelReloader {
            static async reload() {
                await __privateMethod(this, _VxPixelReloader_static, fireAdvertiserPixels_fn).call(this);
                __privateMethod(this, _VxPixelReloader_static, trackConversionPages_fn).call(this);
            }
        }
        _VxPixelReloader_static = new WeakSet;
        fireAdvertiserPixels_fn = async function() {
            const clientId = window.advInfo.id;
            __privateMethod(this, _VxPixelReloader_static, executeAddPixelsForDsp_fn).call(this, "dv_360");
            await __privateMethod(this, _VxPixelReloader_static, executeAddPixelsForDsp_fn).call(this, "stack_adapt");
            if (MEDIA_MATH_ADVERTISER_IDS.includes(clientId) && typeof window.addMediaMathPixel === "function") {
                window.addMediaMathPixel(clientId);
            }
        };
        getPixelsDataForDsp_fn = function(dspType) {
            const dspSegmentsMap = tagConfig.dspSegmentsMap;
            const segmentList = dspSegmentsMap == null ? void 0 : dspSegmentsMap[dspType];
            if (!segmentList || !Array.isArray(segmentList)) {
                return [];
            }
            return segmentList;
        };
        isOnBottomFunnelPage_fn = function() {
            const currentUrl = window.location.href.toLowerCase();
            return BOTTOM_FUNNEL_SEGMENTS.some(segment => currentUrl.includes(segment));
        };
        splitBySegmentType_fn = function(segmentList) {
            return segmentList.reduce(([pathSegments, behaviourSegments], entry) => {
                if (entry.segmentName.startsWith("/")) {
                    pathSegments.push(entry);
                } else {
                    behaviourSegments.push(entry);
                }
                return [ pathSegments, behaviourSegments ];
            }, [ [], [] ]);
        };
        executeAddPixelsForDsp_fn = async function(dspType) {
            let dspSegmentsList = __privateMethod(this, _VxPixelReloader_static, getPixelsDataForDsp_fn).call(this, dspType);
            const addDspPixelFunctionMap = {
                stack_adapt: window.addStackAdaptPixelIdIfOnSegmentPage,
                dv_360: window.addDV360PixelIdIfOnSegmentPage
            };
            if (dspType === "stack_adapt") {
                dspSegmentsList = VxAbTestSplitter.resolve(dspSegmentsList);
                const [pathSegments, behaviourSegments] = __privateMethod(this, _VxPixelReloader_static, splitBySegmentType_fn).call(this, dspSegmentsList);
                await VxSegmentBehaviourPixels.fireMatching(behaviourSegments);
                dspSegmentsList = pathSegments;
            }
            const selectedPixelFunction = addDspPixelFunctionMap[dspType];
            if (typeof selectedPixelFunction !== "function") {
                return;
            }
            dspSegmentsList.forEach(pixelObject => {
                const isStackAdaptCheckout = dspType === "stack_adapt" && pixelObject.segmentName === "/checkout";
                if (!isStackAdaptCheckout) {
                    selectedPixelFunction(pixelObject);
                    return;
                }
                if (__privateMethod(this, _VxPixelReloader_static, isOnBottomFunnelPage_fn).call(this)) {
                    window.addStackAdaptPixelId(pixelObject.pixelId);
                }
            });
        };
        trackConversionPages_fn = function() {
            const usubidaPages = window.usubidaPages;
            for (let i = 0; i < usubidaPages.length; i++) {
                if (window.decodeURLComponentEscaped(window.location.href.replace("#", "")).indexOf(usubidaPages[i]) === -1) {
                    continue;
                }
                const data = {};
                data.pageview = window.location.href.replace("#", "");
                data.kopidcooked = window.kopidCooked;
                data.kopidpip = window.kopid;
                data.sgotasdkaoq = CookiesVx$1.get(window.voxus_key + "_seg_kaoq");
                data.mobile = window.ismobile;
                data.creative = window.creativekaoq;
                data.other = window.isFromOther();
                data.ga = window.alihuadsa;
                data.adv_id = window.advInfo.id;
                data.cv = "true";
                const queryString = Object.keys(data).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])).join("&");
                const urlTrackerVx = window.VOXUS_API_BASE_URL + "/track.png?" + queryString;
                const httptrk = new XMLHttpRequest;
                httptrk.open("GET", urlTrackerVx, true);
                httptrk.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                httptrk.send();
                VxAdPlacementDomainTracking.sendHit(true);
                CookiesVx$1.set(window.voxus_key + "_usubida_tracking", true, {
                    expires: VxDate.addDays(new Date, 7)
                });
            }
        };
        __privateAdd(VxPixelReloader, _VxPixelReloader_static);
        class VxSecondaryDimensionChecker {
            static processAll() {
                if (window.tagConfig.secundaryDimension !== 1 && window.tagConfig.secundaryDimension !== 2) {
                    return;
                }
                this.processCore();
                this.processTopFunnel();
            }
            static async processCore() {
                if (!hasCustomization$1("ds_hit")) {
                    return;
                }
                const response = await VxImpHandler$1.getVerifyTrackData(window.advInfo.id, window.cookie_id, true);
                if (!response || !response.data || response.data.length === 0) {
                    return;
                }
                const campaigns = __privateMethod(this, _VxSecondaryDimensionChecker_static, filterValidCampaigns_fn).call(this, response.data, {
                    defaultDays: __privateMethod(this, _VxSecondaryDimensionChecker_static, getCustomDimensionRtgAttributionDays_fn).call(this)
                });
                if (campaigns.length > 0) {
                    VxGA4Attr.sendEventScopedCustomDimensionProperty(window.dsName);
                    window.analyticsAttributionHitsSentOnPage.ds = true;
                }
            }
            static async processTopFunnel() {
                if (!hasCustomization$1("tf_ds_hit") || (window.tfAdvId == 0 || window.tfAdvId == void 0 || window.tfAdvId == null || window.tfCpgId == 0 || window.tfCpgId == void 0 || window.tfCpgId == null)) {
                    return;
                }
                const response = await VxImpHandler$1.getVerifyTrackData(window.tfAdvId, window.cookie_id, true);
                if (!response || !response.data || response.data.length === 0) {
                    return;
                }
                const tfIds = __privateMethod(this, _VxSecondaryDimensionChecker_static, getTopFunnelLiftCampaigns_fn).call(this, window.tfCpgId);
                const campaigns = __privateMethod(this, _VxSecondaryDimensionChecker_static, filterValidCampaigns_fn).call(this, response.data, {
                    topFunnelCampaignIds: tfIds,
                    defaultDays: 30
                });
                if (campaigns.length > 0) {
                    VxGA4Attr.sendEventScopedCustomDimensionProperty(window.tfDsName);
                    window.analyticsAttributionHitsSentOnPage.tfDs = true;
                }
            }
        }
        _VxSecondaryDimensionChecker_static = new WeakSet;
        filterValidCampaigns_fn = function(responseData, {topFunnelCampaignIds: topFunnelCampaignIds = null, defaultDays: defaultDays}) {
            const validCampaigns = [];
            for (let q = 0; q < responseData.length; q++) {
                const dateImpact = new Date(responseData[q].dateTz || responseData[q].date);
                const diffHours = (new Date - dateImpact) / 1e3 / 60 / 60;
                const cpgId = responseData[q].campaign;
                let maxHours;
                if (cpgId == "11392") {
                    maxHours = 24 * window.tagConfig.lookalikeDays;
                } else if (cpgId == "11393") {
                    maxHours = 24 * window.tagConfig.rmktDays;
                } else if (topFunnelCampaignIds && topFunnelCampaignIds.includes(cpgId)) {
                    maxHours = 24 * window.tagConfig.rmktDays;
                } else {
                    maxHours = 24 * defaultDays;
                }
                if (diffHours <= maxHours) {
                    validCampaigns.push(cpgId);
                }
            }
            return validCampaigns;
        };
        getCustomDimensionRtgAttributionDays_fn = function() {
            return window.advInfo.id === "2753" ? 1 : 30;
        };
        getTopFunnelLiftCampaigns_fn = function(mainCpgId) {
            let ids = [];
            if (window.tfAdvId === 2797) {
                ids = [ 27372121, 27372348 ];
            }
            ids.push(mainCpgId);
            return ids;
        };
        __privateAdd(VxSecondaryDimensionChecker, _VxSecondaryDimensionChecker_static);
        class VxCookieStateLoader {
            static load() {
                __privateMethod(this, _VxCookieStateLoader_static, loadCookieId_fn).call(this);
                __privateMethod(this, _VxCookieStateLoader_static, loadTestingFlag_fn).call(this);
                __privateMethod(this, _VxCookieStateLoader_static, loadConvertedFlag_fn).call(this);
                __privateMethod(this, _VxCookieStateLoader_static, loadAdSeenState_fn).call(this);
                __privateMethod(this, _VxCookieStateLoader_static, loadAdClickState_fn).call(this);
                __privateMethod(this, _VxCookieStateLoader_static, loadIgnoreFullGa_fn).call(this);
                __privateMethod(this, _VxCookieStateLoader_static, handleTestingQueryParam_fn).call(this);
                __privateMethod(this, _VxCookieStateLoader_static, loadIgnoreCookie_fn).call(this);
            }
        }
        _VxCookieStateLoader_static = new WeakSet;
        loadCookieId_fn = function() {
            if (typeof CookiesVx$1.get(window.voxus_key + "_id") !== "undefined") {
                window.cookie_id = CookiesVx$1.get(window.voxus_key + "_id");
            }
        };
        loadTestingFlag_fn = function() {
            if (CookiesVx$1.get(window.voxus_key + "_voxus_testing") === "true") {
                window.igvxtst = true;
            }
        };
        loadConvertedFlag_fn = function() {
            if (CookiesVx$1.get(window.voxus_key + "_converted_gl") === "true") {
                window.converted_gl = window.advInfo.id * 12;
            }
        };
        loadAdSeenState_fn = function() {
            const kopidDbm = CookiesVx$1.get(window.voxus_key + "_kopid_pip");
            if (kopidDbm == "" || typeof kopidDbm === "undefined") {
                return;
            }
            if (CookiesVx$1.get(window.voxus_key + "_inter_view") !== "true") ;
            window.kopid = true;
            window.kopidCooked = true;
            window.creativekaoq = VxImpHandler$1.getCookieLastAdSeenInformation().creative;
            const sgotasdkaoqsplit = window.creativekaoq.split("-");
            if (sgotasdkaoqsplit.length > 1) {
                window.sgotasdkaoq = sgotasdkaoqsplit[1];
            }
        };
        loadAdClickState_fn = function() {
            if (CookiesVx$1.get(window.voxus_key + "_adinter_pip") === "true") {
                window.adinter = true;
            }
        };
        loadIgnoreFullGa_fn = function() {
            if (CookiesVx$1.get(window.voxus_key + "_ignore_full_ugi") === "true") {
                window.sent_usubida = true;
            }
        };
        handleTestingQueryParam_fn = function() {
            if (window.getParameterByNameVx__("voxus_testing") == 1) {
                CookiesVx$1.set(window.voxus_key + "_voxus_testing", "true", {
                    expires: VxDate.addDays(new Date, 365 * 20)
                });
                window.igvxtst = true;
            }
        };
        loadIgnoreCookie_fn = function() {
            if (CookiesVx$1.get(window.voxus_key + "_ignore") === "true") {
                window.igvxtst = true;
            }
        };
        __privateAdd(VxCookieStateLoader, _VxCookieStateLoader_static);
        class VxIgnoredPageHandler {
            static check() {
                const igpgs = window.igpgs;
                for (let i = 0; i < igpgs.length; i++) {
                    if (window.decodeURLComponentEscaped(window.location.href).indexOf(igpgs[i]) === -1) {
                        continue;
                    }
                    window.converted_gl = 12 * window.advInfo.id;
                    CookiesVx$1.set(window.voxus_key + "_converted_gl", "true", {
                        expires: VxDate.addDays(new Date, 1)
                    });
                    CookiesVx$1.expire(window.voxus_key + "_convert_");
                    CookiesVx$1.expire(window.voxus_key + "_campaign_");
                    CookiesVx$1.expire(window.voxus_key + "_kopid_uh_pip");
                    CookiesVx$1.expire(window.voxus_key + "_kopid_pip");
                    CookiesVx$1.expire(window.voxus_key + "_adinter_pip");
                    CookiesVx$1.expire(window.voxus_key + "_prospect_ip");
                    CookiesVx$1.expire(window.voxus_key + "_prospect");
                    CookiesVx$1.expire(window.voxus_key + "_attributed");
                    CookiesVx$1.expire(window.voxus_key + "_cooked");
                    window.igvxtst = true;
                }
            }
        }
        const _VxTagVersion = class _VxTagVersion {
            static getInfo() {
                const buildVersion = typeof window.tagVersion === "string" ? window.tagVersion : "none";
                const semanticVersion = typeof window.tagSemanticVersion === "string" ? window.tagSemanticVersion : "none";
                const deployedSuffix = this.getDeployedSuffix();
                return {
                    buildVersion: buildVersion,
                    semanticVersion: semanticVersion,
                    displayVersion: `${semanticVersion}-${deployedSuffix}`,
                    deployedSuffix: deployedSuffix
                };
            }
            static getDeployedSuffix() {
                var _a2;
                if (this._suffix !== null) return this._suffix;
                const src = ((_a2 = document.currentScript) == null ? void 0 : _a2.src) ?? "";
                if (!src) {
                    this._suffix = "vunknown";
                    return this._suffix;
                }
                const match = src.match(/_(v\d+(?:\.\d+)*)9\.js/) ?? src.match(/_(v\d+(?:\.\d+)*)\.js/);
                this._suffix = (match == null ? void 0 : match[1]) ?? "v1";
                return this._suffix;
            }
            static _resetCache() {
                this._suffix = null;
            }
        };
        _VxTagVersion._suffix = null;
        let VxTagVersion = _VxTagVersion;
        const _VxIpBlockList = class _VxIpBlockList {
            static isBlocked(clientId, ip) {
                if (!clientId || !ip) return false;
                const entries = this.blocks.get(clientId);
                if (!entries) return false;
                return entries.some(entry => this.matches(ip, entry));
            }
            static matches(ip, entry) {
                return entry.includes("/") ? this.isInCidr(ip, entry) : ip === entry;
            }
            static isInCidr(ip, cidr) {
                const [range, bitsStr] = cidr.split("/");
                const bits = parseInt(bitsStr, 10);
                if (Number.isNaN(bits) || bits < 0 || bits > 32) return false;
                const ipInt = this.ipToInt(ip);
                const rangeInt = this.ipToInt(range);
                if (Number.isNaN(ipInt) || Number.isNaN(rangeInt)) return false;
                const mask = bits === 0 ? 0 : ~((1 << 32 - bits) - 1) >>> 0;
                return (ipInt & mask) === (rangeInt & mask);
            }
            static ipToInt(ip) {
                const parts = ip.split(".");
                if (parts.length !== 4) return NaN;
                let result = 0;
                for (const part of parts) {
                    const n = parseInt(part, 10);
                    if (Number.isNaN(n) || n < 0 || n > 255 || String(n) !== part) return NaN;
                    result = (result << 8) + n;
                }
                return result >>> 0;
            }
        };
        _VxIpBlockList.blocks = new Map([ [ "1759", [ "179.136.39.119", "45.190.109.158", "23.22.146.56" ] ], [ "2383", [ "187.72.24.120/29", "201.57.128.192/28", "186.216.198.96/29", "186.216.198.32/29", "200.255.25.128/28", "187.16.106.56/29", "200.170.225.148/30", "201.45.59.96/28", "138.59.150.216/30", "186.227.56.84/30", "201.55.112.236/30", "200.170.226.248/30", "201.73.187.32/28", "187.102.175.80/29", "201.73.186.224/28", "200.170.226.92/30", "201.38.66.64/28", "177.184.206.172/30", "186.227.55.44/30", "200.201.137.56/30", "200.211.198.16/28", "200.188.216.120/29", "201.48.144.184/29", "200.155.167.88/29", "200.183.70.48/29", "200.170.210.160/29", "187.92.77.112/29" ] ] ]);
        let VxIpBlockList = _VxIpBlockList;
        let VxGtag$1 = (_c = class {
            static event(name, params) {
                try {
                    _c.getGtag()("event", name, params);
                } catch {}
            }
            static getGtag() {
                var _a2;
                if (_c.vxGtag !== null) return _c.vxGtag;
                if (typeof gtag === "function") {
                    _c.vxGtag = gtag;
                } else if ((_a2 = window.hasCustomization) == null ? void 0 : _a2.call(window, "multi_data_layer")) {
                    _c.vxGtag = _c.buildMultiDataLayerSender();
                } else {
                    window.dataLayer = window.dataLayer ?? [];
                    _c.vxGtag = function() {
                        window.dataLayer.push(arguments);
                    };
                }
                return _c.vxGtag;
            }
            static buildMultiDataLayerSender() {
                var _a2, _b2;
                const tagIds = ((_a2 = window.getMeasurementIds) == null ? void 0 : _a2.call(window)) ?? [];
                const dataLayerNames = new Set([ "dataLayer" ]);
                for (const tagId of tagIds) {
                    const dlName = (_b2 = window.findDataLayer) == null ? void 0 : _b2.call(window, tagId);
                    if (dlName) dataLayerNames.add(dlName);
                }
                const dlWindow = window;
                for (const dlName of dataLayerNames) {
                    if (!Array.isArray(dlWindow[dlName])) dlWindow[dlName] = [];
                }
                return function() {
                    for (const dlName of dataLayerNames) {
                        dlWindow[dlName].push(arguments);
                    }
                };
            }
        }, _c.vxGtag = null, _c);
        function decodeURLComponentEscaped(url) {
            try {
                return decodeURIComponent(escape(url));
            } catch (e) {
                return url;
            }
        }
        function getParameterByNameVx__(name) {
            return new URLSearchParams(location.search).get(name) ?? "";
        }
        class VxNativePromise {
            static getNativePromise() {
                if (__privateGet(this, _cachedNativePromise)) return __privateGet(this, _cachedNativePromise);
                const native = __privateMethod(this, _VxNativePromise_static, extractNativePromiseFromIframe_fn).call(this);
                __privateSet(this, _cachedNativePromise, native ?? window.Promise);
                return __privateGet(this, _cachedNativePromise);
            }
            static _resetCacheForTests() {
                __privateSet(this, _cachedNativePromise, null);
            }
            static allSettled(values) {
                return this.getNativePromise().allSettled(values);
            }
        }
        _cachedNativePromise = new WeakMap;
        _VxNativePromise_static = new WeakSet;
        extractNativePromiseFromIframe_fn = function() {
            var _a2, _b2, _c2, _d;
            try {
                const iframe = document.createElement("iframe");
                iframe.style.display = "none";
                (document.body || document.documentElement).appendChild(iframe);
                const contentWindow = iframe.contentWindow;
                const nativePromise = (contentWindow == null ? void 0 : contentWindow.Promise) ?? null;
                iframe.remove();
                if (typeof nativePromise !== "function" || typeof nativePromise.allSettled !== "function") {
                    return null;
                }
                return nativePromise;
            } catch (e) {
                (_b2 = (_a2 = window.vxLogger) == null ? void 0 : _a2.debug) == null ? void 0 : _b2.call(_a2, "Error in `VxNativePromise.getNativePromise`:", window.advInfo.id, e);
                (_d = (_c2 = window.vxLogger) == null ? void 0 : _c2.trace) == null ? void 0 : _d.call(_c2, e.stack);
                return null;
            }
        };
        __privateAdd(VxNativePromise, _VxNativePromise_static);
        __privateAdd(VxNativePromise, _cachedNativePromise, null);
        window.VxLogger = VxLogger;
        window.VxLogTransport = VxLogTransport;
        window.VxAsyncWrapper = VxAsyncWrapper$1;
        window.VxDate = VxDate;
        window.VxPageCache = VxPageCache;
        window.CookiesVx = CookiesVx$1;
        window.VxFingerprint = VxFingerprint;
        window.VOXUS_API_BASE_URL = "https://api.voxus.tv";
        window.vxLogger = new VxLogger(typeof VOXUS_DEBUG !== "undefined" && VOXUS_DEBUG);
        window.vxPageCache = new VxPageCache;
        window.hasCustomization = hasCustomization$1;
        window.decodeURLComponentEscaped = decodeURLComponentEscaped;
        window.getParameterByNameVx__ = getParameterByNameVx__;
        window.VxAdobeAttr = VxAdobeAttr;
        window.VxNemuAttr = VxNemuAttr;
        window.VxPlausibleAttr = VxPlausibleAttr;
        window.VxVtexAttr = VxVtexAttr;
        window.VxVtexIOAttr = VxVtexIOAttr;
        window.VxRdstationCookieBased = VxRdstationCookieBased;
        window.UtmParamsHandler = UtmParamsHandler$1;
        window.VxAttrOnClickUtmHandler = VxAttrOnClickUtmHandler;
        window.VxOtherV2Attr = VxOtherV2Attr$1;
        window.VxImpHandler = VxImpHandler$1;
        window.VxResetLookupWindow = VxResetLookupWindow;
        window.VxGA4Attr = VxGA4Attr;
        window.VxGa = VxGa;
        window.VxAdPlacementDomainTracking = VxAdPlacementDomainTracking;
        window.VxDataLayerObserver = VxDataLayerObserver;
        window.VxCrossDomainBridge = VxCrossDomainBridge;
        window.VxMobileImpressionChecker = VxMobileImpressionChecker;
        window.VxPixelReloader = VxPixelReloader;
        window.VxSegmentBehaviourPixels = VxSegmentBehaviourPixels;
        window.VxAbTestSplitter = VxAbTestSplitter;
        window.VxSecondaryDimensionChecker = VxSecondaryDimensionChecker;
        window.VxCookieStateLoader = VxCookieStateLoader;
        window.VxIgnoredPageHandler = VxIgnoredPageHandler;
        window.VxLocalStorageManager = VxLocalStorageManager;
        window.VxTagVersion = VxTagVersion;
        window.VxDomainAllowlist = VxDomainAllowlist;
        window.VxIpBlockList = VxIpBlockList;
        window.VxGtag = VxGtag$1;
        window.VxNativePromise = VxNativePromise;
        VxTagVersion.getDeployedSuffix();
    })();
    function getDataLayerItemWith(eventCheckCallback, dataLayerName = "dataLayer") {
        for (const dataLayerItem of window[dataLayerName]) {
            if (eventCheckCallback(dataLayerItem)) {
                return dataLayerItem;
            }
        }
        return null;
    }
    function isFromOther() {
        if (typeof CookiesVx === "undefined") return false;
        if (typeof voxus_key !== "string" || !voxus_key.length) return false;
        const isOther = CookiesVx.get(voxus_key + "_ignoreot_full");
        return typeof isOther !== "undefined" && isOther?.trim().toLowerCase() === "true";
    }
    function setisicgt(i) {
        isicgt = i;
    }
    function getHardCodedMeasurementIds() {
        const manualClientTrackingMap = new Map([ [ "2726", [ "G-JPJPRSDB9K" ] ], [ "1852", [ "G-ZM0BG28WWR" ] ], [ "2859", [ "G-ZQG965CFCJ" ] ], [ "2783", [ "G-NM6XDMNB2W" ] ], [ "1985", [ "G-SZ828V6WSK" ] ], [ "2701", [ "DC-11379620", "G-WCFX1FQ26K", "AW-804145559" ] ], [ "1948", [ "G-78EPY23H13", "G-7HNMFXJ8J5", "G-B0521B3853", "G-HMCQCM5KQ1", "G-NY5NGVZ1KQ", "G-S02H216ES2" ] ], [ "1879", [ "G-PYGGC1W2VQ" ] ], [ "2900", [ "G-4CZX459Q1Q", "G-G5LR3WEXK4" ] ], [ "1598", [ "corebiz_google_app", "G-TCKVZX1BJB", "G-HN1RYJHPJ7" ] ] ]);
        return manualClientTrackingMap.get(advInfo.id) || [];
    }
    function getMeasurementIdsFromGtm() {
        if (typeof google_tag_manager === "undefined") {
            return [];
        }
        const allOptions = Object.keys(google_tag_manager);
        if (allOptions.length === 0) {
            return [];
        }
        return allOptions.filter(option => option.substring(0, 2) === "G-");
    }
    function getMeasurementIdsFromGtmDestination() {
        if (typeof google_tag_data === "undefined" || !google_tag_data?.tidr?.destination) {
            return [];
        }
        const mainDestinations = Object.keys(google_tag_data.tidr.destination).filter(item => item.startsWith("G-"));
        const secondDestinations = Object.keys(google_tag_data.tidr.destinationArray).filter(item => item.startsWith("G-"));
        return mainDestinations.concat(secondDestinations);
    }
    function getMeasurementIds() {
        if (!hasCustomization("ga_hit")) {
            return [];
        }
        const mIdsSet = new Set([ ...getHardCodedMeasurementIds(), ...getMeasurementIdsFromGtm(), ...getMeasurementIdsFromGtmDestination() ]);
        return [ ...mIdsSet ];
    }
    function getFixedMeasurementId() {
        return VxGa.getFixedMeasurementId();
    }
    function isMeasurementIdValid(measurementId) {
        return VxGa.isMeasurementIdValid(measurementId);
    }
    function parseGaMainCookie() {
        const key = [ "_", "ga" ].join("");
        const fullCookie = CookiesVx.get(key);
        if (!fullCookie) {
            return null;
        }
        const splited = fullCookie.split(".");
        const userId = `${splited[2]}.${splited[3]}`;
        return {
            key: key,
            value: fullCookie,
            timestamp: splited[3],
            userId: userId
        };
    }
    function getGaSessionCookieData(measurementId) {
        if (!measurementId) {
            return null;
        }
        const key = [ "_", "ga_" ].join("") + measurementId.slice(2);
        const fullCookie = CookiesVx.get(key);
        if (!fullCookie) {
            return null;
        }
        const mainCookie = parseGaMainCookie();
        if (!mainCookie) {
            return null;
        }
        const isSessionCookieNewVersion = isGS2Implementation(fullCookie);
        return {
            key: key,
            value: fullCookie,
            userId: mainCookie.userId,
            userTimestamp: mainCookie.timestamp,
            sessionId: getGaCookieSessionId(isSessionCookieNewVersion, fullCookie),
            sessionLastInteraction: getSessionLastInteraction(isSessionCookieNewVersion, fullCookie),
            sessionCount: getSessionCount(isSessionCookieNewVersion, fullCookie),
            newUser: getSessionNewUser(isNewGaSessionCookie, fullCookie)
        };
    }
    function isGS2Implementation(fullCookie) {
        return fullCookie.startsWith("GS2");
    }
    function getGaCookieSessionId(isNewVersion, fullCookie) {
        if (isNewVersion) {
            const splited = fullCookie.split("$");
            const sessionIdPart = splited.find(p => p.includes(".s"));
            return sessionIdPart ? sessionIdPart.split(".s")[1] : null;
        }
        return fullCookie.split(".")[2];
    }
    function getSessionLastInteraction(isNewVersion, fullCookie) {
        if (isNewVersion) {
            const splited = fullCookie.split("$");
            return splited.find(p => p.startsWith("t"))?.substring(1) || null;
        }
        return fullCookie.split(".")[5];
    }
    function getSessionCount(isNewVersion, fullCookie) {
        if (isNewVersion) {
            const splited = fullCookie.split("$");
            const sessionCountPart = splited.find(p => p.startsWith("o"));
            return sessionCountPart ? sessionCountPart.substring(1) : null;
        }
        return fullCookie.split(".")[3];
    }
    function getSessionNewUser(isNewVersion, fullCookie) {
        if (isNewVersion) {
            const splited = fullCookie.split("$");
            const newUserPart = splited.find(p => p.startsWith("o"));
            return newUserPart ? newUserPart.substring(1) === "1" : false;
        }
        return fullCookie.split(".")[3] === "1";
    }
    function expireCookie(cookieKey) {
        CookiesVx.set(cookieKey, "", {
            expires: new Date(0).toGMTString()
        });
    }
    function isNewGaSessionCookie(measurementId) {
        return VxGa.isNewGaSessionCookie(measurementId);
    }
    function isNewUser() {
        return VxGa.isNewUser();
    }
    function resetGa4User(measurementId) {
        const gaCookiedata = getGaSessionCookieData(measurementId);
        if (isNewUser()) {
            expireCookie(gaCookiedata.key);
        }
    }
    function modifyGa4SessionCookie({measurementId: measurementId, newTimestamp: newTimestamp}) {
        const gaCookiedata = getGaSessionCookieData(measurementId);
        if (!gaCookiedata) {
            return;
        }
        if (!gaCookiedata.sessionLastInteraction) {
            return;
        }
        const oldLastInteraction = `t${gaCookiedata.sessionLastInteraction}`;
        const newLastInteraction = `t${newTimestamp}`;
        const newGaSessionCookie = gaCookiedata.value.replace(oldLastInteraction, newLastInteraction);
        CookiesVx.set(gaCookiedata.key, newGaSessionCookie, {
            expires: VxDate.addDays(new Date, 729).toGMTString()
        });
    }
    function getLastDataLayerEventName() {
        if (!Array.isArray(window.dataLayer) || window.dataLayer.length === 0) {
            return;
        }
        const lastEvent = window.dataLayer.at(-1);
        if (!lastEvent) {
            return;
        }
        return lastEvent[1] ?? lastEvent.event;
    }
    function sendToLoggly(data) {
        fetch("https://logs-01.loggly.com/inputs/27cf9a30-eb89-41a7-ba82-3280d33fb2cf/tag/https/", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
            body: JSON.stringify(data)
        }).catch(function(error) {
            vxLogger.debug("Error in `sendToLoggly` for advertiser: ", advInfo.id, error);
            vxLogger.trace(error.stack);
        });
    }
    function reportAppMatchPixel(pixelId) {
        const STUDY_PIXELS = [ "h2Plr8koTIZ1eO15hLkBc6" ];
        if (STUDY_PIXELS.indexOf(pixelId) === -1) {
            return;
        }
        sendToLoggly({
            action: "vx_app_match_pixel",
            advertiser_id: advInfo.id,
            cookie_id: cookie_id,
            pixel_id: pixelId,
            ua: navigator.userAgent || "",
            ts: Math.floor(Date.now() / 1e3)
        });
    }
    function getUserSessionData(measurementId = null) {
        if (!measurementId) {
            measurementId = getMeasurementIds()[0];
        }
        let vxSessionId = CookiesVx.get("vx_session_id");
        let gaSessionData = getGaSessionCookieData(measurementId);
        if (!gaSessionData) return null;
        let gaCurrentSession = gaSessionData.userId;
        if (typeof vxSessionId == "undefined" || vxSessionId != gaCurrentSession) {
            refreshVoxusSession(gaSessionData);
        }
        let currentEpochTime = parseInt(Date.now() / 1e3);
        let sessionTime = currentEpochTime - CookiesVx.get("vx_session_start");
        let vxSessionPagesQt = parseInt(CookiesVx.get("vx_session_pages_qt"));
        vxSessionPagesQt = vxSessionPagesQt + 1;
        CookiesVx.set("vx_session_pages_qt", parseInt(vxSessionPagesQt));
        return {
            vx_session_id: vxSessionId,
            session_time: sessionTime,
            vx_session_pages_qt: vxSessionPagesQt
        };
    }
    function refreshVoxusSession(gaSessionData) {
        let user_id = gaSessionData.userId;
        let session_id = gaSessionData.sessionId;
        CookiesVx.set("vx_session_id", user_id);
        CookiesVx.set("vx_session_start", session_id);
        CookiesVx.set("vx_session_pages_qt", 0);
    }
    function addPixel(url, isReferrerPolicy = false) {
        const px = document.createElement("img");
        px.src = url;
        px.width = 1;
        px.height = 1;
        px.style = "display:none;visibility:hidden";
        if (isReferrerPolicy) {
            px.referrerPolicy = "unsafe-url";
        }
        const body = document.getElementsByTagName("body")[0];
        if (body) {
            body.appendChild(px);
        } else {
            document.addEventListener("DOMContentLoaded", () => {
                document.body.appendChild(px);
            });
        }
    }
    function addMediaMathPixel(advertiser_id) {
        const mediaMathAdvertiserTags = {
            2321: "https://pixel.mathtag.com/event/js?mt_id=1655596&mt_adid=430561&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=",
            1421: "https://pixel.mathtag.com/event/js?mt_id=1655610&mt_adid=430575&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=",
            2653: "https://pixel.mathtag.com/event/js?mt_id=1657731&mt_adid=431376&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3="
        };
        addPixel(mediaMathAdvertiserTags[advertiser_id]);
    }
    function addStackAdaptPixelId(pixelId) {
        const stackAdaptBasePixelUrl = "https://tags.srv.stackadapt.com/rt?sid=";
        addPixel(stackAdaptBasePixelUrl + pixelId);
        reportAppMatchPixel(pixelId);
    }
    function addStackAdaptPixelIdIfOnSegmentPage({pixelId: pixelId, segmentName: segmentName}) {
        if (location.href.includes(segmentName)) {
            addStackAdaptPixelId(pixelId);
        }
    }
    function addDV360PixelIdIfOnSegmentPage({pixelId: pixelId, segmentName: segmentName}) {
        let axel = Math.random() + "";
        let a = axel * 1e13;
        const dv360BaseUrl = "https://ad.doubleclick.net/ddm/activity/src=14508565;type=invmedia;cat=";
        let dv360Params = ";dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=0;gdpr=0;ord=";
        if (advInfo.id === "1567") {
            dv360Params = ";dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=0;gdpr=1;gdpr_consent=CQgSLEAQgSLEAPoABABGCTEAALAAAAAAAAAAF5wAQF5gXnABAXmAAAAA.QF5wAQF5gAAA.IF5wAQF5gAAA;ord=";
        }
        const DV360PixelUrl = dv360BaseUrl + pixelId + dv360Params + a;
        if (location.href.includes(segmentName)) {
            addPixel(DV360PixelUrl);
        }
    }
    function updateSessionTime(sessionTime) {
        let vxSessionId = CookiesVx.get("vx_session_id");
        if (typeof vxSessionId == "undefined") return;
        let sessions = typeof CookiesVx.get("vx_user_sessions") !== "undefined" ? JSON.parse(CookiesVx.get("vx_user_sessions")) : {};
        const currentTime = Math.floor(Date.now() / 1e3);
        sessions[vxSessionId] = {
            sessionTime: sessionTime,
            timestamp: currentTime
        };
        removeExpiredFromUserSessionTime(sessions);
    }
    function removeExpiredFromUserSessionTime(sessions) {
        const days = 4;
        const SESSION_TTL = days * 24 * 60 * 60;
        const currentTime = Math.floor(Date.now() / 1e3);
        Object.keys(sessions).forEach(id => {
            if (currentTime - sessions[id].timestamp >= SESSION_TTL) {
                delete sessions[id];
            }
        });
        CookiesVx.set("vx_user_sessions", JSON.stringify(sessions));
    }
    function getTotalSessionTime() {
        let sessions = typeof CookiesVx.get("vx_user_sessions") !== "undefined" ? JSON.parse(CookiesVx.get("vx_user_sessions")) : {};
        removeExpiredFromUserSessionTime(sessions);
        return Object.values(sessions).reduce((sum, session) => sum + (session.sessionTime || 0), 0);
    }
    function manageUserSession() {
        const totalSessionTime = getTotalSessionTime();
        const mediaMathPixels = {
            1218: "https://pixel.mathtag.com/event/js?mt_id=1657744&mt_adid=430709&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=",
            2776: "https://pixel.mathtag.com/event/js?mt_id=1657745&mt_adid=430892&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=",
            1774: "https://pixel.mathtag.com/event/js?mt_id=1657746&mt_adid=431230&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=",
            2673: "https://pixel.mathtag.com/event/js?mt_id=1657747&mt_adid=431009&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=",
            2249: "https://pixel.mathtag.com/event/js?mt_id=1657748&mt_adid=430883&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3="
        };
        if (mediaMathPixels.hasOwnProperty(advInfo.id) && totalSessionTime >= 120) {
            let requestUrl = mediaMathPixels[advInfo.id];
            let px = document.createElement("img");
            px.src = requestUrl;
            px.async = true;
            px.width = 1;
            px.height = 1;
            px.frameborder = 0;
            px.style = "display:none;visibility:hidden";
            px.marginheight = 0;
            px.marginwidth = 0;
            px.frameBorder = 0;
            px.scrolling = "No";
            px.hspace = 0;
            px.vspace = 0;
            let bd = document.getElementsByTagName("body")[0].lastChild;
            bd.parentNode.insertBefore(px, bd);
        }
    }
    function manageUser(retries = 5, time = 1e3) {
        let gaUserSessionData = getUserSessionData();
        if (gaUserSessionData) {
            updateSessionTime(gaUserSessionData.session_time);
            manageUserSession();
        } else if (retries > 0) {
            VxAsyncWrapper.setTimeout(() => {
                manageUser(retries - 1, time);
            }, time);
        }
    }
    function checkCartItems(dataLayerItem) {
        if (dataLayerItem) {
            if (checkEcommerceItems(dataLayerItem)) {
                return true;
            }
            if (checkAddToCartItems(dataLayerItem)) {
                return true;
            }
            if (checkSubscriptionEvent(dataLayerItem)) {
                return true;
            }
        }
        return false;
    }
    function checkEcommerceItems(dataLayerItem) {
        const validEvents = [ "add_to_cart", "view_cart", "begin_checkout" ];
        if (dataLayerItem.ecommerce) {
            if (validEvents.includes(dataLayerItem.event)) {
                const cartItems = dataLayerItem.ecommerce.items;
                if (cartItems && cartItems.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }
    function checkAddToCartItems(dataLayerItem) {
        const validEvents = [ "cart" ];
        if (dataLayerItem.cartProducts) {
            if (validEvents.includes(dataLayerItem.event)) {
                const cartItems = dataLayerItem.cartProducts;
                if (cartItems && cartItems.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }
    function checkSubscriptionEvent(dataLayerItem) {
        const validEventLabels = [ "formulario:inscricao:inscricao" ];
        if (dataLayerItem.event === "event" && dataLayerItem.eventLabel) {
            return validEventLabels.includes(dataLayerItem.eventLabel);
        }
        return false;
    }
    function hasItemsInDataLayerCart() {
        return getDataLayerItemWith(checkCartItems) !== null;
    }
    function findDataLayer(gtagId) {
        if (!gtagId) {
            return null;
        }
        const gtagScripts = document.querySelectorAll('script[src^="https://www.googletagmanager.com/gtag/js"]');
        for (const tag of gtagScripts) {
            if (!tag.src) {
                continue;
            }
            const tagSrc = new URL(tag.src);
            if (!tagSrc.search.includes(gtagId)) {
                continue;
            }
            const dataLayer = tagSrc.searchParams.get("l");
            if (dataLayer) {
                return dataLayer;
            }
        }
        return null;
    }
    function isPageNotRestricted() {
        if (advInfo.id != 2276 || CookiesVx.get(voxus_key + "custom_is_allowed")) {
            return true;
        }
        const allowedUrls = [ "https://www.smiles.com.br/mfe/emissao-passagem", "https://www.smiles.com.br/passagens", "https://www.smiles.com.br/home" ];
        const currentUrl = window.location.href;
        const isAllowed = allowedUrls.some(url => currentUrl.startsWith(url));
        if (isAllowed) {
            const oneDay = 60 * 60 * 24;
            CookiesVx.set(voxus_key + "custom_is_allowed", true, {
                expires: oneDay
            });
        }
        return isAllowed;
    }
    function getPageIdentifier() {
        let pageIdentifier = parseInt(CookiesVx.get("vx_identifier"));
        if (isNaN(pageIdentifier)) {
            pageIdentifier = 1;
        }
        return pageIdentifier;
    }
    function getAndIncrementPageIdentifier() {
        const updatedPageIdentifier = getPageIdentifier() + 1;
        CookiesVx.set("vx_identifier", updatedPageIdentifier, {
            expires: VxDate.addDays(new Date, 30).toGMTString()
        });
        return updatedPageIdentifier;
    }
    function observeRequests(domain, callback) {
        if (typeof PerformanceObserver === "undefined" || typeof observerController !== "object") {
            return null;
        }
        if (observerController.observers[domain]) {
            return observerController.observers[domain];
        }
        observerController.observedDomains[domain] = false;
        observerController.observedRequests[domain] = [];
        observerController.observers[domain] = {
            getRequests: () => [ ...observerController.observedRequests[domain] ],
            stop: () => {
                let attempts = 0;
                const maxAttempts = 10;
                const interval = setInterval(() => {
                    if (observerController.observers[domain]?.observerInstance) {
                        observerController.observers[domain].observerInstance.disconnect();
                        delete observerController.observers[domain];
                        clearInterval(interval);
                    } else {
                        attempts++;
                        if (attempts >= maxAttempts) {
                            clearInterval(interval);
                        }
                    }
                }, 100);
            },
            observerInstance: null
        };
        performance.getEntriesByType("resource").forEach(entry => {
            if ((entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") && entry.name.includes(domain)) {
                processObservedRequest(entry.name, domain, callback);
            }
        });
        const observer = new PerformanceObserver(list => {
            list.getEntries().forEach(entry => {
                if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") {
                    processObservedRequest(entry.name, domain, callback);
                }
            });
        });
        observer.observe({
            entryTypes: [ "resource" ]
        });
        observerController.observers[domain].observerInstance = observer;
        return observerController.observers[domain];
    }
    function processObservedRequest(urlString, domain, callback) {
        if (typeof observerController === "undefined") {
            return;
        }
        try {
            if (urlString.includes(domain)) {
                observerController.observedRequests[domain].push(urlString);
                observerController.observedDomains[domain] = true;
                if (typeof callback === "function") {
                    callback(urlString, observerController.observers[domain]);
                }
            }
        } catch (error) {
            vxLogger.debug("Error in ``processObservedRequest` for advertiser: ", advInfo.id, error);
            vxLogger.trace(error.stack);
        }
    }
    function getGaCookieKey() {
        return VxGa.getGaCookieKey();
    }
    function getGaCookie() {
        return VxGa.getGaCookie();
    }
    function sendSessionStartMpHit(advertiserId, measurementId) {
        if (advertiserId != 1904 || typeof observerController !== "object" || !observerController.observedDomains || !observerController.observedRequests) {
            return;
        }
        const domain = "server-side-tagging-o5in4ns5xq-uc.a.run.app/g/collect";
        if (!observerController.observedDomains[domain]) {
            VxAsyncWrapper.setTimeout(() => sendSessionStartMpHit(advertiserId), 200);
            return;
        }
        const observedRequests = observerController.observedRequests[domain];
        if (observedRequests.length === 0) {
            return;
        }
        let params = getUrlParams(observedRequests[0]);
        params._s = 1;
        params._ss = 1;
        const queryString = Object.keys(params).map(key => key + "=" + params[key]).join("&");
        const url = "https://" + domain + "?" + queryString;
        fetch(url, {
            method: "GET",
            mode: "no-cors"
        }).catch(error => {
            vxLogger.debug("Error in `sendSessionStartMpHit` for advertiser:", advInfo.id, error);
            vxLogger.trace(error.stack);
        });
        CookiesVx.set(voxus_key + "ss_sent", true, {
            expires: VxDate.addMinutes(new Date, 30).toGMTString()
        });
    }
    function getUrlParams(urlString) {
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const paramsObject = {};
        params.forEach((value, key) => {
            paramsObject[key] = value;
        });
        return paramsObject;
    }
    function sessionChanged(currentSessionId) {
        if (VxLocalStorageManager.getItem("sessionId") !== currentSessionId) {
            VxLocalStorageManager.setItem("sessionId", currentSessionId);
            return true;
        }
        return false;
    }
    function getSearchParam(paramName) {
        try {
            const params = new URL(window.location.href).searchParams;
            return params.get(paramName);
        } catch (error) {
            vxLogger.debug("Error in `getSearchParam` for advertiser: ", advInfo.id, error);
            vxLogger.trace(error.stack);
            return null;
        }
    }
    function getOSDetails() {
        let userAgent = navigator.userAgent;
        let platform = navigator.platform;
        let iosPlatforms = [ "iPhone", "iPad", "iPod" ];
        let os = "Unknown";
        let version = "Unknown";
        if (/Android/.test(userAgent)) {
            os = "Android";
            let match = userAgent.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))?/);
            if (match) {
                version = `${match[1]}.${match[2] || 0}.${match[3] || 0}`;
            }
        } else if (iosPlatforms.indexOf(platform) !== -1 || /iPad|iPhone|iPod/.test(userAgent)) {
            os = "iOS";
            let match = userAgent.match(/OS (\d+)(?:_(\d+))?(?:_(\d+))?/);
            if (match) {
                version = `${match[1]}.${match[2] || 0}.${match[3] || 0}`;
            }
        } else if (/Mac/.test(platform)) {
            os = "MacOS";
        } else if (/Win/.test(platform)) {
            os = "Windows";
        } else if (/Linux/.test(platform)) {
            os = "Linux";
        }
        return {
            os: os,
            version: version
        };
    }
    function areFunctionsAvailable(...functionNames) {
        return functionNames.every(fn => typeof window[fn] === "function");
    }
    function getDatalayerTransactionId(datalayerName = "dataLayer") {
        const gaEvent = window[datalayerName]?.find(item => item?.event === "purchase");
        if (!gaEvent) {
            return;
        }
        return gaEvent?.["ecommerce"]?.transaction_id;
    }
    function listenUrlChangesUntil(targetPath, callback) {
        if (!targetPath || !callback) {
            return;
        }
        if (window.location.pathname === targetPath) {
            callback();
        }
        window.addEventListener("popstate", function() {
            if (window.location.pathname === targetPath) {
                callback();
            }
        });
    }
    function normalizeTimestampInSeconds(timestamp) {
        timestamp = Number(timestamp);
        if (!Number.isFinite(timestamp)) return null;
        const MS_THRESHOLD = 1e12;
        if (timestamp > MS_THRESHOLD) {
            timestamp = Math.floor(timestamp / 1e3);
        }
        return timestamp;
    }
    async function repeatWithDelay(count, delayMs, sendFn, extraDelays = []) {
        for (let i = 0; i < count; i++) {
            sendFn(i);
            const customDelay = extraDelays[i];
            const delay = customDelay !== undefined ? customDelay : delayMs;
            if (i < count - 1) {
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    }
    function sendAdobeHit(params) {
        const ADOBE_PAGE_PARAM2 = "eVar90";
        const ADOBE_UTM_PARAM = "eVar14";
        const ADOBE_JUMP_PARAM = "eVar15";
        const utmString = ":" + params["medium"] + ":" + params["source"] + ":" + params["name"] + ":";
        const url = new URL(window.location.href);
        url.searchParams.set("utm_campaign", params.name);
        url.searchParams.set("utm_source", params.source);
        url.searchParams.set("utm_medium", params.medium);
        if (params.jumpid) {
            url.searchParams.set("jumpid", params.jumpid);
        }
        if (typeof alloy !== "function") {
            return;
        }
        alloy("sendEvent", {
            xdm: {
                web: {
                    webPageDetails: {
                        URL: url.toString(),
                        pageViews: {
                            value: 1
                        }
                    }
                },
                _experience: {
                    analytics: {
                        customDimensions: {
                            eVars: {
                                [ADOBE_PAGE_PARAM2]: url.toString(),
                                [ADOBE_UTM_PARAM]: utmString,
                                [ADOBE_JUMP_PARAM]: params.jumpid,
                                props: {
                                    prop40: "pageView"
                                }
                            }
                        }
                    }
                },
                documentUnloading: true,
                eventType: "web.webpagedetails.pageViews"
            }
        });
    }
    function getSessionId(measurementId = null) {
        if (advInfo.id === "2961") {
            return CookiesVx.get("rl_session");
        }
        const gaData = measurementId ? getGaSessionCookieData(measurementId) : null;
        let session = gaData?.sessionId || null;
        if (!session) {
            session = VxVtexAttr.getSessionCookie();
        }
        return session;
    }
    function getUserId(measurementId = null) {
        const gaData = measurementId ? getGaSessionCookieData(measurementId) : null;
        if (gaData) {
            return gaData?.userId;
        }
        return thisip;
    }
    function setupConversionPixelHook() {
        const pixelId = customData?.conv_pixel?.pixelId;
        const button = document.querySelector(customData?.conv_pixel?.querySelector);
        if (!button) {
            return;
        }
        button.addEventListener("clic" + "k", function() {
            !function(s, a, e, v, n, t, z) {
                if (s.saq) return;
                n = s.saq = function() {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!s._saq) s._saq = n;
                n.push = n;
                n.loaded = !0;
                n.version = "1.0";
                n.queue = [];
                t = a.createElement(e);
                t.async = !0;
                t.src = v;
                z = a.getElementsByTagName(e)[0];
                z.parentNode.insertBefore(t, z);
            }(window, document, "script", "https://tags.srv.stackadapt.com/events.js");
            saq("conv", pixelId);
        }, {
            once: true
        });
    }
    function setupUniversalPixel() {
        const pixelId = customData?.universal_pixel?.pixelId;
        if (!pixelId) {
            return;
        }
        !function(s, a, e, v, n, t, z) {
            if (s.saq) return;
            n = s.saq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!s._saq) s._saq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "1.0";
            n.queue = [];
            t = a.createElement(e);
            t.async = !0;
            t.src = v;
            z = a.getElementsByTagName(e)[0];
            z.parentNode.insertBefore(t, z);
        }(window, document, "script", "https://tags.srv.stackadapt.com/events.js");
        saq("ts", pixelId);
    }
    try {
        if (advInfo.id === "2988") {
            VxDataLayerObserver.observe({
                matcher: function(item) {
                    return item?.[1] === "page_view" && item?.[2]?.campaign?.source === alcs;
                },
                onMatch: function(item) {
                    var campaign = item[2]?.campaign || {};
                    var adSeenInfo = VxImpHandler.getCookieLastAdSeenInformation();
                    vxLogger.info("page_view_utms", {
                        campaign_source: campaign.source || "empty",
                        campaign_medium: campaign.medium || "empty",
                        campaign_name: campaign.name || "empty",
                        campaign_content: campaign.content || "empty",
                        campaign_term: campaign.term || "empty",
                        kopid_creative: adSeenInfo.creative || "empty",
                        kopid_campaign: adSeenInfo.campaign || "empty",
                        kopid_time: adSeenInfo.time ?? "empty",
                        kopid_campaigns: JSON.stringify(adSeenInfo.campaigns),
                        kopid_ad_placement_domain: adSeenInfo.ad_placement_domain || "empty",
                        kopid_plataform: adSeenInfo.kopid_plataform || "empty",
                        cookie_kopid_pip: CookiesVx.get(voxus_key + "_kopid_pip") || "empty",
                        cookie_last_impression_ts: CookiesVx.get("voxus_last_impression_timestamp_" + advInfo.id) || "empty",
                        cookie_seg_kaoq: CookiesVx.get(voxus_key + "_seg_kaoq") || "empty",
                        cookie_ad_placement_domain: CookiesVx.get(voxus_key + "_ad_placement_domain") || "empty",
                        cookie_kopid_plataform: CookiesVx.get(voxus_key + "_kopid_plataform") || "empty"
                    });
                }
            });
        }
        var getIP = function() {};
        var sgarq = function() {};
        var intervalDocumentOnloadVoxusDsp = null;
        var intervalDataExcludeValidated;
        var VOXUS_RTDT_DATA = encodeURIComponent(`client=${tagConfig.clientName}&website_id=${tagConfig.advInfo.id}&obj=238b5637f41f33387ecb9ff9fb2f3e47238b5637f41f33387ecb9ff9fb2f3e47238b5637f41f33387ecb9ff9fb2f3e47238b5637f41f33387ecb9ff9fb2f3e47238b5637f41f33387ecb9ff9fb2f3e47238b5637f41f33387ecb9ff9fb2f3e47&type=pageview`);
        if (CookiesVx.get(voxus_key + "_campaign_") != null) {
            alcn = "campaign_" + advInfo.id + "_" + CookiesVx.get(voxus_key + "_campaign_");
        }
        var fs = window.RequestFileSystem || window.webkitRequestFileSystem;
        if (!fs) {} else {
            fs(window.TEMPORARY, 100, setisicgt.bind(setisicgt, false), setisicgt.bind(setisicgt, true));
        }
        if (navigator != null) {
            if (navigator.userAgent != null) {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    ismobile = true;
                }
            }
        }
        var utmInThisPage = false;
        var otnoreal = false;
        if (window.getParameterByNameVx__("utm_source") == "voxus") {
            CookiesVx.set(voxus_key + "_adinter_pip", "true", {
                expires: 24 * 60 * 60
            });
            adinter = true;
            utmInThisPage = true;
            if (window.getParameterByNameVx__("utm_campaign").length > 0) {
                if (window.getParameterByNameVx__("utm_campaign").split("_").length == 3) {
                    CookiesVx.set(voxus_key + "_campaign_", window.getParameterByNameVx__("utm_campaign").split("_")[2], {
                        expires: Infinity
                    });
                } else {
                    CookiesVx.set(voxus_key + "_campaign_", "-1", {
                        expires: Infinity
                    });
                }
            }
        }
        if (window.getParameterByNameVx__("utm_source") == "voxusmediamanager") {
            CookiesVx.set(voxus_key + "_adinter_pip", "true", {
                expires: 24 * 60 * 60
            });
            adinter = true;
            utmInThisPage = true;
            if (window.getParameterByNameVx__("utm_campaign").length > 0) {
                if (window.getParameterByNameVx__("utm_campaign").split("_").length == 3) {
                    CookiesVx.set(voxus_key + "_campaign_", window.getParameterByNameVx__("utm_campaign").split("_")[2], {
                        expires: Infinity
                    });
                } else {
                    CookiesVx.set(voxus_key + "_campaign_", "-1", {
                        expires: Infinity
                    });
                }
            }
        }
        if (window.getParameterByNameVx__("utm_medium") != "") {
            VxLocalStorageManager.setItem(voxus_key + "_medium", window.getParameterByNameVx__("utm_medium"));
        }
        if (window.getParameterByNameVx__("utm_source") != "") {
            VxLocalStorageManager.setItem(voxus_key + "_source", window.getParameterByNameVx__("utm_source"));
        }
        if (window.getParameterByNameVx__("utm_content") != "") {
            VxLocalStorageManager.setItem(voxus_key + "_content", window.getParameterByNameVx__("utm_content"));
        }
        if (window.getParameterByNameVx__("utm_campaign") != "") {
            VxLocalStorageManager.setItem(voxus_key + "_campaign", window.getParameterByNameVx__("utm_campaign"));
        }
        if (window.getParameterByNameVx__("utm_source") != "" || window.getParameterByNameVx__("gclid")) {
            kopid = false;
        }
        if (location.hostname.indexOf("vtexcommercestable.com.br") > -1) {
            igvxtst = true;
        }
        if (isFromOther()) {
            igvxtst = true;
            fromOther = true;
        } else {
            VxCookieStateLoader.load();
            thisip = thisip || CookiesVx.get(voxus_key + "_ip");
            if (VxIpBlockList.isBlocked(advInfo.id, thisip)) {
                VxAttrOnClickUtmHandler.setIgnoreCookies();
                VxResetLookupWindow.setOtherPaidMediaCookie();
            }
            if (VxAttrOnClickUtmHandler.isOtherPaidMediaOnQueryString()) {
                VxAttrOnClickUtmHandler.setIgnoreCookies();
                VxOtherV2Attr.setOtherMediaCooldownCookie(new Date);
            }
            VxIgnoredPageHandler.check();
        }
        function __voxMainProc() {
            function startFunctionsVoxus() {
                var lastPageVerify = window.location.href;
                if (hasCustomization("custom_pixels")) {
                    manageUser();
                }
                VxDataLayerObserver.trackPurchaseUrl();
                VxDataLayerObserver.trackPurchaseId();
                if (typeof getAndIncrementPageIdentifier === "function") {
                    getAndIncrementPageIdentifier();
                }
                if (hasCustomization("analytics_observer") && typeof observeAnyPageViewEvent === "function") {
                    observeAnyPageViewEvent();
                }
                VxOtherV2Attr.reloadFromOtherV2VariableState();
                VxResetLookupWindow.resetLookupWindow();
                if (hasCustomization("usubida_pixel")) {
                    setupConversionPixelHook();
                    setupUniversalPixel();
                }
                verifyPage = function() {
                    if (lastPageVerify != window.location.href) {
                        lastPageVerify = window.location.href;
                        VxOtherV2Attr.reloadFromOtherV2VariableState();
                        VxResetLookupWindow.resetLookupWindow();
                        if (VxVtexAttr.isOnCheckout() && (fromOtherv2 || !kopid)) {
                            VxVtexAttr.cleanCheckout();
                        }
                        if (typeof getAndIncrementPageIdentifier === "function") {
                            getAndIncrementPageIdentifier();
                        }
                        if (hasCustomization("analytics_observer") && typeof observeAnyPageViewEvent === "function") {
                            observeAnyPageViewEvent();
                        }
                        if (hasCustomization("custom_pixels")) {
                            manageUser();
                        }
                        sdloggly(true);
                        if (typeof reloadPixels == "function") {
                            reloadPixels();
                        }
                        VxSecondaryDimensionChecker.processAll();
                        if (!isFromOther()) {
                            sgarqRun = true;
                            alihuadsanw = false;
                            sgarq = function() {
                                if (!VxDomainAllowlist.isAllowedDomain()) {
                                    return;
                                }
                                if (2 == tagConfig.secundaryDimension) {
                                    return;
                                }
                                const isOnGaHitDelay = CookiesVx.get(voxus_key + "_ignore_full_ugi") == "true" && !hasCustomization("conv_skip") && !VxVtexAttr.isOnCheckout();
                                const isBlocked = CookiesVx.get(voxus_key + "_block_full") == "true";
                                const isUserAllowedByType = isNewUser() || isPageNotRestricted();
                                const sendHit = sgarqRun && usubidaPages != null && usubidaPages.length > 0 && alihuadsanw == false && !isOnGaHitDelay && isicgt == false && lswf == false && isUserAllowedByType && !isBlocked;
                                async function checkVxIsActualLastPaidMedia() {
                                    if (await VxOtherV2Attr.isVxLastPaidMediaOnAnyAdvertiser()) return true;
                                    const activeOtherPaidMedia = await VxOtherV2Attr.getActivePaidMedia();
                                    if (!activeOtherPaidMedia?.time) return true;
                                    const advertiserIds = VxOtherV2Attr.getAttrScopeAdvertiserIds();
                                    const vxImpsResults = await VxNativePromise.allSettled(advertiserIds.map(id => VxImpHandler.getVxLastImpression(id)));
                                    const vxImpsByAdv = advertiserIds.map((id, index) => ({
                                        advertiserId: id,
                                        impression: vxImpsResults[index].status === "fulfilled" ? vxImpsResults[index].value : null
                                    }));
                                    sendToLoggly({
                                        type: "expire_hit_v3_r",
                                        pageview: window.location.href,
                                        activePaidMedia: activeOtherPaidMedia,
                                        cookie_id: cookie_id,
                                        ads: kopid,
                                        hasIgnore: CookiesVx.get(voxus_key + "_ignoreot_full"),
                                        timestampCookie: vxImpsByAdv
                                    });
                                    const now = Math.floor(Date.now() / 1e3);
                                    const twentyFourHoursAttrWindowInSeconds = 24 * 60 * 60;
                                    const timePassed = now - activeOtherPaidMedia.time;
                                    const timeLeft = twentyFourHoursAttrWindowInSeconds - timePassed;
                                    if (timeLeft <= 0) return false;
                                    CookiesVx.set(voxus_key + "_ignoreot_full", "true", {
                                        expires: timeLeft
                                    });
                                    return false;
                                }
                                checkVxIsActualLastPaidMedia().then(isVxLastPaidMedia => {
                                    if (!isVxLastPaidMedia) {
                                        forceEmptySgarq();
                                        return;
                                    }
                                    if (sendHit) return tryVxAttr(); else forceEmptySgarq();
                                });
                                function tryVxAttr() {
                                    alcn = UtmParamsHandler.getDefaultVxCampaign();
                                    var urlOk = true;
                                    if (CookiesVx.get(voxus_key + "_at_pg_ok") != "true") {
                                        for (var pgok = 0; pgok < urlsToBloq.length; pgok++) {
                                            if (window.decodeURLComponentEscaped(window.location.href).indexOf(urlsToBloq[pgok]) !== -1) {
                                                urlOk = false;
                                            }
                                        }
                                    }
                                    if (urlOk) {
                                        CookiesVx.set(voxus_key + "_at_pg_ok", "true", {
                                            expires: 1 * 60 * 60
                                        });
                                    }
                                    if (CookiesVx.get(voxus_key + "_at_pg_ok") != "true") {
                                        return;
                                    }
                                    sgarqRun = false;
                                    kiphouYiasO = [];
                                    var urlTrackerVx2 = VOXUS_API_BASE_URL + "/verify/c.php?adv_id=" + advInfo.id;
                                    var httptrk2 = new XMLHttpRequest;
                                    httptrk2.open("GET", urlTrackerVx2, true);
                                    httptrk2.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                                    httptrk2.send();
                                    httptrk2.onreadystatechange = function() {
                                        if (httptrk2.readyState != 4 || httptrk2.status != 200) {
                                            vxAttrStatus.gaNotSent = `http-state-readyState:${httptrk2.readyState}-status:${httptrk2.status}`;
                                            return;
                                        }
                                        var response = JSON.parse(httptrk2.responseText);
                                        var cvCheckBypassed = hasCustomization("cv_check_bypass") && Math.random() < .3;
                                        if (!cvCheckBypassed && (response == null || response.cv == null || response.cv !== false)) {
                                            vxAttrStatus.gaNotSent = "response.cv";
                                            if (response?.date) {
                                                const secondsSinceConv = Math.floor((Date.now() - new Date(response.date).getTime()) / 1e3);
                                                vxAttrStatus.recentConv = secondsSinceConv > 120;
                                            }
                                            return;
                                        }
                                        vxAttrStatus.gaNotSent = null;
                                        CookiesVx.set(voxus_key + "_assigned", "true", {
                                            expires: VxDate.addMinutes(new Date, 30)
                                        });
                                        VxAdPlacementDomainTracking.sendHit();
                                        if (hasCustomization("ga4_reset_session")) {
                                            VxGA4Attr.resetSession(getMeasurementIds());
                                        }
                                        if (hasCustomization("conv_skip") && isConversionPage()) {
                                            sendToLoggly({
                                                type: "conv_skip",
                                                pageview: window.location.href.replace("#", ""),
                                                tp: thisip
                                            });
                                            vxAttrStatus.gaNotSent = "conv-skip";
                                            return;
                                        }
                                        let params = UtmParamsHandler.getUtmParametersToSend(alcs, alcm, alcn);
                                        if (hasCustomization("new_user_reset")) {
                                            VxGA4Attr.resetNewUserIfEligible(params);
                                        }
                                        if (hasCustomization("ga_hit")) {
                                            if (hasCustomization("multiple-ga-hits-with-delay")) {
                                                sendMultipleAnalyticsHitsWithDelays(() => VxGA4Attr.sendDefaultPageViewAnalyticsHit());
                                            } else {
                                                VxGA4Attr.sendDefaultPageViewAnalyticsHit();
                                            }
                                            alihuadsa = true;
                                            alihuadsanw = true;
                                            VxResetLookupWindow.setVxPaidMediaCookie();
                                            if (hasCustomization("conv_skip")) {
                                                sendToLoggly({
                                                    type: "conv_not_skip",
                                                    pageview: window.location.href.replace("#", ""),
                                                    tp: thisip
                                                });
                                                return;
                                            }
                                            if (!hasCustomization("ga-hits-with-no-delay")) {
                                                CookiesVx.set(voxus_key + "_ignore_full_ugi", "true", {
                                                    expires: VxDate.addMinutes(new Date, 1)
                                                });
                                            }
                                        }
                                        [ VxAdobeAttr, VxNemuAttr, VxPlausibleAttr, VxVtexAttr, VxVtexIOAttr, VxRdstationCookieBased ].forEach(platform => platform.sendHit(params));
                                        if (hasCustomization("mtm_hit") && _paq) {
                                            const url = new URL(window.location.href);
                                            url.searchParams.append("utm_campaign", params.name);
                                            url.searchParams.append("utm_source", params.source);
                                            url.searchParams.append("utm_medium", params.medium);
                                            _paq.push([ "setCustomUrl", url.toString() ]);
                                            _paq.push([ "trackPageView" ]);
                                        }
                                        if (hasCustomization("amp_hit") && typeof amplitude === "object") {
                                            const identifyObj = new amplitude.Identify;
                                            identifyObj.set("utm_campaign", params.name);
                                            identifyObj.set("utm_medium", params.medium);
                                            identifyObj.set("utm_source", params.source);
                                            amplitude.identify(identifyObj);
                                        }
                                    };
                                    function sendMultipleAnalyticsHitsWithDelays(sendFn, delays = [ 2e3, 2e3, 5e3, 1e4 ]) {
                                        (async () => {
                                            await repeatWithDelay(delays.length + 1, 2e3, sendFn, delays);
                                        })();
                                    }
                                    function isConversionPage() {
                                        const allConversionPaths = subusubidaPages.concat(usubidaPages).map(page => page.replace("/", ""));
                                        return allConversionPaths.some(path => window.location.pathname.includes(path));
                                    }
                                    forceEmptySgarq();
                                }
                                function forceEmptySgarq() {
                                    sgarq = function() {};
                                }
                            };
                            checkStatisticsConvUser();
                        }
                    }
                };
                if (!hasCustomization("disable_set_interval")) {
                    VxAsyncWrapper.setInterval(verifyPage, 1e3);
                }
                if (isFromOther()) {
                    return false;
                }
                sgarq = function() {
                    if (!VxDomainAllowlist.isAllowedDomain()) {
                        return;
                    }
                    if (2 == tagConfig.secundaryDimension) {
                        return;
                    }
                    const isOnGaHitDelay = CookiesVx.get(voxus_key + "_ignore_full_ugi") == "true" && !hasCustomization("conv_skip") && !VxVtexAttr.isOnCheckout();
                    const isBlocked = CookiesVx.get(voxus_key + "_block_full") == "true";
                    const isUserAllowedByType = isNewUser() || isPageNotRestricted();
                    const sendHit = sgarqRun && usubidaPages != null && usubidaPages.length > 0 && alihuadsanw == false && !isOnGaHitDelay && isicgt == false && lswf == false && isUserAllowedByType && !isBlocked;
                    async function checkVxIsActualLastPaidMedia() {
                        if (await VxOtherV2Attr.isVxLastPaidMediaOnAnyAdvertiser()) return true;
                        const activeOtherPaidMedia = await VxOtherV2Attr.getActivePaidMedia();
                        if (!activeOtherPaidMedia?.time) return true;
                        const advertiserIds = VxOtherV2Attr.getAttrScopeAdvertiserIds();
                        const vxImpsResults = await VxNativePromise.allSettled(advertiserIds.map(id => VxImpHandler.getVxLastImpression(id)));
                        const vxImpsByAdv = advertiserIds.map((id, index) => ({
                            advertiserId: id,
                            impression: vxImpsResults[index].status === "fulfilled" ? vxImpsResults[index].value : null
                        }));
                        sendToLoggly({
                            type: "expire_hit_v3_r",
                            pageview: window.location.href,
                            activePaidMedia: activeOtherPaidMedia,
                            cookie_id: cookie_id,
                            ads: kopid,
                            hasIgnore: CookiesVx.get(voxus_key + "_ignoreot_full"),
                            timestampCookie: vxImpsByAdv
                        });
                        const now = Math.floor(Date.now() / 1e3);
                        const twentyFourHoursAttrWindowInSeconds = 24 * 60 * 60;
                        const timePassed = now - activeOtherPaidMedia.time;
                        const timeLeft = twentyFourHoursAttrWindowInSeconds - timePassed;
                        if (timeLeft <= 0) return false;
                        CookiesVx.set(voxus_key + "_ignoreot_full", "true", {
                            expires: timeLeft
                        });
                        return false;
                    }
                    checkVxIsActualLastPaidMedia().then(isVxLastPaidMedia => {
                        if (!isVxLastPaidMedia) {
                            forceEmptySgarq();
                            return;
                        }
                        if (sendHit) return tryVxAttr(); else forceEmptySgarq();
                    });
                    function tryVxAttr() {
                        alcn = UtmParamsHandler.getDefaultVxCampaign();
                        var urlOk = true;
                        if (CookiesVx.get(voxus_key + "_at_pg_ok") != "true") {
                            for (var pgok = 0; pgok < urlsToBloq.length; pgok++) {
                                if (window.decodeURLComponentEscaped(window.location.href).indexOf(urlsToBloq[pgok]) !== -1) {
                                    urlOk = false;
                                }
                            }
                        }
                        if (urlOk) {
                            CookiesVx.set(voxus_key + "_at_pg_ok", "true", {
                                expires: 1 * 60 * 60
                            });
                        }
                        if (CookiesVx.get(voxus_key + "_at_pg_ok") != "true") {
                            return;
                        }
                        sgarqRun = false;
                        kiphouYiasO = [];
                        var urlTrackerVx2 = VOXUS_API_BASE_URL + "/verify/c.php?adv_id=" + advInfo.id;
                        var httptrk2 = new XMLHttpRequest;
                        httptrk2.open("GET", urlTrackerVx2, true);
                        httptrk2.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                        httptrk2.send();
                        httptrk2.onreadystatechange = function() {
                            if (httptrk2.readyState != 4 || httptrk2.status != 200) {
                                vxAttrStatus.gaNotSent = `http-state-readyState:${httptrk2.readyState}-status:${httptrk2.status}`;
                                return;
                            }
                            var response = JSON.parse(httptrk2.responseText);
                            var cvCheckBypassed = hasCustomization("cv_check_bypass") && Math.random() < .3;
                            if (!cvCheckBypassed && (response == null || response.cv == null || response.cv !== false)) {
                                vxAttrStatus.gaNotSent = "response.cv";
                                if (response?.date) {
                                    const secondsSinceConv = Math.floor((Date.now() - new Date(response.date).getTime()) / 1e3);
                                    vxAttrStatus.recentConv = secondsSinceConv > 120;
                                }
                                return;
                            }
                            vxAttrStatus.gaNotSent = null;
                            CookiesVx.set(voxus_key + "_assigned", "true", {
                                expires: VxDate.addMinutes(new Date, 30)
                            });
                            VxAdPlacementDomainTracking.sendHit();
                            if (hasCustomization("ga4_reset_session")) {
                                VxGA4Attr.resetSession(getMeasurementIds());
                            }
                            if (hasCustomization("conv_skip") && isConversionPage()) {
                                sendToLoggly({
                                    type: "conv_skip",
                                    pageview: window.location.href.replace("#", ""),
                                    tp: thisip
                                });
                                vxAttrStatus.gaNotSent = "conv-skip";
                                return;
                            }
                            let params = UtmParamsHandler.getUtmParametersToSend(alcs, alcm, alcn);
                            if (hasCustomization("new_user_reset")) {
                                VxGA4Attr.resetNewUserIfEligible(params);
                            }
                            if (hasCustomization("ga_hit")) {
                                if (hasCustomization("multiple-ga-hits-with-delay")) {
                                    sendMultipleAnalyticsHitsWithDelays(() => VxGA4Attr.sendDefaultPageViewAnalyticsHit());
                                } else {
                                    VxGA4Attr.sendDefaultPageViewAnalyticsHit();
                                }
                                alihuadsa = true;
                                alihuadsanw = true;
                                VxResetLookupWindow.setVxPaidMediaCookie();
                                if (hasCustomization("conv_skip")) {
                                    sendToLoggly({
                                        type: "conv_not_skip",
                                        pageview: window.location.href.replace("#", ""),
                                        tp: thisip
                                    });
                                    return;
                                }
                                if (!hasCustomization("ga-hits-with-no-delay")) {
                                    CookiesVx.set(voxus_key + "_ignore_full_ugi", "true", {
                                        expires: VxDate.addMinutes(new Date, 1)
                                    });
                                }
                            }
                            [ VxAdobeAttr, VxNemuAttr, VxPlausibleAttr, VxVtexAttr, VxVtexIOAttr, VxRdstationCookieBased ].forEach(platform => platform.sendHit(params));
                            if (hasCustomization("mtm_hit") && _paq) {
                                const url = new URL(window.location.href);
                                url.searchParams.append("utm_campaign", params.name);
                                url.searchParams.append("utm_source", params.source);
                                url.searchParams.append("utm_medium", params.medium);
                                _paq.push([ "setCustomUrl", url.toString() ]);
                                _paq.push([ "trackPageView" ]);
                            }
                            if (hasCustomization("amp_hit") && typeof amplitude === "object") {
                                const identifyObj = new amplitude.Identify;
                                identifyObj.set("utm_campaign", params.name);
                                identifyObj.set("utm_medium", params.medium);
                                identifyObj.set("utm_source", params.source);
                                amplitude.identify(identifyObj);
                            }
                        };
                        function sendMultipleAnalyticsHitsWithDelays(sendFn, delays = [ 2e3, 2e3, 5e3, 1e4 ]) {
                            (async () => {
                                await repeatWithDelay(delays.length + 1, 2e3, sendFn, delays);
                            })();
                        }
                        function isConversionPage() {
                            const allConversionPaths = subusubidaPages.concat(usubidaPages).map(page => page.replace("/", ""));
                            return allConversionPaths.some(path => window.location.pathname.includes(path));
                        }
                        forceEmptySgarq();
                    }
                    function forceEmptySgarq() {
                        sgarq = function() {};
                    }
                };
                intervalDocumentOnloadVoxusDsp = VxAsyncWrapper.setInterval(function() {
                    if (document.body == null) {
                        return;
                    }
                    clearInterval(intervalDocumentOnloadVoxusDsp);
                    var objclk = null;
                    var random = Math.random() * 1e19;
                    checkStatisticsConvUser();
                    if (typeof window.onpopstate == "function") {
                        var onpopstatefunctionvx = window.onpopstate;
                        window.onpopstate = function() {
                            sdloggly(true);
                            checkStatisticsConvUser();
                            onpopstatefunctionvx();
                        };
                    }
                    if (typeof window.addEventListener == "function") {
                        window.addEventListener("hashchange", function() {
                            sdloggly(true);
                            if (typeof reloadPixels == "function") {
                                reloadPixels();
                            }
                            checkStatisticsConvUser();
                            for (var i = 0; i < usubidaPages.length; i++) {}
                        });
                    } else if (typeof document.addEventListener == "function") {
                        document.addEventListener("hashchange", function() {
                            sdloggly(true);
                            if (typeof reloadPixels == "function") {
                                reloadPixels();
                            }
                            checkStatisticsConvUser();
                            for (var i = 0; i < usubidaPages.length; i++) {
                                if (window.decodeURLComponentEscaped(window.location.href).indexOf(usubidaPages[i]) != -1) {}
                            }
                        });
                    }
                    for (var i = 0; i < usubidaPages.length; i++) {
                        if (window.decodeURLComponentEscaped(window.location.href).indexOf(usubidaPages[i]) != -1) {
                            break;
                        }
                    }
                }, 1e3);
            }
            startFunctionsVoxus();
            function customClickChecking() {
                if (advInfo.id != 2753) return;
                const sendLogglyFunction = function() {
                    sdloggly(true);
                };
                const thisIsClick = [ "cli", "ck" ].join("");
                let wppButton = document.querySelector("#chatButton");
                const handleInput = function() {
                    let inputField = document.querySelector('input[name="name"]');
                    if (inputField && inputField.value.trim() !== "") {
                        wppTriggered = true;
                        sendLogglyFunction();
                    }
                };
                wppButton.addEventListener(thisIsClick, function() {
                    const observer = new MutationObserver(function(mutationsList, observer) {
                        for (let mutation of mutationsList) {
                            if (mutation.type === "childList") {
                                let inputField = document.querySelector('input[name="name"]');
                                if (inputField) {
                                    inputField.addEventListener("input", handleInput);
                                    observer.disconnect();
                                    break;
                                }
                            }
                        }
                    });
                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                });
                const checkButtonExistence = function() {
                    let appointmentButton = document.querySelector(".text-base.font-semibold.md\\:text-sm.md\\:font-medium.rounded-full.transition-colors.duration-500.inline-flex.justify-center.items-center.whitespace-nowrap.ease-out.disabled\\:opacity-50.bg-blue-500.md\\:hover\\:bg-blue-400.text-white.w-fit.px-4.py-2.md\\:px-5.md\\:py-3");
                    if (appointmentButton) {
                        appointmentTriggered = true;
                        appointmentButton.addEventListener(thisIsClick, sendLogglyFunction);
                    }
                };
                VxAsyncWrapper.setInterval(checkButtonExistence, 2e3);
            }
            function startAnalyticsObservation(callback) {
                if (typeof observeRequests !== "function" || typeof callback !== "function") {
                    return;
                }
                const defaultPath = "/g/collect";
                observeRequests(defaultPath, callback);
            }
            function observeAnyPageViewEvent() {
                startAnalyticsObservation(stopObservingAfterPageViewEvent);
            }
            function stopObservingAfterPageViewEvent(urlString, observerController) {
                if (!observerController || typeof observerController.getRequests !== "function") {
                    return;
                }
                const requests = observerController.getRequests();
                if (!Array.isArray(requests) || requests.length === 0) {
                    return;
                }
                try {
                    const event = requests.find(request => {
                        try {
                            const url = new URL(request);
                            return url.searchParams.has("en") && url.searchParams.get("en") === "page_view";
                        } catch (error) {
                            vxLogger.debug("Error while searching params in `stopObservingAfterPageViewEvent` for advertiser: ", advInfo.id, error);
                            vxLogger.trace(error.stack);
                            return false;
                        }
                    });
                    if (event) {
                        observerController.stop();
                    }
                } catch (error) {
                    vxLogger.debug("Error in `stopObservingAfterPageViewEvent` for advertiser: ", advInfo.id, error);
                    vxLogger.trace(error.stack);
                }
            }
            customClickChecking();
            let previousDataLayerLength = 0;
            function trackClickElements(newDataLayerItem, trackingClickElements) {
                if (!Array.isArray(trackingClickElements)) {
                    return;
                }
                if (typeof trackedElements["cliques"] === "undefined") trackedElements["cliques"] = {};
                const trackedElement = newDataLayerItem["gtm.element"];
                trackingClickElements.forEach(function(trackingElement) {
                    if (trackedElement.closest(trackingElement)) {
                        if (typeof trackedElements["cliques"][trackingElement] === "undefined" || !trackedElements["cliques"][trackingElement]) {
                            trackedElements["cliques"][trackingElement] = true;
                            sdloggly(true);
                        }
                    }
                });
            }
            function dataLayerTracking(trackingElements) {
                if (dataLayer.length === previousDataLayerLength) {
                    return {};
                }
                const newDataLayerItems = dataLayer.slice(previousDataLayerLength);
                newDataLayerItems.forEach(function(newDataLayerItem) {
                    if (trackingElements["cliques"] && newDataLayerItem.event === [ "gtm.", "cli", "ck" ].join("") && typeof newDataLayerItem["gtm.element"] !== "undefined") {
                        trackClickElements(newDataLayerItem, trackingElements["cliques"]);
                    }
                    if (trackingElements["scroll"] && newDataLayerItem.event === "gtm.scrollDepth") {
                        trackedElements["scroll"] = true;
                        sdloggly(true);
                    }
                });
                previousDataLayerLength = dataLayer.length;
            }
            function startDataLayerTracking() {
                const trackingElements = tagConfig.advCustomTracking;
                initializeTrackedElements(trackingElements);
                VxAsyncWrapper.setInterval(() => dataLayerTracking(trackingElements), 2e3);
            }
            function initializeTrackedElements(trackingElements) {
                for (const key in trackingElements) {
                    if (trackingElements.hasOwnProperty(key)) {
                        if (Array.isArray(trackingElements[key])) {
                            trackedElements[key] = {};
                            trackingElements[key].forEach(element => {
                                trackedElements[key][element] = false;
                            });
                        } else {
                            trackedElements[key] = false;
                        }
                    }
                }
            }
            if (hasCustomization("custom_tracking")) {
                startDataLayerTracking();
            }
            function checkStatisticsConvUser(page) {
                if (typeof page == "undefined") {
                    page = false;
                }
                if (CookiesVx.get(voxus_key + "_converted") != "true" && (kopid == true || adinter == true || kopiduh == true)) {
                    sgarq();
                }
                if (CookiesVx.get(voxus_key + "_converted") != "true" && (kopid == true || adinter == true || kopiduh == true) && alihuadsa) {
                    var objclk = null;
                    if (page === false) {
                        page = window.location.href;
                    }
                    for (var i = 0; i < usubidaPages.length; i++) {
                        var usubidaPageParts = usubidaPages[i].split("*");
                        var usubida = true;
                        for (var j = 0; j < usubidaPageParts.length; j++) {
                            var idobjclk = usubidaPageParts[j].split("#");
                            if (window.decodeURLComponentEscaped(page).indexOf(idobjclk[0]) == -1) {
                                usubida = false;
                            } else {
                                if (idobjclk.length > 1) {
                                    objclk = document.getElementById(idobjclk[1]);
                                }
                            }
                        }
                    }
                    if (objclk != null) {
                        objclk.addEventListener("inter", function() {
                            if (interConversion == false) {
                                interConversion = true;
                                sgarq();
                                for (var i = 0; i < usubidaPages.length; i++) {
                                    var usubidaPageParts = usubidaPages[i].split("#");
                                    if (window.decodeURLComponentEscaped(page).indexOf(usubidaPageParts[0]) != -1) {
                                        sdloggly();
                                        sdconv();
                                        break;
                                    }
                                }
                            }
                        });
                    } else {
                        if (CookiesVx.get(voxus_key + "_campaign_") == null) {
                            for (var i = 0; i < sgotasd.length; i++) {
                                CookiesVx.set(voxus_key + "_campaign_", sgotasd[i][1], {
                                    expires: Infinity
                                });
                            }
                        }
                        for (var i = 0; i < usubidaPages.length; i++) {
                            var re = new RegExp(usubidaPages[i]);
                            if (re.exec(window.decodeURLComponentEscaped(page)) != null) {
                                sdloggly();
                                sdconv();
                                break;
                            }
                        }
                    }
                }
            }
            if (typeof CookiesVx.get(voxus_key + "_ip") == "undefined") {
                var getip = new XMLHttpRequest;
                getip.open("GET", "https://api.ipify.org/?format=json", true);
                getip.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                getip.send();
                getip.onreadystatechange = function() {
                    if (getip.readyState === 4) {
                        var response = JSON.parse(getip.responseText);
                        getIP(response);
                    }
                };
            } else {
                thisip = CookiesVx.get(voxus_key + "_ip");
            }
            getIP = function(ip) {
                thisip = ip.ip;
                CookiesVx.set(voxus_key + "_ip", ip.ip, {
                    expires: 60 * 10
                });
            };
            function sayswho() {
                var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return "IE " + (tem[1] || "");
                }
                if (M[1] === "Chrome") {
                    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
                }
                M = M[2] ? [ M[1], M[2] ] : [ navigator.appName, navigator.appVersion, "-?" ];
                if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
                return M.join(" ");
            }
            var totalLogglys = 0;
            var domainsToIgnore = [];
            function sdlogglyinter(eventClick, md5Event) {
                logglyloadvoxus = true;
                if (typeof force == "undefined") {
                    force = false;
                }
                var ignoreThis = false;
                for (it = 0; it < domainsToIgnore.length; it++) {
                    if (window.location.href.replace("#", "").indexOf(domainsToIgnore[it]) > -1) {
                        ignoreThis = true;
                    }
                }
                if (ignoreThis) {
                    return;
                }
                if (hasCustomization("ga_hit") && !getFixedMeasurementId()) {
                    VxAsyncWrapper.setTimeout(() => sdlogglyinter(eventClick, md5Event), 200);
                    return;
                }
                let observedRequests = "";
                if (hasCustomization("analytics_observer") && typeof observerController === "object" && observerController.observedDomains && observerController.observedRequests) {
                    const isAllDomainsReady = Object.values(observerController.observedDomains).every(status => status === true);
                    if (!isAllDomainsReady) {
                        VxAsyncWrapper.setTimeout(() => sdloggly(force), 200);
                        return;
                    }
                    observedRequests = Object.values(observerController.observedRequests).flat().join(",") || "";
                }
                alihuadsa = alihuadsanw;
                if (alihuadsa == true) {
                    alihuadsa = 1;
                } else {
                    alihuadsa = 0;
                }
                var dateLoggly = new Date;
                var yearString = dateLoggly.getUTCFullYear() + "";
                var monthString = dateLoggly.getUTCMonth() + 1 + "";
                if (monthString.length == 1) {
                    monthString = "0" + monthString;
                }
                var dayString = dateLoggly.getUTCDate() + "";
                if (dayString.length == 1) {
                    dayString = "0" + dayString;
                }
                var hourString = dateLoggly.getUTCHours() + "";
                if (hourString.length == 1) {
                    hourString = "0" + hourString;
                }
                var minuteString = dateLoggly.getUTCMinutes() + "";
                if (minuteString.length == 1) {
                    minuteString = "0" + minuteString;
                }
                var secondString = dateLoggly.getUTCSeconds() + "";
                if (secondString.length == 1) {
                    secondString = "0" + secondString;
                }
                var dateLogglyString = yearString + "-" + monthString + "-" + dayString + " " + hourString + ":" + minuteString + ":" + secondString;
                const measurementId = getFixedMeasurementId();
                var data = {};
                data.typeinter = eventClick;
                data.button = md5Event;
                data.version = sayswho();
                data.tp = thisip;
                if (hasCustomization("user_behavior")) {
                    let userGaSessionData = getUserSessionData(measurementId);
                    data.session_time = userGaSessionData ? userGaSessionData.session_time : -1;
                    data.vx_session_pages_qt = userGaSessionData ? userGaSessionData.vx_session_pages_qt : -1;
                    data.has_items_in_cart = hasItemsInDataLayerCart();
                }
                data.advertiser_id = window.advInfo.id;
                data.pageview = window.location.href.replace("#", "");
                data.data = dateLogglyString;
                data.action = "mediamanager";
                data.usubidaimpression = totalSes;
                data.kopidcooked = kopidCooked;
                data.usubidainter = adinter;
                data.kopidpip = kopid;
                data.sgotasdkaoq = sgotasdkaoq;
                data.creative = creativekaoq;
                data.other = isFromOther();
                data.otherv2 = fromOtherv2;
                data.recent_conv = vxAttrStatus.recentConv;
                data.ga = alihuadsa;
                data.ds_hit_sent = analyticsAttributionHitsSentOnPage.ds;
                data.tf_ds_hit_sent = analyticsAttributionHitsSentOnPage.tfDs;
                data.ga_not_sent_reason = vxAttrStatus.gaNotSent;
                data.new_user_not_reset_reason = noNewUserResetReason;
                data.reset_hit_collect_host = resetHitCollectHost;
                data.ga_hit_sent = analyticsAttributionHitsSentOnPage.ga ? 1 : 0;
                data.cookie_id = cookie_id;
                data.uuid = VxFingerprint.generateUuid();
                data.mobile = ismobile;
                data.ignore = igvxtst;
                data.creative = creativekaoq;
                if (hasCustomization("analytics_observer") && observedRequests) {
                    data.analytics_requests = observedRequests;
                }
                var protocol = window.location.protocol.replace(":", "");
                var token = "27cf9a30-eb89-41a7-ba82-3280d33fb2cf";
                var urlLoggly = protocol + "://logs-01.loggly.com/inputs/" + token + "/tag/" + protocol + "/";
                var httploggly = new XMLHttpRequest;
                httploggly.open("POST", urlLoggly, true);
                httploggly.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                httploggly.send(JSON.stringify(data));
                httploggly.onreadystatechange = function() {
                    if (httploggly.readyState == 4) {
                        if (httploggly.status != 200) {
                            sdloggly(false);
                        } else {
                            var response = JSON.parse(httploggly.responseText);
                            if (response == null || typeof response.response == "undefined" || response.response != "ok") {
                                sdloggly(false);
                            }
                        }
                    }
                };
            }
            function getOperatingSystem() {
                let userAgent = navigator.userAgent;
                let platform = navigator.platform;
                let macosPlatforms = [ "Macintosh", "MacIntel", "MacPPC", "Mac68K" ];
                let windowsPlatforms = [ "Win32", "Win64", "Windows", "WinCE" ];
                let iosPlatforms = [ "iPhone", "iPad", "iPod" ];
                let os = null;
                if (macosPlatforms.indexOf(platform) !== -1) {
                    os = "Mac OS";
                } else if (iosPlatforms.indexOf(platform) !== -1) {
                    os = "iOS";
                } else if (windowsPlatforms.indexOf(platform) !== -1) {
                    os = "Windows";
                } else if (/Android/.test(userAgent)) {
                    os = "Android";
                } else if (!os && /Linux/.test(platform)) {
                    os = "Linux";
                } else {
                    os = "Unidentified";
                }
                return os;
            }
            async function sdloggly(force) {
                var ignoreThis = false;
                for (it = 0; it < domainsToIgnore.length; it++) {
                    if (window.location.href.replace("#", "").indexOf(domainsToIgnore[it]) > -1) {
                        ignoreThis = true;
                    }
                }
                if (ignoreThis) {
                    return;
                }
                if (hasCustomization("ga_hit") && !getFixedMeasurementId()) {
                    VxAsyncWrapper.setTimeout(() => sdloggly(force), 200);
                    return;
                }
                let observedRequests = "";
                if (hasCustomization("analytics_observer") && typeof observerController === "object" && observerController.observedDomains && observerController.observedRequests) {
                    const isAllDomainsReady = Object.values(observerController.observedDomains).every(status => status === true);
                    if (!isAllDomainsReady) {
                        VxAsyncWrapper.setTimeout(() => sdloggly(force), 200);
                        return;
                    }
                    observedRequests = Object.values(observerController.observedRequests).flat().join(",") || "";
                }
                totalLogglys++;
                if (totalLogglys >= 10) {
                    return;
                }
                logglyloadvoxus = true;
                if (typeof force == "undefined") {
                    force = false;
                }
                alihuadsa = alihuadsanw;
                if (alihuadsa == true) {
                    alihuadsa = 1;
                } else {
                    alihuadsa = 0;
                }
                if (alihuadsa == 0) {
                    if (CookiesVx.get(voxus_key + "_ignore_full_ugi") == "true") {
                        alihuadsa = 1;
                    }
                }
                var dateLoggly = new Date;
                var yearString = dateLoggly.getUTCFullYear() + "";
                var monthString = dateLoggly.getUTCMonth() + 1 + "";
                if (monthString.length == 1) {
                    monthString = "0" + monthString;
                }
                var dayString = dateLoggly.getUTCDate() + "";
                if (dayString.length == 1) {
                    dayString = "0" + dayString;
                }
                var hourString = dateLoggly.getUTCHours() + "";
                if (hourString.length == 1) {
                    hourString = "0" + hourString;
                }
                var minuteString = dateLoggly.getUTCMinutes() + "";
                if (minuteString.length == 1) {
                    minuteString = "0" + minuteString;
                }
                var secondString = dateLoggly.getUTCSeconds() + "";
                if (secondString.length == 1) {
                    secondString = "0" + secondString;
                }
                var dateLogglyString = yearString + "-" + monthString + "-" + dayString + " " + hourString + ":" + minuteString + ":" + secondString;
                var typeWindow = 3;
                if (window.opener) {
                    typeWindow = 1;
                } else if (window.top !== window.self) {
                    typeWindow = 2;
                } else {
                    typeWindow = 3;
                }
                var widthAnalysis = 800;
                var heightAnalysis = 800;
                if (typeof document != "undefined" && typeof document.documentElement != "undefined") {
                    widthAnalysis = document.documentElement.clientWidth;
                    heightAnalysis = document.documentElement.clientHeight;
                }
                const measurementId = getFixedMeasurementId();
                var data = {};
                data.os = getOperatingSystem();
                if (typeof isNewUser != "undefined") {
                    data.new_user = isNewUser();
                }
                if (hasCustomization("custom_conv_id") && typeof getConvIdForAdvertiser != "undefined") {
                    const conv_id = getConvIdForAdvertiser();
                    if (conv_id) {
                        data.conv_id = conv_id;
                    }
                }
                const voxus_last_impression_timestamp = VxImpHandler.getCookieLastAdSeenInformation();
                if (voxus_last_impression_timestamp?.time) {
                    data.voxus_last_impression_timestamp = voxus_last_impression_timestamp.time;
                    data.voxus_user_return_timestamp = Math.floor(Date.now() / 1e3);
                    data.voxus_last_entry_before_impression = CookiesVx.get("voxus_last_entry_before_impression");
                } else {
                    const thirtyDays = 60 * 60 * 24 * 30;
                    CookiesVx.set("voxus_last_entry_before_impression", Math.floor(Date.now() / 1e3), {
                        expires: thirtyDays
                    });
                }
                data.index_nck_version = indexNckVersion;
                const _vxVerInfo = VxTagVersion.getInfo();
                data.tag_version = _vxVerInfo.buildVersion;
                data.tag_semversion = _vxVerInfo.displayVersion;
                data.assigned = CookiesVx.get(voxus_key + "_assigned") == "true";
                const utms = UtmParamsHandler.getUtmParametersToSend();
                data.source = utms.source;
                data.medium = utms.medium;
                data.campaign = utms.name;
                data.creative_id = utms.id;
                data.width = widthAnalysis;
                data.height = heightAnalysis;
                data.tp = thisip;
                if (hasCustomization("user_behavior")) {
                    let userGaSessionData = getUserSessionData(measurementId);
                    data.session_time = userGaSessionData ? userGaSessionData.session_time : -1;
                    data.vx_session_pages_qt = userGaSessionData ? userGaSessionData.vx_session_pages_qt : -1;
                    data.has_items_in_cart = hasItemsInDataLayerCart();
                }
                if (hasCustomization("custom_tracking") && typeof trackedElements !== "undefined") {
                    data.custom_tracking = trackedElements;
                }
                data.advertiser_id = window.advInfo.id;
                data.pageview = window.location.href.replace("#", "");
                data.data = dateLogglyString;
                data.action = "mediamanager";
                data.usubidainter = adinter;
                data.kopidpip = kopid;
                data.category = CookiesVx.get(voxus_key + "_seg_kaoq");
                data.sgotasdkaoq = sgotasdkaoq;
                data.creative = creativekaoq;
                data.other = isFromOther();
                data.otherv2 = fromOtherv2;
                data.recent_conv = vxAttrStatus.recentConv;
                data.ga = alihuadsa;
                data.ds_hit_sent = analyticsAttributionHitsSentOnPage.ds;
                data.tf_ds_hit_sent = analyticsAttributionHitsSentOnPage.tfDs;
                data.ga_not_sent_reason = vxAttrStatus.gaNotSent;
                data.new_user_not_reset_reason = noNewUserResetReason;
                data.reset_hit_collect_host = resetHitCollectHost;
                data.ga_hit_sent = analyticsAttributionHitsSentOnPage.ga ? 1 : 0;
                data.cookie_id = cookie_id;
                data.uuid = VxFingerprint.generateUuid();
                if (hasCustomization("2753_custom_track")) {
                    data.wpp_triggered = wppTriggered;
                    data.appointment_triggered = appointmentTriggered;
                }
                const session = getSessionId(measurementId);
                data.mobile = ismobile;
                data.creative = creativekaoq;
                data.dimension = false;
                data.session = session;
                data.user_id = getUserId(measurementId);
                data.sessionChanged = sessionChanged(session);
                data.sessionReseted = CookiesVx.get(voxus_key + "_session_reseted");
                data.actv_paid_media = await VxOtherV2Attr.getActivePaidMedia();
                if (VxResetLookupWindow.hasLookupCustomization()) {
                    data.lookup_w_rst = VxResetLookupWindow.getResetCount();
                }
                if (hasCustomization("analytics_observer") && observedRequests) {
                    data.analytics_requests = observedRequests;
                }
                if (typeof getPageIdentifier === "function") {
                    data.page_identifier = getPageIdentifier();
                }
                if (hasCustomization("register_first_page")) {
                    data.first_page = CookiesVx.get(voxus_key + "_registered_first_page") != "true";
                }
                if (CookiesVx.get(voxus_key + "_dimension") == "true") {
                    data.dimension = true;
                }
                if (typeof CookiesVx.get(voxus_key + "_lkaoq") != "undefined" && CookiesVx.get(voxus_key + "_lkaoq") != "") {
                    data.lkaoq = CookiesVx.get(voxus_key + "_lkaoq");
                }
                if (CookiesVx.get(voxus_key + "_lrf") != "") {
                    data.lref = CookiesVx.get(voxus_key + "_lrf");
                }
                if (typeof CookiesVx.get(voxus_key + "_cp_ent") != "undefined") {
                    data.campaign_id = CookiesVx.get(voxus_key + "_cp_ent");
                }
                var protocol = window.location.protocol.replace(":", "");
                var token = "27cf9a30-eb89-41a7-ba82-3280d33fb2cf";
                var urlLoggly = protocol + "://logs-01.loggly.com/inputs/" + token + "/tag/" + protocol + "/";
                var httploggly = new XMLHttpRequest;
                httploggly.open("POST", urlLoggly, true);
                httploggly.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                httploggly.send(JSON.stringify(data));
                lastDataLoggly = data;
                var iNew = document.createElement("img");
                iNew.id = "inserted_log_27c";
                iNew.style = "border-style:none;visibility:hidden;position:absolute;z-index:-1;display:none";
                iNew.width = iNew.height = 1;
                document.body.appendChild(iNew);
                httploggly.onreadystatechange = function() {
                    if (httploggly.readyState != 4) {
                        return;
                    }
                    if (httploggly.status != 200) {
                        sdloggly(false);
                        return;
                    }
                    if (hasCustomization("register_first_page")) {
                        CookiesVx.set(voxus_key + "_registered_first_page", "true", {
                            domain: window.location.hostname.replace("www", ""),
                            expires: VxDate.addDays(new Date, 1).toGMTString()
                        });
                    }
                    var response = JSON.parse(httploggly.responseText);
                    if (response == null || typeof response.response == "undefined" || response.response != "ok") {
                        sdloggly(false);
                    }
                };
            }
            VxAsyncWrapper.setTimeout(function() {
                logglyOnloadVoxusDsp = VxAsyncWrapper.setInterval(function() {
                    if (document.body == null) {
                        return;
                    }
                    if (logglyloadvoxus) {
                        clearInterval(logglyOnloadVoxusDsp);
                        return;
                    }
                    if (document.getElementById("lgvx") != null) {
                        clearInterval(logglyOnloadVoxusDsp);
                        return;
                    }
                    if (location.hostname.indexOf("vtexcommercestable.com.br") > -1) {
                        clearInterval(logglyOnloadVoxusDsp);
                        return;
                    }
                    sdloggly();
                    clearInterval(logglyOnloadVoxusDsp);
                }, 3e3);
            }, 3e3);
            var inputs, index;
            inputs = document.getElementsByTagName("input");
            function sdconv() {
                sgarqRun = true;
                var data = new FormData;
                data.append("client", advInfo.id);
                data.append("campaign", CookiesVx.get(voxus_key + "_campaign_"));
                var typeConversion = 0;
                if (kopid == true && adinter == "true") {
                    typeConversion = 1;
                } else if (kopid == true) {
                    typeConversion = 2;
                } else if (adinter == true) {
                    typeConversion = 1;
                }
                CookiesVx.set(voxus_key + "_converted", "true", {
                    expires: 60 * 60
                });
                CookiesVx.set(voxus_key + "_converted_gl", "true", {
                    expires: 60 * 60
                });
                CookiesVx.expire(voxus_key + "_adinter_pip");
                CookiesVx.expire(voxus_key + "_kopid_pip");
                var urlTrackerVx = VOXUS_API_BASE_URL + "/track.png?adv_id=" + advInfo.id + "&cv=true";
                var httptrk = new XMLHttpRequest;
                httptrk.open("GET", urlTrackerVx, true);
                httptrk.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                httptrk.send();
                VxAdPlacementDomainTracking.sendHit(true);
                CookiesVx.set(voxus_key + "_usubida_tracking", true, {
                    expires: 60 * 60 * 24 * 7
                });
            }
            function getConvIdForAdvertiser() {
                if (VxVtexAttr.getConversionId()) {
                    return VxVtexAttr.getConversionId();
                }
                const msIds = getMeasurementIds();
                if (!msIds || msIds.length === 0) {
                    return;
                }
                return getDatalayerTransactionId(findDataLayer(msIds.at(0)));
            }
            function sdinterv() {}
            function __voxusTrackConversion() {
                if (CookiesVx.get(voxus_key + "_converted") != "true" && (kopid == "true" || adinter == "true")) {
                    if (converted == true) {
                        return;
                    }
                    sgarqRun = true;
                    sgarq();
                    if (CookiesVx.get(voxus_key + "_campaign_") == null) {
                        for (var i = 0; i < sgotasd.length; i++) {
                            CookiesVx.set(voxus_key + "_campaign_", sgotasd[i][1], {
                                expires: Infinity
                            });
                        }
                    }
                    var data = new FormData;
                    data.append("client", advInfo.id);
                    data.append("campaign", CookiesVx.get(voxus_key + "_campaign_"));
                    var typeConversion = 1;
                    var xmlhttpc = new XMLHttpRequest;
                    xmlhttpc.open("POST", "https://analytics.voxus.tv/usubida/", true);
                    xmlhttpc.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                    xmlhttpc.send("ret=" + retroative + "&type=" + typeConversion + "&client=" + advInfo.id + "&campaign=" + CookiesVx.get(voxus_key + "_campaign_"));
                    CookiesVx.set(voxus_key + "_converted", "true", {
                        expires: 60 * 60
                    });
                    CookiesVx.set(voxus_key + "_converted_gl", "true", {
                        expires: 7 * 24 * 60 * 60
                    });
                    converted = true;
                }
                sdloggly();
            }
            if (hasCustomization("custom_conv_id")) {
                VxDataLayerObserver.observeGA4Event("purchase", {
                    onMatch: () => sdloggly(true)
                });
            }
            if (hasCustomization("track_conv_url")) {
                listenUrlChangesUntil(usubidaPages[0], () => sdloggly(true));
            }
            if (hasCustomization("vtex_clean")) {
                VxVtexAttr.onVtexCheckout(async () => {
                    if (await VxOtherV2Attr.isVxLastPaidMedia()) {
                        return;
                    }
                    VxVtexAttr.cleanCheckout("vtex_cleanv2");
                });
            }
            reloadPixels();
        }
        VxSecondaryDimensionChecker.processAll();
        VxMobileImpressionChecker.check();
        function reloadPixels() {
            VxPixelReloader.reload();
        }
        targetingOnload = VxAsyncWrapper.setInterval(function() {
            if (document.body == null) {
                return;
            }
            clearInterval(targetingOnload);
            VxCrossDomainBridge.init();
        }, 1e3);
        if (typeof intervalDataExcludeValidated == "undefined") {
            intervalDataExcludeValidated = VxAsyncWrapper.setInterval(function() {
                if (dataExcludeValidated == false) return;
                dataExcludeValidated = true;
                clearInterval(intervalDataExcludeValidated);
                if (typeof CookiesVx.get(voxus_key + "_dataexclude") == "undefined") {
                    __voxMainProc();
                }
            }, 100);
        }
    } catch (error) {
        if (window.vxLogger) {
            window.vxLogger.report(error?.message || String(error), {
                stack: error?.stack || ""
            });
            window.vxLogger.trace(error);
        }
    }
}